import { defaultI18nConfig, Logger, EvtEmitter, CODEC, DrmKeySystems, commonTool, KernelFactory, KERNEL_NAME, videoTool, VIDEO_STATE, urlTool, lsTool, PLAY_MODE, PLAY_EVENT, uaTool, VERSION, jsonTool, SimpleDefer, netTool, getLogCache, clearLogCache, END_STATE, t, i18nConfig, domTool, requireModule, cookieTool, getEventEmitterBinder, TpCoreError, preloadEvtBus, PRELOAD_EVENT, performanceCostDecoratorCreator, TaskLoop, LoopMode, SET_LEVEL_MODE, KernelProxy, logMethodCallDecoratorCreator, getEventTargetBinder, ResizeObserver, destroyProtectDecorator, ReferenceReport, kernelEvtBus, PRELOAD_TYPE, VIDEO_CODEC, CONTAINER_FORMAT, AUDIO_CODEC, mountGlobal } from '@tencent/thumbplayer-core';
export { AUDIO_CODEC, CONTAINER_FORMAT, END_STATE, EvtEmitter, KERNEL_NAME, PLAY_EVENT, PLAY_MODE, PRELOAD_TYPE, VIDEO_CODEC, VIDEO_STATE, i18nConfig, kernelEvtBus, preloadEvtBus, t } from '@tencent/thumbplayer-core';
import { __extends, __spreadArray, __assign, __awaiter, __generator, __decorate, __metadata, __rest } from 'tslib';
import { sha256 } from 'js-sha256';

var h5playerI18nConfig = {
    // Getinfo 错误
    ERROR_GETINFO_PLUGIN_MISSING: '没有找到获取视频信息插件',
    ERROR_GETINFO_INNER: '获取视频信息内部错误',
    /** 网络错误 */
    ERROR_GETINFO_NET: '无法获取视频信息',
    /** 网络超时 */
    ERROR_GETINFO_TIMEOUT: '获取视频信息超时',
    /** 解析错误 */
    ERROR_GETINFO_PARSE: '视频信息无法解析',
    /** 后台下发的错误码 */
    ERROR_GETINFO_CODE: '播放后台返回错误',
    // plugins/base.ts
    ERROR_UNOFFICIAL_PLUGIN_NEEDS_URL: '您所传入的插件不是官方插件，必须提供 url',
    // PlayTimeLimiter: 传入保护点配置时，校验失败的提示
    ERROR_PLAY_LIMIT_EMPTY_CONFIG: '配置不能为空',
    ERROR_PLAY_LIMIT_POINTS_BOTH_EMPTY: 'startPoint / endPoint 配置不能同时为空',
    ERROR_PLAY_LIMIT_START_TIME_BELOW_ZERO: 'startPoint.value 值不能小于 0',
    ERROR_PLAY_LIMIT_END_TIME_BELOW_START_TIME: 'endPoint.value 值不能小于 startPoint.value',
    ERROR_URL_INVALID: '地址不合法',
    // 自动播放相关
    ERROR_AUTOPLAY_FAILED_BROWSER: '浏览器不允许自动播放',
    ERROR_AUTOPLAY_FAILED_CONFIG: '播放器配置不允许进行静音自动播放重试',
};
defaultI18nConfig.h5player = h5playerI18nConfig;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle;

/** 用局部变量保存广告插件实例 */
var adPluginMap = {};
function setAdPlugin(instanceId, plugin) {
    adPluginMap[instanceId] = plugin;
}
function getAdPlugin(instanceId) {
    return adPluginMap[instanceId];
}
/**
 * 从广告插件获取最终的广告请求参数
 * @param instanceId 播放器实例id
 * @param customParams 用户自定参数
 * @returns 最终的广告请求参数
 */
function getAdReqParams(instanceId, customParams) {
    var adPlugin = getAdPlugin(instanceId);
    if (!adPlugin || typeof adPlugin.getAdParams !== 'function' || !(customParams === null || customParams === void 0 ? void 0 : customParams.adType) || !(customParams === null || customParams === void 0 ? void 0 : customParams.vid)) {
        // 没有vid, adType返回空
        return {};
    }
    return adPlugin.getAdParams(customParams);
}

/** 广告插件名 */
var AdPluginName = '__thumbplayer-ad';
/** 广告类型 */
var AD_TYPE;
(function (AD_TYPE) {
    AD_TYPE["PRE"] = "preAd";
    AD_TYPE["ZT"] = "ZT";
    AD_TYPE["POST"] = "postAd";
})(AD_TYPE || (AD_TYPE = {}));
/** 是否前后贴广告类型 */
function isPreOrPostAd(data) {
    return [AD_TYPE.PRE, AD_TYPE.POST].indexOf(data.adType) !== -1;
}

var H5_EXT_EVENT;
(function (H5_EXT_EVENT) {
    /** 广告倒计时 */
    H5_EXT_EVENT["AD_COUNTDOWN_CHANGE"] = "AD_COUNTDOWN_CHANGE";
    /** 是否显示loading动画 */
    H5_EXT_EVENT["SET_LOADING"] = "SET_LOADING";
    /** 合并接口开始请求 */
    H5_EXT_EVENT["PROXY_HTTP_START"] = "PROXY_HTTP_START";
    /** 合并接口结束请求 */
    H5_EXT_EVENT["PROXY_HTTP_END"] = "PROXY_HTTP_END";
    /** getinfo请求开始 */
    H5_EXT_EVENT["GETINFO_START"] = "GETINFO_START";
    /** getinfo接口返回 */
    H5_EXT_EVENT["GETINFO_OVER"] = "GETINFO_OVER";
    /** 预加载请求结束 */
    H5_EXT_EVENT["PRELOAD_GETINFO_OVER"] = "PRELOAD_GETINFO_OVER";
    /** 切换播放id */
    H5_EXT_EVENT["VID_CHANGE"] = "VID_CHANGE";
    /** 播放器销毁 */
    H5_EXT_EVENT["DESTROY"] = "DESTROY";
    /** 数据中心字段更新 */
    H5_EXT_EVENT["DATASET_UPDATE"] = "data-set:update";
    /** 数据中心state-map字段更新 */
    H5_EXT_EVENT["DATASET_STATE_UPDATE"] = "data-set:stateUpdate";
    /** 播放级别的重试（腾讯视频点播直播的重试，会重新请求后台） */
    H5_EXT_EVENT["RETRY_PLAY"] = "retryPlay";
    /** 播放级别的重试成功（重新恢复播放） */
    H5_EXT_EVENT["RETRY_PLAY_SUCC"] = "retryPlaySucc";
    /** 降级编码播放 */
    H5_EXT_EVENT["DEGRADE_CODEC_PLAY"] = "degradeCodecPlay";
    /** 因为浏览器限制而自动静音播放 */
    H5_EXT_EVENT["AUTOPLAY_IN_MUTED"] = "autoplayInMuted";
    /** 自动播放失败，可能是浏览器策略导致完全无法自动播放，或是 config 配置不允许尝试静音自动播放 */
    H5_EXT_EVENT["AUTOPLAY_FAILED"] = "autoplayFailed";
    /** 节点开始预加载 */
    H5_EXT_EVENT["FLOW_NODE_PRELOAD"] = "FLOW_NODE_PRELOAD";
    /** 进入节点流程（可能还未开始播放，例如预加载了但是还在loading过程中） */
    H5_EXT_EVENT["FLOW_NODE_START"] = "FLOW_NODE_START";
    /** 当前节点结束/出错后，进入下一节点 */
    H5_EXT_EVENT["FLOW_NODE_END"] = "FLOW_NODE_END";
    /** 中断当前流程 */
    H5_EXT_EVENT["FLOW_NODE_ABORT"] = "FLOW_NODE_ABORT";
    /** 播放数据统计 */
    H5_EXT_EVENT["STATS_CHANGE"] = "STATS_CHANGE";
    /** 广告或者正片首次起播 */
    H5_EXT_EVENT["SESSION_FIRST_PLAYING"] = "SESSION_FIRST_PLAYING";
})(H5_EXT_EVENT || (H5_EXT_EVENT = {}));

var ErrorCode;
(function (ErrorCode) {
    ErrorCode["SUC"] = "0";
    /** 未知错误 */
    ErrorCode["UNKNOWN"] = "70040000";
    /** 广告结束出错的默认错误码 */
    ErrorCode["AD_END_DEFAULT_FAIL"] = "70040002";
    /** 广告信息请求出错的默认错误码 */
    ErrorCode["AD_REQ_INFO_DEFAULT_FAIL"] = "70040003";
    /** 没有getinfo插件 */
    ErrorCode["GETINFO_PLUGIN_MISSING"] = "70040001";
    // getinfo过程中的错误码
    ErrorCode["GETINFO_NET"] = "70014001";
    ErrorCode["GETINFO_TIMEOUT"] = "70014003";
    ErrorCode["GETINFO_PARSE"] = "70014004";
    ErrorCode["GETINFO_INNER"] = "70014005";
    /** 直出数据不可用 */
    ErrorCode["SRV_DATA_INVAILD"] = "70014006";
    /** 腾讯视频点播服务返回错误时的错误码前缀 */
    ErrorCode["GETINFO_SERVER_CODE_PREFIX"] = "70013";
    /** 腾讯视频直播服务返回错误时的错误码前缀 */
    ErrorCode["GETINFO_LIVE_SERVER_CODE_PREFIX"] = "70023";
    /** 腾讯视频融合直播服务返回错误时的错误码前缀 */
    ErrorCode["GETINFO_UNIFIED_LIVE_SERVER_CODE_PREFIX"] = "70033";
    /** 1080P未付费 */
    ErrorCode["UNPAIED_1080P"] = "70013091.0";
})(ErrorCode || (ErrorCode = {}));
/**
 * @deprecated 已迁移至 i18nConfig，请使用 i18nConfig.h5player.ERROR_xxx
 */
var ErrorMsg;
(function (ErrorMsg) {
    ErrorMsg["GETINFO_PLUGIN_MISSING"] = "\u6CA1\u6709\u627E\u5230\u83B7\u53D6\u89C6\u9891\u4FE1\u606F\u63D2\u4EF6";
    ErrorMsg["GETINFO_INNER"] = "\u83B7\u53D6\u89C6\u9891\u4FE1\u606F\u5185\u90E8\u9519\u8BEF";
    /** 网络错误 */
    ErrorMsg["GETINFO_NET"] = "\u65E0\u6CD5\u83B7\u53D6\u89C6\u9891\u4FE1\u606F";
    /** 网络超时 */
    ErrorMsg["GETINFO_TIMEOUT"] = "\u83B7\u53D6\u89C6\u9891\u4FE1\u606F\u8D85\u65F6";
    /** 解析错误 */
    ErrorMsg["GETINFO_PARSE"] = "\u89C6\u9891\u4FE1\u606F\u65E0\u6CD5\u89E3\u6790";
    /** 后台下发的错误码 */
    ErrorMsg["GETINFO_CODE"] = "\u64AD\u653E\u540E\u53F0\u8FD4\u56DE\u9519\u8BEF";
})(ErrorMsg || (ErrorMsg = {}));

/**
 * 标准播放流程事件
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var H5_PLAY_EVENT;
(function (H5_PLAY_EVENT) {
    /** 单次播放会话开始 在load/play时开始 */
    H5_PLAY_EVENT["PLAY_SESSION_START"] = "PLAY_SESSION_START";
    // 广告事件（相对于整个广告生命周期，不区分分片）
    /** 请求广告信息开始 */
    H5_PLAY_EVENT["AD_REQ_INFO_START"] = "AD_REQ_INFO_START";
    /** 广告信息返回成功/失败 */
    H5_PLAY_EVENT["AD_REQ_INFO_END"] = "AD_REQ_INFO_END";
    /** 请求广告素材开始 */
    H5_PLAY_EVENT["AD_REQ_ASSETS_START"] = "AD_REQ_ASSETS_START";
    /** 广告自动播放被拦截 */
    H5_PLAY_EVENT["AD_AUTOPLAY_BLOCKED"] = "AD_AUTOPLAY_BLOCKED";
    /** 广告开始播放 */
    H5_PLAY_EVENT["AD_PLAYING"] = "AD_PLAYING";
    /** 广告音量变化 */
    H5_PLAY_EVENT["AD_VOLUME_CHANGE"] = "AD_VOLUME_CHANGE";
    /** 广告素材加载完成 */
    H5_PLAY_EVENT["AD_ASSETS_LOADED"] = "AD_ASSETS_LOADED";
    /** 广告播放暂停 */
    H5_PLAY_EVENT["AD_PAUSE"] = "AD_PAUSE";
    /** 广告恢复播放 */
    H5_PLAY_EVENT["AD_RESUME"] = "AD_RESUME";
    /** 广告播放完成/失败	 */
    H5_PLAY_EVENT["AD_END"] = "AD_END";
    H5_PLAY_EVENT["AD_TIME_UPDATE"] = "AD_TIME_UPDATE";
    /** 请求正片信息开始 */
    H5_PLAY_EVENT["VIDEO_REQ_INFO_START"] = "VIDEO_REQ_INFO_START";
    /** 请求正片信息结束，成功/失败 */
    H5_PLAY_EVENT["VIDEO_REQ_INFO_END"] = "VIDEO_REQ_INFO_END";
    /** 开始加载正片 */
    H5_PLAY_EVENT["VIDEO_LOAD_START"] = "VIDEO_LOAD_START";
    /** 正片数据加载中 */
    H5_PLAY_EVENT["VIDEO_LOAD_PROGRESS"] = "VIDEO_LOAD_PROGRESS";
    /** 正片时长变化 */
    H5_PLAY_EVENT["VIDEO_DURATION_CHANGE"] = "VIDEO_DURATION_CHANGE";
    /** 正片信息变化 */
    H5_PLAY_EVENT["VIDEO_METADATA_CHANGE"] = "VIDEO_METADATA_CHANGE";
    /** 正片播放进度变化 */
    H5_PLAY_EVENT["VIDEO_TIMEUPDATE"] = "VIDEO_TIMEUPDATE";
    /** 正片音量变化 */
    H5_PLAY_EVENT["VIDEO_VOLUME_CHANGE"] = "VIDEO_VOLUME_CHANGE";
    /** 正片倍速变化 */
    H5_PLAY_EVENT["VIDEO_RATE_CHANGE"] = "VIDEO_RATE_CHANGE";
    /** 正片可以播放 */
    H5_PLAY_EVENT["VIDEO_CANPLAY"] = "VIDEO_CANPLAY";
    /** 正片开始播放 */
    H5_PLAY_EVENT["VIDEO_PLAYING"] = "VIDEO_PLAYING";
    /** 正片自动播放被拦截 */
    H5_PLAY_EVENT["VIDEO_AUTOPLAY_BLOCKED"] = "VIDEO_AUTOPLAY_BLOCKED";
    /** 正片暂停播放 */
    H5_PLAY_EVENT["VIDEO_PAUSE"] = "VIDEO_PAUSE";
    /** 正片缓冲中 */
    H5_PLAY_EVENT["VIDEO_BUFFERING"] = "VIDEO_BUFFERING";
    /** 正片跳转中 */
    H5_PLAY_EVENT["VIDEO_SEEKING"] = "VIDEO_SEEKING";
    /** 正片跳转结束 */
    H5_PLAY_EVENT["VIDEO_SEEKED"] = "VIDEO_SEEKED";
    /** 正片切换清晰度开始 */
    H5_PLAY_EVENT["VIDEO_SETLEVEL_START"] = "VIDEO_SETLEVEL_START";
    /** 正片切换清晰度结束 */
    H5_PLAY_EVENT["VIDEO_SETLEVEL_END"] = "VIDEO_SETLEVEL_END";
    /** 视频分辨率发生变化 */
    H5_PLAY_EVENT["VIDEO_RESIZE"] = "VIDEO_RESIZE";
    /** 正片播放结束 */
    H5_PLAY_EVENT["VIDEO_END"] = "VIDEO_END";
    /** 单次播放会话结束 */
    H5_PLAY_EVENT["PLAY_SESSION_END"] = "PLAY_SESSION_END";
})(H5_PLAY_EVENT || (H5_PLAY_EVENT = {}));

/** core: 插件map局部变量，对外提供存取方法 */
var pluginStorage = {};
var pluginExists = function (name) { return Object.prototype.hasOwnProperty.call(pluginStorage, name); };
var getPlugin = function (name) { return (pluginExists(name) ? pluginStorage[name] : undefined); };
/** 把插件添加到map里 */
function registerPlugin(name, plugin) {
    if (typeof name !== 'string') {
        throw new Error("Illegal plugin name, \"".concat(name, "\", must be a string, was ").concat(typeof name, "."));
    }
    if (typeof plugin !== 'function') {
        throw new Error("Illegal plugin for \"".concat(name, "\", must be a function, was ").concat(typeof plugin, "."));
    }
    if (pluginExists(name)) {
        console.warn("A plugin named \"".concat(name, "\" already exists. You may want to avoid re-registering plugins!"));
        return;
    }
    pluginStorage[name] = plugin;
    return plugin;
}
/** 注销插件 */
function deregisterPlugin(name) {
    if (pluginExists(name))
        delete pluginStorage[name];
}
/** 获取部分插件map */
function getPlugins(names) {
    if (names === void 0) { names = Object.keys(pluginStorage); }
    var result;
    names.forEach(function (name) {
        var plugin = getPlugin(name);
        if (plugin) {
            result = result || {};
            result[name] = plugin;
        }
    });
    return result;
}

/** 基类中定义的钩子都用这个字符串开头 */
var methodPrefix = 'hook';
/** 目前提供的钩子 */
var playHooks = Object.values(H5_PLAY_EVENT);
/**
 * 插件基类，初始化前后在player上提供事件
 */
var Plugin = /** @class */ (function (_super) {
    __extends(Plugin, _super);
    /**
     * @param player H5player实例
     * @param config 插件的配置信息
     * @param extra 其他参数
     */
    function Plugin(player, config, extra) {
        var _newTarget = this.constructor;
        var _this = _super.call(this) || this;
        _this.player = player;
        _this.config = config;
        /** 存放钩子回调函数 */
        _this.hookMap = {};
        if (_newTarget === Plugin) {
            throw new Error('Plugin must be sub-classed; not directly instantiated.');
        }
        _this.logger_ = new Logger(player.config.instanceId, _this.constructor.pluginName);
        var msg = (extra || {}).msg;
        _this.msg = msg;
        _this.registerHook();
        return _this;
    }
    // 日志方法: 注意如果锁了低版本的core，部分方法可能不存在
    Plugin.prototype.log = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = this.logger_).log) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
    };
    Plugin.prototype.warn = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = this.logger_).warn) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
    };
    Plugin.prototype.error = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = this.logger_).error) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
    };
    Plugin.prototype.debug = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = this.logger_).debug) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
    };
    Plugin.prototype.info = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = this.logger_).info) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
    };
    /** 判断播放器是否包含(已注册)某个插件 */
    Plugin.prototype.hasPlugin = function (name) {
        return !!pluginExists(name);
    };
    /** 移除事件，删除播放器上的插件实例 */
    Plugin.prototype.destroy = function () {
        var _a;
        var player = this.player;
        var name = this.name;
        if ((_a = player.plugins) === null || _a === void 0 ? void 0 : _a[name]) {
            delete player.plugins[name];
        }
        this.unRegisterHook();
        this.hookMap = null;
        this.player = null;
        this.removeAllListeners();
    };
    Plugin.prototype.hookPlaySessionStart = function (_param) { };
    // ad hook
    Plugin.prototype.hookAdReqInfoStart = function (_param) { };
    Plugin.prototype.hookAdReqInfoEnd = function (_param) { };
    Plugin.prototype.hookAdReqAssetsStart = function (_param) { };
    Plugin.prototype.hookAdAutoplayBlocked = function (_param) { };
    Plugin.prototype.hookAdPlaying = function (_param) { };
    Plugin.prototype.hookAdVolumeChange = function (_param) { };
    Plugin.prototype.hookAdAssetsLoaded = function (_param) { };
    Plugin.prototype.hookAdPause = function (_param) { };
    Plugin.prototype.hookAdResume = function (_param) { };
    Plugin.prototype.hookAdEnd = function (_param) { };
    Plugin.prototype.hookAdTimeUpdate = function (_param) { };
    // video hook
    Plugin.prototype.hookVideoReqInfoStart = function (_param) { };
    Plugin.prototype.hookVideoReqInfoEnd = function (_param) { };
    Plugin.prototype.hookVideoLoadStart = function (_param) { };
    Plugin.prototype.hookVideoMetadataChange = function (_param) { };
    Plugin.prototype.hookVideoLoadProgress = function (_param) { };
    Plugin.prototype.hookVideoDurationChange = function (_param) { };
    Plugin.prototype.hookVideoTimeupdate = function (_param) { };
    Plugin.prototype.hookVideoVolumeChange = function (_param) { };
    Plugin.prototype.hookVideoResize = function (_param) { };
    Plugin.prototype.hookVideoRateChange = function (_param) { };
    Plugin.prototype.hookVideoCanplay = function (_param) { };
    Plugin.prototype.hookVideoPlaying = function (_param) { };
    Plugin.prototype.hookVideoAutoplayBlocked = function (_param) { };
    Plugin.prototype.hookVideoPause = function (_param) { };
    Plugin.prototype.hookVideoBuffering = function (_param) { };
    Plugin.prototype.hookVideoSeeking = function (_param) { };
    Plugin.prototype.hookVideoSeeked = function (_param) { };
    Plugin.prototype.hookVideoSetlevelStart = function (_param) { };
    Plugin.prototype.hookVideoSetlevelEnd = function (_param) { };
    Plugin.prototype.hookVideoEnd = function (_param) { };
    Plugin.prototype.hookPlaySessionEnd = function (_param) { };
    Plugin.prototype.registerHook = function () {
        var _this = this;
        playHooks.forEach(function (hook) {
            var methodName = getHookMethodName(hook);
            // 这里必须用匿名函数，因为执行基类构造函数时子类属性还没挂载
            _this.hookMap[hook] = function (evtParam) { var _a; return (_a = _this[methodName]) === null || _a === void 0 ? void 0 : _a.call(_this, evtParam.data); };
            _this.player.on(hook, _this.hookMap[hook]);
        });
    };
    Plugin.prototype.unRegisterHook = function () {
        var _this = this;
        playHooks.forEach(function (hook) {
            if (!_this.hookMap[hook])
                return;
            _this.player.off(hook, _this.hookMap[hook]);
        });
    };
    /** 版本号，暂时保留 */
    Plugin.VERSION = '';
    /** 插件名 */
    Plugin.pluginName = '';
    return Plugin;
}(EvtEmitter));
/**
 * 是否是函数插件（非继承Plugin实现）
 */
function isFunctionPlugin(plugin) {
    var p = (typeof plugin === 'string') ? getPlugin(plugin) : plugin;
    return typeof p === 'function' && !Object.prototype.isPrototypeOf.call(Plugin.prototype, p.prototype);
}
function createPluginFactory(name, pluginFunction) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var player = args[0];
    var instance;
    if (isFunctionPlugin(pluginFunction)) {
        // 函数插件,绑定this到player
        instance = pluginFunction.apply(player, args);
    }
    else {
        // 类插件
        var pluginClass = pluginFunction;
        // 动态增加name属性，销毁时用到
        pluginClass.prototype.name = name;
        // eslint-disable-next-line new-cap
        instance = new (pluginClass.bind.apply(pluginClass, __spreadArray([void 0], args, false)))();
    }
    if (instance) {
        // 函数插件可能没有返回 此时不需要挂载plugins
        player.plugins[name] = instance;
    }
    return instance;
}
/** 从事件名转换得到hook方法名 */
function getHookMethodName(hook) {
    // PLAY_SESSION_START->hookPlaySessionStart
    return methodPrefix + hook.toLowerCase().replace(/^[a-z]/, function (v) { return v.toUpperCase(); })
        .replace(/_[a-z]/g, function (v) { return v[1].toUpperCase(); });
}

/**
 * @fileoverview 定义VideoReq插件
 */
function isVideoId(id) {
    return typeof id === 'string' || typeof id === 'number';
}
/**
 * drm类型，这里是getinfo返回的drm类型（点直播是对齐的）
 */
var DRM_TYPE = {
    NONE: 0,
    CHACHA: 3,
    FAIR_PLAY: 4,
    WIDEVINE: 5,
    ChinaDRM: 6,
};
/**
 * drm请求类型，这个为请求getinfo后台的类型
 */
var DRM_VALUE = {
    NONE: 0,
    CHACHA: 8,
    FAIR_PLAY: 16,
    WIDEVINE: 32,
};

var DATA_EVENTS;
(function (DATA_EVENTS) {
    /** 数据更新 */
    DATA_EVENTS["UPDATE"] = "data-set:update";
    DATA_EVENTS["STATE_UPDATE"] = "data-set:stateUpdate";
})(DATA_EVENTS || (DATA_EVENTS = {}));
var DATA_STATE;
(function (DATA_STATE) {
    DATA_STATE["INIT"] = "PLAYER:init";
    DATA_STATE["SESSION_START"] = "PLAYER:session_start";
    DATA_STATE["SESSION_END"] = "PLAYER:session_end";
    DATA_STATE["GET_INFO"] = "PLAYER:getinfo";
    /** CDN重定向请求开始 */
    DATA_STATE["GET_INFO_START"] = "PLAYER:getinfo_start";
    /** CDN重定向请求结束 */
    DATA_STATE["GET_INFO_END"] = "PLAYER:getinfo_end";
    DATA_STATE["SUBTITLE"] = "PLAYER:subtitle";
    /** 字幕加载开始 */
    DATA_STATE["SUBTITLE_START"] = "PLAYER:subtitle_start";
    /** 字幕加载结束 */
    DATA_STATE["SUBTITLE_END"] = "PLAYER:subtitle_end";
    /** 视频文件加载开始 */
    DATA_STATE["LOAD_START"] = "PLAYER:load_start";
    /** 视频文件加载结束 */
    DATA_STATE["LOAD_END"] = "PLAYER:load_end";
    DATA_STATE["LOAD"] = "PLAYER:load";
    DATA_STATE["BUFFER"] = "PLAYER:buffer";
    /** 二次缓冲开始 */
    DATA_STATE["BUFFER_START"] = "PLAYER:buffer_start";
    /** 二次缓冲结束 */
    DATA_STATE["BUFFER_END"] = "PLAYER:buffer_end";
    DATA_STATE["SEEK"] = "PLAYER:seek";
    /** seek事件开始 */
    DATA_STATE["SEEK_START"] = "PLAYER:seek_start";
    /** seek事件结束 */
    DATA_STATE["SEEK_END"] = "PLAYER:seek_end";
    /** 用户拖拽开始 */
    DATA_STATE["USER_SEEK_START"] = "PLAYER:user_seek_start";
    /** 用户拖拽结束 */
    DATA_STATE["USER_SEEK_END"] = "PLAYER:user_seek_end";
    /** 视频播放结束（code=0） */
    DATA_STATE["END"] = "PLAYER:end";
    /** 视频播放出错（非致命，各类重试逻辑写入） */
    DATA_STATE["ERROR"] = "PLAYER:error";
    /** 视频播放出错 （致命，视频播放结束） */
    DATA_STATE["FATAL_ERROR"] = "PLAYER:fatal_error";
    /** 首次开播 */
    DATA_STATE["FIRST_PLAY"] = "PLAYER:firstPlay";
    /** 播放器进入IDLE状态 */
    DATA_STATE["IDLE"] = "PLAYER:idle";
    /** 播放器进入播放状态 */
    DATA_STATE["PLAYING"] = "PLAYER:playing";
    DATA_STATE["SET_LEVEL"] = "PLAYER:setLevel";
    /** 内核层切换清晰度开始 */
    DATA_STATE["SET_LEVEL_START"] = "PLAYER:setLevel_start";
    /** 内核层切换清晰度结束 */
    DATA_STATE["SET_LEVEL_END"] = "PLAYER:setLevel_end";
    DATA_STATE["PAUSE"] = "PLAYER:pause";
    /** 播放器进入暂停状态 */
    DATA_STATE["PAUSE_START"] = "PLAYER:pause_start";
    /** 播放器结束暂停状态 */
    DATA_STATE["PAUSE_END"] = "PLAYER:pause_end";
    /** 设定倍速 */
    DATA_STATE["SET_RATE"] = "PLAYER:setRate";
    /** 进行后备地址重试 */
    DATA_STATE["RETRY_BACKURL"] = "PLAYER:retryBackUrl";
    /** 进行播放级别重试 */
    DATA_STATE["RETRY_PLAY"] = "PLAYER:retryPlay";
    /** 自动播放被阻止 */
    DATA_STATE["AUTO_PLAY_BLOCKED"] = "PLAYER:autoplayBlocked";
    /** 编码降级 */
    DATA_STATE["CODEC_DEGRADE"] = "PLAYER:codecDegrade";
    /** 用户是否打开了devTools面板 */
    DATA_STATE["DT_OPEN"] = "PLAYER:dtOpen";
})(DATA_STATE || (DATA_STATE = {}));
var LOG_TYPE;
(function (LOG_TYPE) {
    /** 用户操作 */
    LOG_TYPE["USER_ACTION"] = "log:userAction";
    /** 插件行为 */
    LOG_TYPE["PLUGIN_ACTION"] = "log:pluginAction";
    /** 播放内核事件/状态流转 */
    LOG_TYPE["CORE_EVENT"] = "log:coreEvent";
    /** 外部API调用 */
    LOG_TYPE["API_INVOKE"] = "log:apiInvoke";
    /** （默认）未分类 */
    LOG_TYPE["UNCATEGORIZED"] = "log:uncategorized";
})(LOG_TYPE || (LOG_TYPE = {}));
var BUFFER_REASON;
(function (BUFFER_REASON) {
    BUFFER_REASON[BUFFER_REASON["NETWORK_UNSTABLE"] = 1400027] = "NETWORK_UNSTABLE";
    BUFFER_REASON[BUFFER_REASON["PARALLEL_DOWNLOAD"] = 1400028] = "PARALLEL_DOWNLOAD";
    BUFFER_REASON[BUFFER_REASON["CDN_NO_CONNECTION"] = 1400007] = "CDN_NO_CONNECTION";
    BUFFER_REASON[BUFFER_REASON["CDN_URL_SWITCH_SUCCESS"] = 1400029] = "CDN_URL_SWITCH_SUCCESS";
    BUFFER_REASON[BUFFER_REASON["CDN_SLOW"] = 1400030] = "CDN_SLOW";
    BUFFER_REASON[BUFFER_REASON["CDN_URL_SWITCH_UNSUCCESS"] = 1400031] = "CDN_URL_SWITCH_UNSUCCESS";
    BUFFER_REASON[BUFFER_REASON["CDN_TIMEOUT"] = 1400026] = "CDN_TIMEOUT";
    BUFFER_REASON[BUFFER_REASON["CDN_TIMEOUT_URL_SWITCH"] = 1400032] = "CDN_TIMEOUT_URL_SWITCH";
    BUFFER_REASON[BUFFER_REASON["BYTERATE_ERROR"] = 1400033] = "BYTERATE_ERROR";
    BUFFER_REASON[BUFFER_REASON["DOWNLOAD_TOO_SHORT"] = 1400034] = "DOWNLOAD_TOO_SHORT";
    BUFFER_REASON[BUFFER_REASON["P2P_UPLOAD_SLOW"] = 1400035] = "P2P_UPLOAD_SLOW";
    BUFFER_REASON[BUFFER_REASON["DEFAULT"] = 0] = "DEFAULT";
})(BUFFER_REASON || (BUFFER_REASON = {}));
var LOCAL_KEY;
(function (LOCAL_KEY) {
    LOCAL_KEY["GUID"] = "thumbplayer-h5-guid";
    LOCAL_KEY["VOLUME"] = "thumbplayer-h5-volume";
})(LOCAL_KEY || (LOCAL_KEY = {}));
/** 会被默认记录的播放参数 */
var PersistedUserSettings;
(function (PersistedUserSettings) {
    /** 清晰度 */
    PersistedUserSettings["definition"] = "user-setting:definition";
    /** 音量 */
    PersistedUserSettings["volume"] = "user-setting:volume";
    /** 倍速 */
    PersistedUserSettings["playbackRate"] = "user-setting:playbackRate";
    /** 字幕 */
    PersistedUserSettings["subtitle"] = "user-setting:subtitle";
    /** 音轨（hls独有） */
    PersistedUserSettings["audioTrack"] = "user-setting:audioTrack";
})(PersistedUserSettings || (PersistedUserSettings = {}));
/** 数据中心默认收集的公共字段 */
var DEFAULT_KEY = {
    // 登录态相关
    loginid: '',
    loginex: '',
    logintype: '',
    hh_ip: '',
    hc_main_login: '',
    hc_vuserid: '',
    hc_openid: '',
    hc_appid: '',
    hc_access_token: '',
    hc_vuession: '',
    qimeiH38: '',
    vip: 0,
    codec: CODEC.H264,
    freetype: 0,
    // 设备相关
    videoCapability: '',
    mobile: 0,
    guid: '',
    ua: '',
    uip: '',
    device: '',
    resolution: '',
    osver: '',
    // SDK相关
    p2pver: '',
    appVer: '',
    playerver: '',
    playertype: 0,
    playercore: '',
    confid: '',
    // 播放环境相关
    downloadkit: 0,
    online: 1,
    p2p: 0,
    sstrength: 0,
    network: 0,
    /** 测试id */
    testid: 0,
    /** 当前播放内核 */
    curcore: '',
    /** 环境内可用的播放内核 */
    curcorever: '',
    // 下载组件相关
    speed: 0,
    quic: 0,
    // 播放相关
    /** 平台号 */
    platform: '',
    /** 播放流水号，日志的凭证，表示单次播放 */
    flowid: '',
    /** 视频id，点播的vid/直播的cnlid */
    vid: '',
    /** 专辑号coverid */
    cid: '',
    /** 点播视频栏目ID */
    columnId: '',
    /** 直播的节目id */
    livepid: '',
    /** 互动剧id */
    interactid: '',
    /** 当前页面的url */
    url: '',
    /** 当前页面的referrer */
    referrer: '',
    /** 当前页面的顶级url */
    topUrl: '',
    /** 是否启用加密播放 */
    drm: 0,
    /** 实际播放中的drm类型 */
    drmtype: 0,
    // getinfo返回相关
    /** 视频的清晰度编号 */
    fmt: 0,
    /** 重定向服务返回的cdn id */
    cdnid: 0,
    /** 重定向服务返回的视频文件格式 */
    dltype: '',
    /** 视频的码率 */
    rate: 0,
    /** 视频的分片数 */
    clip: 0,
    /** 视频状态码 */
    status: 0,
    /** 视频时长 */
    duration: 0,
    /** 视频是否命中预加载 */
    isPreload: 0,
    /** 视频类型 */
    type: 0,
    cdnuip: '',
    cdnip: '',
    // 其他信息
    ptag: '',
    sdtfrom: '',
    authfrom: '',
    // 播放器插件间共享的状态信息
    currentDefnList: [],
    currentDefn: '',
    currentAudioTrack: 0,
    currentAudioTrackList: [],
    currentSubtitle: '',
    currentSubtitleList: [],
    /** 一个session中的缓冲次数 */
    sessionBufferCount: 0,
    /** 一个session中的备份url重试次数 */
    sessionRetryBackUrlCount: 0,
    /** 一个session中的播放级别重试次数 */
    sessionRetryPlayCount: 0,
    ckeytime: -1,
    ckeydg: 0,
    /** 是否有检测到“坏人”调试过 */
    deved: 0,
    deviceScore: 0,
    /** 屏幕信息 (TEE使用）*/
    TEE_screen: {},
    /** 是否使用的直出数据 */
    isUseSrvData: false,
    /** 直出数据是否非法 */
    isSrvDataInvaild: false,
    /** 广告是否使用demux内核播放 */
    isAdUseDemuxKernel: false,
};
/** 数据中心的key映射 */
var COMMON_DATA_KEY = {};
Object.keys(DEFAULT_KEY).forEach(function (key) { return COMMON_DATA_KEY[key] = key; });

var _a$1;
var FreezeKey = 'thumbplayer-h5-dataset';
var KeySystemToDrmType = (_a$1 = {},
    _a$1[DrmKeySystems.Widevine] = DRM_TYPE.WIDEVINE,
    _a$1[DrmKeySystems.FairPlay] = DRM_TYPE.FAIR_PLAY,
    _a$1[DrmKeySystems.FairPlayWebKit] = DRM_TYPE.FAIR_PLAY,
    _a$1.none = DRM_TYPE.NONE,
    _a$1);
/** 部分具有特征和特殊含义的配置项上报ID */
var confIdMap = {
    default: 0,
    /** hls内核渐进式加载 */
    hlsProgressive: 1,
    /** hls内核预加载分片 */
    hlsFragPrefetch: 2,
};
/**
 * thumbplayer-h5 内置数据中心插件
 *
 * 插件提供设备信息，自动记录的step上报信息和播放信息，提供外部接口调取和设定数据
 */
var DataSet = /** @class */ (function (_super) {
    __extends(DataSet, _super);
    function DataSet(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.player = player;
        /** 是否在seeking过程 */
        _this.isSeeking = false;
        /** 是否正在缓冲 */
        _this.isBuffering = false;
        /** 是否正在切换清晰度 */
        _this.isSettingLevel = false;
        /** 是否正在加载 */
        _this.isLoading = false;
        /** 播放事件时间戳 */
        _this.lastPlay = 0;
        /** 用户播放时长 */
        _this.playDuration = 0;
        /** 用于累计timeupdate的时长，每来一次timeupdate */
        _this.prevPlayTimeS = 0;
        /** 累计一个session内的总缓冲次数 */
        _this.sessionBufferCount = 0;
        /** 累计一个session中的url重试次数 */
        _this.sessionRetryBackUrlCount = 0;
        /** 累计一个session中的播放级别重试次数 */
        _this.sessionRetryPlayCount = 0;
        /** commonMap freeze字段 */
        _this.commonMapFreeze = {};
        /** stateMap freeze字段 */
        _this.stateMapFreeze = {};
        /** 是否是直播 */
        _this.isLive = false;
        /** 是否在播放广告 */
        _this.isAdPlaying = false;
        /** eventId map */
        _this.evtIdMap = {};
        /**
         * 设定字段值，如果有传入freezeKey则尝试冻结
         * @param key 字段key
         * @param value 字段值
         * @param freezeKey 冻结字段的key
         * @return boolean
         */
        _this.writeCommon = function (key, value, freezeKey) {
            var oldVal = _this.commonMap[key];
            _this.commonMap[key] = value;
            if (!DataSet.canUseProxy) {
                _this.emit(DATA_EVENTS.UPDATE, {
                    key: key,
                    oldVal: oldVal,
                    newVal: value,
                });
            }
            if (freezeKey)
                return _this.freeze('common', key, freezeKey);
            return false;
        };
        /**
         * 设定字段值，如果有传入freezeKey则尝试冻结
         * @param key 字段key
         * @param value 字段值，这里会补全ftime，name，eventId，stats包
         * @param freezeKey 冻结字段的key
         * @return boolean
         */
        _this.writeState = function (key, value, freezeKey) {
            var type = value.type || LOG_TYPE.UNCATEGORIZED;
            var oldVal = _this.stateMap[key];
            var prevStateData = _this.getStartEventData(key);
            _this.stateMap[key] = __assign(__assign(__assign({}, (type === LOG_TYPE.CORE_EVENT ? _this.stats : {})), { type: type, ftime: +new Date(), name: key, eventId: _this.generateEvtId() }), value);
            if (!DataSet.canUseProxy && _this.commonMap[COMMON_DATA_KEY.flowid]) {
                _this.emit(DATA_EVENTS.STATE_UPDATE, {
                    key: key,
                    oldVal: oldVal,
                    newVal: _this.stateMap[key],
                    startEvent: prevStateData,
                });
            }
            if (freezeKey)
                return _this.freeze('state', key, freezeKey);
            return false;
        };
        /** 播放器被关闭时，立刻返回最终结果 */
        _this.onClose = function () {
            var now = +new Date();
            return {
                code: ErrorCode.SUC,
                playDuration: _this.playDuration,
                ftime: now,
            };
        };
        /** 获取当前的stats，用户播放时长，visualStats */
        _this.getStats = function () { return (__assign(__assign({ playDuration: _this.playDuration }, _this.stats), _this.visualStats)); };
        /**
         * 生成新的flowid
         */
        _this.generateFlowId = function () { return commonTool.createGUID(32); };
        /** 生成新的eventId */
        _this.generateEvtId = function () { return commonTool.createGUID(8); };
        _this.getStartEventData = function (eventName) {
            var _a;
            var eventMap = (_a = {},
                _a[DATA_STATE.SEEK_END] = _this.stateMap[DATA_STATE.SEEK_START],
                _a[DATA_STATE.BUFFER_END] = _this.stateMap[DATA_STATE.BUFFER_START],
                _a[DATA_STATE.LOAD_END] = _this.stateMap[DATA_STATE.LOAD_START],
                _a[DATA_STATE.SET_LEVEL_END] = _this.stateMap[DATA_STATE.SET_LEVEL_START],
                _a[DATA_STATE.PAUSE_END] = _this.stateMap[DATA_STATE.PAUSE_START],
                _a[DATA_STATE.GET_INFO_END] = _this.stateMap[DATA_STATE.GET_INFO_START],
                _a);
            return eventMap[eventName];
        };
        /**
         * 清空当前正在进行的seek和buffer
         */
        _this.resetState = function () {
            _this.isBuffering = false;
            _this.isSeeking = false;
            _this.isSettingLevel = false;
        };
        _this.finalCleanup = function (now, videoInfo) {
            var _a, _b;
            var error = videoInfo.error, loadingUrl = videoInfo.loadingUrl, config = videoInfo.config;
            var urlIdx = (_b = (_a = config === null || config === void 0 ? void 0 : config.backupUrls) === null || _a === void 0 ? void 0 : _a.findIndex(function (i) { return i === loadingUrl; })) !== null && _b !== void 0 ? _b : -1;
            if (_this.isSeeking) {
                _this.writeState(DATA_STATE.SEEK_END, {
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    type: LOG_TYPE.CORE_EVENT,
                    ftime: now,
                    error: error,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    name: DATA_STATE.SEEK_END,
                    eventId: _this.evtIdMap[DATA_STATE.SEEK_START],
                });
                _this.isSeeking = false;
            }
            if (_this.isBuffering) {
                _this.writeState(DATA_STATE.BUFFER_END, {
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    type: LOG_TYPE.CORE_EVENT,
                    ftime: now,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    error: error,
                    name: DATA_STATE.BUFFER_END,
                    eventId: _this.evtIdMap[DATA_STATE.BUFFER_START],
                });
                _this.isBuffering = false;
            }
            if (_this.isSettingLevel) {
                _this.isSettingLevel = false;
                _this.writeState(DATA_STATE.SET_LEVEL_END, {
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    type: LOG_TYPE.CORE_EVENT,
                    ftime: now,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    error: error,
                    name: DATA_STATE.SET_LEVEL_END,
                    eventId: _this.evtIdMap[DATA_STATE.SET_LEVEL_START],
                });
            }
            if (_this.isLoading) {
                _this.isLoading = false;
                _this.writeState(DATA_STATE.LOAD_END, {
                    type: LOG_TYPE.CORE_EVENT,
                    currentUrl: loadingUrl,
                    urlIndex: urlIdx,
                    ftime: now,
                    error: error,
                    code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
                    name: DATA_STATE.LOAD_END,
                    eventId: _this.evtIdMap[DATA_STATE.LOAD_START],
                });
            }
            _this.isAdPlaying = false;
        };
        /**
         * 自动播放被拦截
         */
        _this.onAutoplayBlocked = function () {
            _this.writeState(DATA_STATE.AUTO_PLAY_BLOCKED, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.AUTO_PLAY_BLOCKED,
                eventId: _this.generateEvtId(),
                ftime: +new Date(),
            });
        };
        /**
         * 前贴广告播放中
         */
        _this.onAdPlaying = function (evt) {
            if (evt.data.adType !== AD_TYPE.PRE)
                return;
            _this.isAdPlaying = true;
        };
        /**
         * 前贴广告播放结束
         */
        _this.onAdEnd = function (evt) {
            if (evt.data.adType !== AD_TYPE.PRE)
                return;
            _this.isAdPlaying = false;
        };
        /**
         * 播放器加载失败进行地址重试时的回调
         */
        _this.onRetryLoad = function (evt) {
            var data = evt.data;
            var prevUrl = data.prevUrl, curUrl = data.curUrl, _a = data.error, error = _a === void 0 ? {} : _a;
            _this.writeState(DATA_STATE.RETRY_BACKURL, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.RETRY_BACKURL,
                eventId: _this.generateEvtId(),
                prevUrl: prevUrl,
                currentUrl: curUrl,
                ftime: +new Date(),
                error: error,
                code: error === null || error === void 0 ? void 0 : error.code,
            });
            // 累计url重试缓冲次数
            _this.sessionRetryBackUrlCount++;
            _this.writeCommon(COMMON_DATA_KEY.sessionRetryBackUrlCount, _this.sessionRetryBackUrlCount);
        };
        _this.onRetryPlay = function (evt) {
            var data = evt.data;
            var _a = data.retryTimes, retryTimes = _a === void 0 ? 0 : _a;
            _this.writeState(DATA_STATE.RETRY_PLAY, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.RETRY_PLAY,
                eventId: _this.generateEvtId(),
                ftime: +new Date(),
                ext: {
                    retryTimes: retryTimes,
                },
            });
            // 累计播放级别重试次数
            _this.sessionRetryPlayCount++;
            _this.writeCommon(COMMON_DATA_KEY.sessionRetryPlayCount, _this.sessionRetryPlayCount);
        };
        /**
         * 播放器状态切换为buffering时的回调
         *
         * 1.如果上一个buffer还未结束则跳过（如果buffer之后pause）
         */
        _this.onBuffering = function (data) {
            // 如果正在缓冲则跳过
            if (_this.isBuffering)
                return;
            _this.isBuffering = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DATA_STATE.BUFFER_START] = eventId;
            _this.writeState(DATA_STATE.BUFFER_START, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.BUFFER_START,
                eventId: eventId,
                prevState: data.old,
                ftime: +new Date(),
            });
            // 累计缓冲次数
            _this.sessionBufferCount++;
            _this.writeCommon(COMMON_DATA_KEY.sessionBufferCount, _this.sessionBufferCount);
        };
        /**
         * 播放器状态切换为loadStart时的回调
         *
         * 1.清空正在发生的buffer和seek事件
         * 2.设定当前播放器内核
         * 3.如果播放器下一个状态为canplay则标记load结束
         */
        _this.onLoadStart = function (data) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            _this.resetState();
            var currentConfig = (_a = data.videoInfo) === null || _a === void 0 ? void 0 : _a.config;
            var now = +new Date();
            _this.writeCommon(COMMON_DATA_KEY.curcore, _this.player.kernelName);
            var kernelVersion = (_b = KernelFactory.getKernelByName(_this.player.kernelName)) === null || _b === void 0 ? void 0 : _b.VERSION;
            _this.writeCommon(COMMON_DATA_KEY.curcorever, kernelVersion);
            _this.writeCommon(COMMON_DATA_KEY.drmtype, KeySystemToDrmType[((_c = currentConfig.drmConfig) === null || _c === void 0 ? void 0 : _c.keySystem) || 'none']);
            _this.writeCommon(COMMON_DATA_KEY.playertype, _this.player.kernelName === KERNEL_NAME.ORIGIN ? '0' : '1');
            var p2pController = (_f = (_e = (_d = _this.player.corePlayer) === null || _d === void 0 ? void 0 : _d.kernel) === null || _e === void 0 ? void 0 : _e.getP2P) === null || _f === void 0 ? void 0 : _f.call(_e);
            _this.writeCommon(COMMON_DATA_KEY.p2pver, (_h = (_g = p2pController === null || p2pController === void 0 ? void 0 : p2pController.getVersion) === null || _g === void 0 ? void 0 : _g.call(p2pController)) !== null && _h !== void 0 ? _h : 0);
            // 如果没有下载组件 则不上报p2p
            _this.writeCommon(COMMON_DATA_KEY.p2p, p2pController ? '1' : '0');
            // 如果是hls内核，又没有p2p组件，上报一个特殊的配置id
            if (_this.player.kernelName === KERNEL_NAME.HLS_JS && !p2pController) {
                var enableP2P = +((_j = _this.player.config.enableP2P) !== null && _j !== void 0 ? _j : 2);
                var p2pConfig = +(!!_this.player.currentVideoInfo.config.p2pConfig);
                _this.writeCommon(COMMON_DATA_KEY.confid, "7003".concat(enableP2P).concat(p2pConfig));
            }
            _this.isLoading = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DATA_STATE.LOAD_START] = eventId;
            _this.writeState(DATA_STATE.LOAD_START, {
                type: LOG_TYPE.CORE_EVENT,
                eventId: eventId,
                name: DATA_STATE.LOAD_START,
                ftime: now,
            });
        };
        /**
         * 播放器状态切换为End时的回调, 这里是正常播放结束，如果报错不会走到end状态
         *
         * 1.统计本次播放内的seek和buffer事件
         * 2.统计本次播放时用户的播放时长
         *
         */
        _this.onEnd = function () {
            _this.writeState(DATA_STATE.END, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.END,
                eventId: _this.generateEvtId(),
                ftime: +new Date(),
                ext: {
                    playDuration: _this.playDuration,
                },
                code: ErrorCode.SUC,
            });
        };
        /**
         * 播放器状态切换为idle时的回调，一般是播放结束END后或报错后
         * 这里需要注意，如果外部拦截error执行重试操作，播放器都会进入idle状态再重新开播，但是日志和上报都应该被认为是同次播放
         */
        _this.onIdle = function () {
        };
        /**
         * 播放器状态切换为seeking时的回调
         *
         * 1.如果正在seek则标记seek为结束并开始下一次seek
         * 2.如果正在buffer则抛弃这次buffer
         */
        _this.onSeeking = function (data) {
            var _a, _b;
            var time = +new Date();
            if (_this.isSeeking) {
                _this.writeState(DATA_STATE.SEEK_END, {
                    type: LOG_TYPE.CORE_EVENT,
                    name: DATA_STATE.SEEK_END,
                    ftime: time,
                    eventId: _this.evtIdMap[DATA_STATE.SEEK_START],
                    ext: {
                        isUserSeek: ((_b = (_a = _this.stateMap[DATA_STATE.SEEK_START]) === null || _a === void 0 ? void 0 : _a.ext) === null || _b === void 0 ? void 0 : _b.isUserSeek) || false,
                    },
                });
            }
            // 直播状态下buffer不可以被抛弃
            if (!_this.isLive)
                _this.resetState();
            _this.isSeeking = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DATA_STATE.SEEK_START] = eventId;
            _this.writeState(DATA_STATE.SEEK_START, {
                type: LOG_TYPE.CORE_EVENT,
                ftime: time,
                name: DATA_STATE.SEEK_START,
                eventId: eventId,
                ext: {
                    inBufferedRange: videoTool.checkTimeInBuffer(data.seekingTime, _this.player.videoBuffered),
                    isUserSeek: data.isUserSeek,
                },
            });
        };
        /**
         * 播放器状态切换为seeked时的回调
         *
         * 1.如果正在seek则标记seek为结束
         */
        _this.onSeeked = function (data) {
            if (!_this.isSeeking)
                return;
            _this.isSeeking = false;
            _this.writeState(DATA_STATE.SEEK_END, {
                type: LOG_TYPE.CORE_EVENT,
                eventId: _this.evtIdMap[DATA_STATE.SEEK_START],
                ftime: +new Date(),
                name: DATA_STATE.SEEK_END,
                ext: {
                    isUserSeek: data.isUserSeek,
                },
                code: ErrorCode.SUC,
            });
        };
        /**
         * 播放器状态切换为pause时的回调
         */
        _this.onPause = function (data) {
            var pauseType = data.pauseType;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DATA_STATE.PAUSE_START] = eventId;
            _this.writeState(DATA_STATE.PAUSE_START, {
                type: LOG_TYPE.CORE_EVENT,
                ftime: +new Date(),
                name: DATA_STATE.PAUSE_START,
                eventId: eventId,
                pauseType: pauseType,
            });
        };
        /**
         * 播放器状态切换为playing时的回调
         *
         * 1.更新播放开始的时间戳
         */
        _this.onPlaying = function () {
            var now = +new Date();
            if (_this.isBuffering) {
                // hls相关的缓冲信息
                _this.writeState(DATA_STATE.BUFFER_END, {
                    type: LOG_TYPE.CORE_EVENT,
                    name: DATA_STATE.BUFFER_END,
                    ftime: now,
                    eventId: _this.evtIdMap[DATA_STATE.BUFFER_START],
                });
                _this.isBuffering = false;
            }
            _this.lastPlay = now;
            if (_this.evtIdMap[DATA_STATE.PAUSE_START]) {
                _this.writeState(DATA_STATE.PAUSE_END, {
                    type: LOG_TYPE.CORE_EVENT,
                    name: DATA_STATE.PAUSE_END,
                    eventId: _this.evtIdMap[DATA_STATE.PAUSE_START],
                    ftime: now,
                    code: ErrorCode.SUC,
                });
                delete _this.evtIdMap[DATA_STATE.PAUSE_START];
            }
        };
        /**
         * 播放器状态切换为canplay时的回调
         *
         * 1. 如果有正在进行的buffer则标记buffer为结束
         */
        _this.onCanPlay = function () {
            if (!_this.isLoading)
                return;
            var now = +new Date();
            _this.writeState(DATA_STATE.LOAD_END, {
                type: LOG_TYPE.CORE_EVENT,
                ftime: now,
                name: DATA_STATE.LOAD_END,
                eventId: _this.evtIdMap[DATA_STATE.LOAD_START],
                code: ErrorCode.SUC,
                ext: { isAdPlaying: _this.isAdPlaying },
            });
            _this.isLoading = false;
        };
        _this.onCodecDegrade = function (evt) {
            var _a;
            var now = +new Date();
            _this.writeState(DATA_STATE.CODEC_DEGRADE, {
                type: LOG_TYPE.CORE_EVENT,
                ftime: now,
                name: DATA_STATE.CODEC_DEGRADE,
                code: (_a = evt.data.degradeReason) !== null && _a !== void 0 ? _a : ErrorCode.SUC,
            });
        };
        /**
         * 播放器开始切换清晰度时的监听回调
         *
         * 1.如果有正在进行的seek事件，标记seek结束
         * 2.清空正在进行的buffer事件
         */
        _this.onSetLevelStart = function (evt) {
            var time = +new Date();
            if (_this.isSeeking) {
                _this.isSeeking = false;
                _this.writeState(DATA_STATE.SEEK_END, {
                    type: LOG_TYPE.CORE_EVENT,
                    name: DATA_STATE.SEEK_END,
                    ftime: time,
                    eventId: _this.evtIdMap[DATA_STATE.SEEK_START],
                });
            }
            _this.resetState();
            _this.isSettingLevel = true;
            var eventId = _this.generateEvtId();
            _this.evtIdMap[DATA_STATE.SET_LEVEL_START] = eventId;
            _this.writeState(DATA_STATE.SET_LEVEL_START, {
                type: LOG_TYPE.CORE_EVENT,
                ftime: time,
                eventId: eventId,
                name: DATA_STATE.SET_LEVEL_START,
                ext: {
                    defn: _this.commonMap.currentDefn,
                    mode: evt.data.mode,
                },
            });
        };
        /**
         * 播放器结束清晰度切换时的监听回调
         */
        _this.onSetLevelEnd = function (evt) {
            var _a = evt.data, data = _a === void 0 ? {} : _a;
            var videoInfo = data.videoInfo;
            var error = (videoInfo || {}).error;
            _this.isSettingLevel = false;
            // 切清晰度可能切换内核
            _this.writeCommon(COMMON_DATA_KEY.curcore, _this.player.kernelName);
            _this.writeState(DATA_STATE.SET_LEVEL_END, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.SET_LEVEL_END,
                ftime: +new Date(),
                eventId: _this.evtIdMap[DATA_STATE.SET_LEVEL_START],
                error: error,
                code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC,
            });
        };
        /**
         * 播放器报错时的回调
         *
         * 更新报错前播放器最后的状态，
         * ！！注意这里stats已经无法取值了，需要从error的videoinfo上获取
         */
        _this.onError = function (evt) {
            var _a, _b;
            var data = evt.data;
            var videoInfo = (data || {}).videoInfo;
            var _c = videoInfo || {}, error = _c.error, state = _c.state, currentFragSn = _c.currentFragSn, currentFragUrl = _c.currentFragUrl, loadingUrl = _c.loadingUrl, config = _c.config;
            var now = +new Date();
            _this.writeState(DATA_STATE.ERROR, {
                currentUrl: loadingUrl,
                urlIndex: (_b = (_a = config === null || config === void 0 ? void 0 : config.backupUrls) === null || _a === void 0 ? void 0 : _a.findIndex(function (i) { return i === loadingUrl; })) !== null && _b !== void 0 ? _b : -1,
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.ERROR,
                eventId: _this.generateEvtId(),
                fragUrl: currentFragUrl,
                ext: {
                    fragSn: currentFragSn,
                },
                code: error.code,
                error: error,
                ftime: now,
                prevState: state,
            });
            _this.finalCleanup(now, videoInfo);
        };
        /**
         * 播放器DURATION变更的监听回调
         *
         * 更新播放器视频时长
         */
        _this.onDurationChange = function (evt) {
            var _a = evt.data, data = _a === void 0 ? {} : _a;
            var videoInfo = data.videoInfo;
            var _b = (videoInfo || {}).duration, duration = _b === void 0 ? 0 : _b;
            _this.commonMap.duration = duration;
        };
        /**
         * 播放器FIRST_PLAYING变更的监听回调
         *
         * 记录首播时间
         */
        _this.onFirstPlay = function () {
            var now = +new Date();
            _this.writeState(DATA_STATE.FIRST_PLAY, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.FIRST_PLAY,
                ftime: now,
                eventId: _this.generateEvtId(),
            });
        };
        /**
         * 播放器PLAY_TIME变更的监听回调
         *
         * 更新用户真实播放时长
         */
        _this.onTimeChange = function () {
            var timeS = Math.floor(_this.player.playtime);
            if (!timeS)
                return;
            if (timeS === _this.prevPlayTimeS)
                return;
            _this.prevPlayTimeS = timeS;
            if (!_this.playDuration)
                _this.playDuration = 0;
            _this.playDuration += 1;
        };
        /** 播放器VIDEO_STATE变更的监听回调 */
        _this.onStateChange = function (evt) {
            var _a;
            var data = evt.data;
            var newState = data.new;
            var stateHandlerMap = (_a = {},
                _a[VIDEO_STATE.BUFFERING] = _this.onBuffering,
                _a[VIDEO_STATE.LOAD_START] = _this.onLoadStart,
                _a[VIDEO_STATE.END] = _this.onEnd,
                _a[VIDEO_STATE.IDLE] = _this.onIdle,
                // 用户拖拽才会被记录，监听CTRL_EVENT.MOUSE_DOWN处理
                _a[VIDEO_STATE.SEEKING] = _this.onSeeking,
                _a[VIDEO_STATE.SEEKED] = _this.onSeeked,
                _a[VIDEO_STATE.PAUSE] = _this.onPause,
                _a[VIDEO_STATE.PLAYING] = _this.onPlaying,
                _a[VIDEO_STATE.CANPLAY] = _this.onCanPlay,
                _a);
            if (stateHandlerMap[newState]) {
                stateHandlerMap[newState](data);
            }
        };
        /** 倍速切换 */
        _this.onRateChange = function () {
            _this.writeState(DATA_STATE.SET_RATE, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.SET_RATE,
                eventId: _this.generateEvtId(),
                ftime: +new Date(),
            });
        };
        /** GETINFO开始 */
        _this.onVideoReqInfoStart = function () {
            var evtId = _this.generateEvtId();
            _this.evtIdMap[DATA_STATE.GET_INFO_START] = evtId;
            _this.writeState(DATA_STATE.GET_INFO_START, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.GET_INFO_START,
                eventId: evtId,
                ftime: +new Date(),
            });
        };
        /** GETINFO结束 */
        _this.onVideoReqInfoEnd = function (evt) {
            var data = evt.data;
            var code = data.code, _a = data.data, resData = _a === void 0 ? {} : _a;
            // 如果重新请求了getinfo，那么备份地址重试清零
            _this.sessionRetryBackUrlCount = 0;
            if (!_this.evtIdMap[DATA_STATE.GET_INFO_START])
                return;
            _this.writeState(DATA_STATE.GET_INFO_END, {
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.GET_INFO_END,
                code: code,
                ext: {
                    reqBody: urlTool.object2string(resData.reqParams || {}, '&'),
                    reqPath: resData.reqPath || '',
                    retryCount: resData.alreadyRetryCount || 0,
                },
                error: resData.error || {},
                eventId: _this.evtIdMap[DATA_STATE.GET_INFO_START],
                ftime: +new Date(),
            });
        };
        /** play session开始，生成flowid */
        _this.onPlaySessionStart = function (_a) {
            var data = _a.data;
            _this.writeCommon(COMMON_DATA_KEY.flowid, data.flowid);
            _this.writeCommon(COMMON_DATA_KEY.isPreload, Number(data.isPreload));
            _this.writeCommon(COMMON_DATA_KEY.vid, isVideoId(data.playItem) ? data.playItem : '');
            // 此时开始上报init
            _this.emit(DATA_EVENTS.STATE_UPDATE, {
                key: DATA_STATE.INIT,
                oldVal: undefined,
                newVal: _this.stateMap[DATA_STATE.INIT],
                startEvent: undefined,
            });
            _this.writeState(DATA_STATE.SESSION_START, {
                eventId: _this.generateEvtId(),
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.SESSION_START,
                ftime: +new Date(),
            });
        };
        _this.onPlaySessionEnd = function (evt) {
            var data = evt.data;
            var code = data.code;
            var payload = code === ErrorCode.SUC
                ? __assign({}, _this.stateMap[DATA_STATE.END]) : __assign({}, _this.stateMap[DATA_STATE.ERROR]);
            if (code !== ErrorCode.SUC) {
                // 报错的情况下移除本地的音轨缓存
                _this.removeUserSetting([
                    PersistedUserSettings.audioTrack,
                ]);
            }
            _this.writeState(DATA_STATE.SESSION_END, __assign(__assign({}, payload), { code: code, eventId: _this.generateEvtId(), name: DATA_STATE.SESSION_END, type: LOG_TYPE.CORE_EVENT, ftime: +new Date() }));
            _this.playDuration = 0;
            _this.prevPlayTimeS = 0;
            _this.sessionBufferCount = 0;
            _this.sessionRetryBackUrlCount = 0;
            _this.sessionRetryPlayCount = 0;
        };
        /** AD */
        /**
         * 获取GUID，如果localStorage没有GUID则生成新的GUID
         */
        _this.getGUID = function () {
            var lsGuid = lsTool.getData(LOCAL_KEY.GUID);
            if (lsGuid) {
                return lsGuid;
            }
            var newGuid = commonTool.createGUID(32);
            lsTool.setData(LOCAL_KEY.GUID, newGuid);
            return newGuid;
        };
        /** 标签是否可见，1:可见，0:不可见，-1:未知 */
        _this.isTabFocused = function () {
            var hiddenTags = ['hidden', 'msHidden', 'webkitHidden'];
            var tag = hiddenTags.find(function (i) { return typeof document[i] !== 'undefined'; });
            if (tag) {
                return document[tag] ? 0 : 1;
            }
            return -1;
        };
        /** 播放器容器元素是否在屏幕内 */
        _this.isPlayerInViewport = function () {
            var container = _this.player.container;
            if (!container.offsetParent)
                return 0;
            var rect = container.getBoundingClientRect();
            var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
            var windowWidth = (window.innerWidth || document.documentElement.clientWidth);
            var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
            var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
            return +(vertInView && horInView);
        };
        // 拦截commonMap的设定，如果成功设定则对外广播update事件并携带新旧值
        _this.commonMap = DataSet.canUseProxy ? new Proxy({}, {
            get: function (target, key, receiver) { return Reflect.get(target, key, receiver); },
            set: function (target, key, value, receiver) {
                if (typeof key !== 'string')
                    return false;
                if (_this.commonMapFreeze[key])
                    return false;
                var oldVal = Reflect.get(target, key, receiver);
                var res = Reflect.set(target, key, value, receiver);
                if (oldVal !== value) {
                    _this.emit(DATA_EVENTS.UPDATE, {
                        key: key,
                        oldVal: oldVal,
                        newVal: value,
                    });
                }
                return res;
            },
        }) : {};
        // 拦截stateMap的设定，如果成功设定则对外广播state update事件并携带新旧值
        _this.stateMap = DataSet.canUseProxy ? new Proxy({}, {
            get: function (target, key, receiver) { return Reflect.get(target, key, receiver); },
            set: function (target, key, value, receiver) {
                if (typeof key !== 'string')
                    return false;
                if (_this.stateMapFreeze[key])
                    return false;
                var oldVal = Reflect.get(target, key, receiver);
                var res = Reflect.set(target, key, value, receiver);
                // 只有flowid生成后才广播事件
                if (_this.commonMap[COMMON_DATA_KEY.flowid]) {
                    _this.emit(DATA_EVENTS.STATE_UPDATE, {
                        key: key,
                        oldVal: oldVal,
                        newVal: value,
                        startEvent: _this.getStartEventData(key),
                        startEventData: _this.getStartEventData(key),
                    });
                }
                return res;
            },
        }) : {};
        _this.isLive = _this.player.config.type === PLAY_MODE.LIVE;
        _this.setEnv();
        _this.collectBaseInfo();
        _this.collectVideoCapability();
        _this.persistUserSetting();
        return _this;
    }
    Object.defineProperty(DataSet.prototype, "stats", {
        /** 播放器的播控参数 */
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var _h = this.player, playbackRate = _h.playbackRate, volume = _h.volume, played = _h.played, playtime = _h.playtime, currentVideoInfo = _h.currentVideoInfo;
            return {
                volume: volume,
                playbackRate: playbackRate,
                played: played,
                playtime: playtime,
                urlIndex: (_c = (_b = (_a = currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.config) === null || _a === void 0 ? void 0 : _a.backupUrls) === null || _b === void 0 ? void 0 : _b.findIndex(function (i) { return i === currentVideoInfo.loadingUrl; })) !== null && _c !== void 0 ? _c : -1,
                frameDroppedInPercentage: (_e = (_d = currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.qualityInfo) === null || _d === void 0 ? void 0 : _d.frameDroppedInPercentage) !== null && _e !== void 0 ? _e : -1,
                averageDecodeTimeInMs: (_g = (_f = currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.qualityInfo) === null || _f === void 0 ? void 0 : _f.averageDecodeTimeInMs) !== null && _g !== void 0 ? _g : -1,
                currentUrl: currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.loadingUrl,
                paused: this.paused,
                fragUrl: currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.currentFragUrl,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataSet.prototype, "visualStats", {
        /** 播放器的视觉信息 */
        get: function () {
            var isTabFocused = this.isTabFocused();
            var isPlayerInViewport = this.isPlayerInViewport();
            return {
                isTabFocused: isTabFocused,
                isPlayerInViewport: isPlayerInViewport,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataSet.prototype, "paused", {
        /** 是否为暂停状态 */
        get: function () {
            var _a, _b;
            return (_b = (_a = this.player) === null || _a === void 0 ? void 0 : _a.currentVideoElement) === null || _b === void 0 ? void 0 : _b.paused;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 解冻指定字段，需要传入冻结字段时的secret
     * @param target 目标字段集
     * @param key 需要解冻的字段值
     * @param secret 冻结字段时传入的secret用于校验
     * @return boolean true时为解冻成功；false时为解冻失败
     */
    DataSet.prototype.defrost = function (target, key, secret) {
        if (secret === void 0) { secret = 'secret'; }
        switch (target) {
            case 'state':
                if (this.stateMapFreeze[key] === secret) {
                    delete this.stateMapFreeze[key];
                    return true;
                }
                return false;
            case 'common':
                if (this.commonMapFreeze[key] === secret) {
                    delete this.commonMapFreeze[key];
                    return true;
                }
                return false;
        }
    };
    /**
     * 冻结指定字段，无法冻结已经冻结的字段；secret可以用于解冻时的校验
     * @param target 目标字段集
     * @param key 需要冻结的字段值
     * @param secret 冻结校验的key
     * @return boolean true时为冻结成功；false时为冻结失败
     */
    DataSet.prototype.freeze = function (target, key, secret) {
        if (secret === void 0) { secret = 'secret'; }
        switch (target) {
            case 'state':
                if (this.stateMapFreeze[key]) {
                    this.player.log("".concat(key, "\u5DF2\u9501\u5B9A"));
                    return false;
                }
                this.stateMapFreeze[key] = secret;
                return true;
            case 'common':
                if (this.commonMapFreeze[key]) {
                    this.player.log("".concat(key, "\u5DF2\u9501\u5B9A"));
                    return false;
                }
                this.commonMapFreeze[key] = secret;
                return true;
            default:
                return false;
        }
    };
    DataSet.prototype.setEnv = function () {
        var _this = this;
        // 监听播放器state change
        this.player.on(PLAY_EVENT.STATE_CHANGE, this.onStateChange);
        // 首播记录
        this.player.on(PLAY_EVENT.FIRST_PLAYING, this.onFirstPlay);
        // 时间更新 (不同浏览器间隔不同，这里throttle一下每秒触发一次)
        this.player.on(PLAY_EVENT.TIME_UPDATE, this.onTimeChange);
        // 长度更新
        this.player.on(PLAY_EVENT.DURATION_CHANGE, this.onDurationChange);
        // 报错
        this.player.on(PLAY_EVENT.ERROR, this.onError);
        // 清晰度切换开始
        this.player.on(PLAY_EVENT.SETLEVEL_START, this.onSetLevelStart);
        // 清晰度切换结束/报错
        this.player.on(PLAY_EVENT.SETLEVEL_OVER, this.onSetLevelEnd);
        // 倍速切换
        this.player.on(PLAY_EVENT.RATE_CHANGE, this.onRateChange);
        // 地址重试
        this.player.on(PLAY_EVENT.RETRY_BACKURL, this.onRetryLoad);
        // 自动播放被拦截
        this.player.on(PLAY_EVENT.AUTOPLAY_BLOCKED, this.onAutoplayBlocked);
        // 前贴广告
        this.player.on(H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying);
        this.player.on(H5_PLAY_EVENT.AD_END, this.onAdEnd);
        // GETINFO
        this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_START, this.onVideoReqInfoStart);
        this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, this.onVideoReqInfoEnd);
        // play session变更
        this.player.on(H5_PLAY_EVENT.PLAY_SESSION_START, this.onPlaySessionStart);
        this.player.on(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
        this.player.on(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, function (_a) {
            var data = _a.data;
            if (data.code === ErrorCode.SUC)
                return;
            var output = data.data;
            var code = ((output === null || output === void 0 ? void 0 : output.error) || {}).code;
            _this.writeState(DATA_STATE.ERROR, {
                eventId: _this.generateEvtId(),
                type: LOG_TYPE.CORE_EVENT,
                name: DATA_STATE.ERROR,
                code: code,
                ftime: +new Date(),
            });
        });
        this.msg.on(H5_EXT_EVENT.RETRY_PLAY, this.onRetryPlay);
        this.msg.on(H5_EXT_EVENT.DEGRADE_CODEC_PLAY, this.onCodecDegrade);
    };
    /**
     * 设定公共字段并屏蔽部分字段的setter
     */
    DataSet.prototype.collectBaseInfo = function () {
        var os = uaTool.os, mobile = uaTool.mobile;
        // 移动端
        this.writeCommon(COMMON_DATA_KEY.mobile, mobile ? 1 : 0, FreezeKey);
        // online
        this.writeCommon(COMMON_DATA_KEY.online, 1, FreezeKey);
        // 分辨率
        this.writeCommon(COMMON_DATA_KEY.resolution, "".concat(screen.width, "*").concat(screen.height, "*").concat(window.devicePixelRatio || 1), FreezeKey);
        // ua
        this.writeCommon(COMMON_DATA_KEY.ua, navigator.userAgent.replace(/,/g, '\\,'), FreezeKey);
        // osver
        this.writeCommon(COMMON_DATA_KEY.osver, "".concat(os.osName, " ").concat(os.version), FreezeKey);
        // playertype - 0 系统 1自研，起播前默认为origin
        this.writeCommon(COMMON_DATA_KEY.playertype, 0);
        // 播放器内核信息
        this.writeCommon(COMMON_DATA_KEY.confid, confIdMap.default);
        this.writeCommon(COMMON_DATA_KEY.playercore, Object.keys(KernelFactory.kernelMap).join(','), FreezeKey);
        // 播放器版本号
        this.writeCommon(COMMON_DATA_KEY.playerver, VERSION);
        this.writeCommon(COMMON_DATA_KEY.speed, 0);
        this.writeCommon(COMMON_DATA_KEY.drm, 0);
        // 播放页信息
        this.writeCommon(COMMON_DATA_KEY.url, location.href, FreezeKey);
        this.writeCommon(COMMON_DATA_KEY.topUrl, urlTool.getTopFrameUrl(), FreezeKey);
        this.writeCommon(COMMON_DATA_KEY.referrer, document.referrer, FreezeKey);
        // 设备标识
        this.writeCommon(COMMON_DATA_KEY.guid, this.getGUID());
    };
    /** 收集播放能力支持的情况 */
    DataSet.prototype.collectVideoCapability = function () {
        try {
            var hardware = {
                concurrency: navigator.hardwareConcurrency,
            };
            var nativeCodecSupport = {
                av1: +videoTool.supportAV1(),
                hevc: +videoTool.supportHevc(),
                dolby: +videoTool.isDolbyVisionSupported(),
            };
            var nativeFormatSupport = {
                hls: +videoTool.supportVideoFormat().includes('hls'),
            };
            var hdrSupportLevel = videoTool.isHDRSupported();
            // 这里直接做转译，避免上报插件引用的时候出现逗号转译的问题
            var res = jsonTool.safelyStringify({
                codec: nativeCodecSupport,
                format: nativeFormatSupport,
                hdr: hdrSupportLevel,
                hw: hardware,
                wasm: +videoTool.isWasmSupported(),
                mse: +videoTool.supportMSE(),
            }).replace(/,/g, '\\,');
            this.writeCommon(COMMON_DATA_KEY.videoCapability, res);
            this.log("device capability info: ".concat(res));
        }
        catch (e) {
            // 这里因为部分能力检测可能抛出异常，我们统一处理
        }
    };
    /** 将用户的部分配置持久化 */
    DataSet.prototype.persistUserSetting = function () {
        var _this = this;
        var keysToSave = {};
        var config = this.player.config;
        var disableUserSettingCache = config.disableUserSettingCache, modeSuffix = config.type;
        var isKeyShouldBeIgnored = function (key) {
            var _a;
            return (((_a = disableUserSettingCache === null || disableUserSettingCache === void 0 ? void 0 : disableUserSettingCache.indexOf) === null || _a === void 0 ? void 0 : _a.call(disableUserSettingCache, key)) > -1);
        };
        DataSet.SETTING_CONFIG.forEach(function (settingConfig) {
            var dsKey = settingConfig.dsKey, lsKey = settingConfig.lsKey, oldDsKey = settingConfig.oldDsKey;
            var lsKeyWithPrefix = "".concat(lsKey, "_").concat(modeSuffix);
            if (isKeyShouldBeIgnored(dsKey))
                return;
            // 对旧版本的ds key禁用做一下兼容
            if (oldDsKey && isKeyShouldBeIgnored(oldDsKey))
                return;
            keysToSave[dsKey] = lsKeyWithPrefix;
            var cache = lsTool.getData(lsKeyWithPrefix);
            if (!cache)
                return;
            if (dsKey) {
                _this.writeCommon(dsKey, cache);
            }
        });
        this.msg.on(H5_EXT_EVENT.DATASET_UPDATE, function (e) {
            var data = e.data;
            var newVal = data.newVal, key = data.key;
            if (!keysToSave[key])
                return;
            lsTool.setData(keysToSave[key], newVal);
        });
    };
    DataSet.prototype.removeUserSetting = function (key) {
        var _this = this;
        var keysToRemove = typeof key === 'string' ? [key] : key;
        keysToRemove.forEach(function (key) {
            _this.writeCommon(key, '');
        });
    };
    DataSet.pluginName = 'dataset';
    DataSet.UserSettingKeyPrefix = '__thumbplayer_setting_';
    DataSet.SETTING_CONFIG = [
        {
            oldDsKey: COMMON_DATA_KEY.currentDefn,
            dsKey: PersistedUserSettings.definition,
            lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_definition"),
        },
        {
            oldDsKey: COMMON_DATA_KEY.currentSubtitle,
            dsKey: PersistedUserSettings.subtitle,
            lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_subtitle"),
        },
        {
            oldDsKey: COMMON_DATA_KEY.currentAudioTrack,
            dsKey: PersistedUserSettings.audioTrack,
            lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_audioTrack"),
        },
        {
            dsKey: PersistedUserSettings.volume,
            lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_volume"),
        },
        {
            dsKey: PersistedUserSettings.playbackRate,
            lsKey: "".concat(DataSet.UserSettingKeyPrefix, "_playbackRate"),
        },
    ];
    DataSet.canUseProxy = typeof window.Proxy !== 'undefined';
    return DataSet;
}(Plugin));

var ReportSource;
(function (ReportSource) {
    ReportSource["WHITE_LIST"] = "white";
})(ReportSource || (ReportSource = {}));
var DEFAULT_REPORT_OPTIONS = {
    downloadOnFailed: false,
    reportSource: 'API_CALL',
    onlyCurrent: true,
};

/**
 * iframe 存储相关的 class
 */
var StorageError = /** @class */ (function (_super) {
    __extends(StorageError, _super);
    function StorageError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StorageError;
}(Error));
/**
 * 初始化 iframe storage 失败
 */
var StorageInitError = /** @class */ (function (_super) {
    __extends(StorageInitError, _super);
    function StorageInitError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StorageInitError;
}(StorageError));

/**
 * 通信消息列表
 */
var BridgeMessageName;
(function (BridgeMessageName) {
    /** indexedDB 初始化失败 */
    BridgeMessageName["STORAGE_INIT_FAILED"] = "storageInitFailed";
    /** indexedDB 就绪 */
    BridgeMessageName["STORAGE_READY"] = "storageReady";
    /** 请求存储日志数据 */
    BridgeMessageName["REQUEST_STORE_LOG"] = "requestStoreLog";
    /** 存储日志成功 */
    BridgeMessageName["STORE_LOG_SUCCESS"] = "storeLogSuccess";
    /** 存储日志失败 */
    BridgeMessageName["STORE_LOG_FAILED"] = "storeLogFailed";
    /** 请求上报所有日志 */
    BridgeMessageName["REQUEST_REPORT_LOG"] = "requestReportLog";
    /** 上报日志成功 */
    BridgeMessageName["REPORT_LOG_SUCCESS"] = "reportLogSuccess";
    /** 上报日志失败 */
    BridgeMessageName["REPORT_LOG_FAILED"] = "reportLogFailed";
    /** 上报进度回报 */
    BridgeMessageName["REPORT_PROGRESS"] = "reportProgress";
    /** 请求下载日志 */
    BridgeMessageName["REQUEST_DOWNLOAD_LOG"] = "requestDownloadLog";
})(BridgeMessageName || (BridgeMessageName = {}));
/**
 * iframe 插入到 DOM 上的类名
 */
var REMOTE_STORAGE_CLASS_NAME = 'thumbplayer-remote-storage-bridge';
/** iframe 默认超时时间 10 秒 */
var DEFAULT_IFRAME_TIMEOUT = 10 * 1000;
/** 上报接口可能比较慢，这里设置 30 秒超时 */
var REPORT_TIMEOUT = 30 * 1000;

/** 定义基础通信方法和协议 */
var MessageBridge = /** @class */ (function () {
    /**
     * @param sender globalThis
     * @param receiver iframe.contentWindow | window.parentWindow
     * @param config 配置
     */
    function MessageBridge(sender, receiver) {
        var _this = this;
        this.sender = sender;
        this.receiver = receiver;
        /** 使用 on 方法添加的回调函数存储 */
        this.callbackMap = {};
        /** 如果已被执行 destroy ，则不再监听 iframe 回调 */
        this.hasDestroy = false;
        this.onReceiverMessage = function (event) {
            _this.receiverMessageHandler(event);
        };
        this.sender.addEventListener('message', this.onReceiverMessage);
    }
    /**
     * 向 receiver 发送消息
     */
    MessageBridge.prototype.postMessage = function (message) {
        if (this.hasDestroy)
            throw new Error('Cannot exec postMessage after destroy');
        this.receiver.postMessage(message, '*');
    };
    MessageBridge.prototype.on = function (name, callback) {
        if (this.hasDestroy)
            return;
        if (!this.callbackMap[name]) {
            this.callbackMap[name] = [];
        }
        this.callbackMap[name].push(callback);
    };
    MessageBridge.prototype.off = function (name, callback) {
        if (this.hasDestroy)
            return;
        var callbackList = this.callbackMap[name];
        if (!(callbackList === null || callbackList === void 0 ? void 0 : callbackList.length))
            return;
        var index = callbackList.indexOf(callback);
        if (index === -1)
            return;
        callbackList.splice(index, 1);
    };
    /** 销毁 Bridge，移除所有监听 */
    MessageBridge.prototype.destroy = function () {
        var _a;
        this.hasDestroy = true;
        (_a = this.sender) === null || _a === void 0 ? void 0 : _a.removeEventListener('message', this.onReceiverMessage);
        this.sender = null;
        this.receiver = null;
        this.callbackMap = null;
    };
    /**
     * sender.onmessage 回调函数，过滤出请求的响应数据并操作 simpleDefer.resolve / reject
     * @param event message 事件实例
     */
    MessageBridge.prototype.receiverMessageHandler = function (event) {
        var _this = this;
        var _a;
        if (!this.isBridgeMessage(event.data) || this.hasDestroy)
            return;
        var message = event.data;
        (_a = this.callbackMap[message.name]) === null || _a === void 0 ? void 0 : _a.forEach(function (cb) {
            cb(message, _this.postMessage.bind(_this));
        });
    };
    MessageBridge.prototype.isBridgeMessage = function (data) {
        return typeof data === 'object'
            && typeof (data === null || data === void 0 ? void 0 : data.name) === 'string'
            && typeof (data === null || data === void 0 ? void 0 : data.instanceId) === 'string';
    };
    return MessageBridge;
}());

/**
 * 基于 iframe 的远程 indexedDB 存储，多次 new 情况下会保持 iframe 的单例复用
 */
var RemoteStorageBridge = /** @class */ (function (_super) {
    __extends(RemoteStorageBridge, _super);
    function RemoteStorageBridge(url, instanceId, timeout) {
        if (timeout === void 0) { timeout = DEFAULT_IFRAME_TIMEOUT; }
        var _this = _super.call(this, self, RemoteStorageBridge.getIframe(url, timeout).contentWindow) || this;
        _this.instanceId = instanceId;
        _this.timeout = timeout;
        RemoteStorageBridge.instanceCount += 1;
        return _this;
    }
    /** 创建 / 复用通信 Iframe 元素 */
    RemoteStorageBridge.getIframe = function (url, timeout) {
        if (timeout === void 0) { timeout = DEFAULT_IFRAME_TIMEOUT; }
        if (RemoteStorageBridge.iframeEl)
            return RemoteStorageBridge.iframeEl;
        var iframeEl = document.createElement('iframe');
        iframeEl.src = url;
        document.body.append(iframeEl);
        iframeEl.style.display = 'none';
        iframeEl.classList.add(REMOTE_STORAGE_CLASS_NAME);
        RemoteStorageBridge.iframeEl = iframeEl;
        RemoteStorageBridge.rejectTimeout = window.setTimeout(function () {
            RemoteStorageBridge.storageDefer.reject(new Error('IFrame wait timeout'));
        }, timeout);
        return iframeEl;
    };
    /**
     * 请求 iframe 页面存储日志数据
     */
    RemoteStorageBridge.prototype.storeLogs = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, RemoteStorageBridge.storageDefer.promise];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.postMessagePromise({
                                message: {
                                    name: BridgeMessageName.REQUEST_STORE_LOG,
                                    instanceId: this.instanceId,
                                    data: data,
                                },
                                resolveMessageName: BridgeMessageName.STORE_LOG_SUCCESS,
                                rejectMessageName: BridgeMessageName.STORE_LOG_FAILED,
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 请求 iframe 页面上报
     */
    RemoteStorageBridge.prototype.report = function (reportExt, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, RemoteStorageBridge.storageDefer.promise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.postMessagePromise({
                                message: {
                                    name: BridgeMessageName.REQUEST_REPORT_LOG,
                                    instanceId: this.instanceId,
                                    data: reportExt,
                                },
                                resolveMessageName: BridgeMessageName.REPORT_LOG_SUCCESS,
                                rejectMessageName: BridgeMessageName.REPORT_LOG_FAILED,
                                progressMessageName: BridgeMessageName.REPORT_PROGRESS,
                                onProgress: onProgress,
                                timeout: REPORT_TIMEOUT,
                            })];
                }
            });
        });
    };
    /**
     * 请求 iframe ，下载日志到本地
     */
    RemoteStorageBridge.prototype.downloadLogs = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, RemoteStorageBridge.storageDefer.promise];
                    case 1:
                        _a.sent();
                        this.postMessage({
                            instanceId: this.instanceId,
                            name: BridgeMessageName.REQUEST_DOWNLOAD_LOG,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Promisify postMessage 接口，当对应消息返回时，分别 resolve / reject */
    RemoteStorageBridge.prototype.postMessagePromise = function (_a) {
        var _this = this;
        var message = _a.message, resolveMessageName = _a.resolveMessageName, rejectMessageName = _a.rejectMessageName, progressMessageName = _a.progressMessageName, _b = _a.timeout, timeout = _b === void 0 ? this.timeout : _b, onProgress = _a.onProgress;
        return new Promise(function (resolve, reject) {
            var instanceId = message.instanceId;
            var setResponseTimeout = function () { return setTimeout(function () {
                reject(new Error("PostMessage response timeout: ".concat(message.name, " / ").concat(message.instanceId)));
                bindEvent(false);
            }, timeout); };
            // 响应超时定时器
            var timer = setResponseTimeout();
            var bindEvent = function (isBind) {
                if (isBind === void 0) { isBind = false; }
                var binder = isBind
                    ? _this.on.bind(_this)
                    : _this.off.bind(_this);
                binder(progressMessageName, progressHandler);
                binder(rejectMessageName, rejectHandler);
                binder(resolveMessageName, resolveHandler);
                if (isBind)
                    return;
                clearTimeout(timer);
            };
            // 如果收到对应的 Progress 事件，则刷新超时定时器，并触发对应的 onProgress 回调
            var progressHandler = function (message) {
                clearTimeout(timer);
                timer = setResponseTimeout();
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(message.data.progress);
            };
            var rejectHandler = function (message) {
                if (instanceId !== message.instanceId)
                    return;
                reject(message.data);
                bindEvent(false);
            };
            var resolveHandler = function (message) {
                if (instanceId !== message.instanceId)
                    return;
                resolve(message.data);
                bindEvent(false);
            };
            bindEvent(true);
            _this.postMessage(message);
        });
    };
    /** destroy 一个 bridge 实例时，引用计数 -1，引用归零时销毁 iframe */
    RemoteStorageBridge.prototype.destroy = function () {
        var _a;
        RemoteStorageBridge.instanceCount -= 1;
        if (RemoteStorageBridge.instanceCount <= 0) {
            clearTimeout(RemoteStorageBridge.rejectTimeout);
            RemoteStorageBridge.rejectTimeout = null;
            (_a = RemoteStorageBridge.iframeEl) === null || _a === void 0 ? void 0 : _a.remove();
            RemoteStorageBridge.iframeEl = null;
            RemoteStorageBridge.instanceCount = 0;
            RemoteStorageBridge.storageDefer = new SimpleDefer();
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * 继承基类方法，实现 iframe 等待 ready 逻辑
     */
    RemoteStorageBridge.prototype.receiverMessageHandler = function (event) {
        if (!this.isBridgeMessage(event.data))
            return;
        if (event.data.name === BridgeMessageName.STORAGE_READY) {
            RemoteStorageBridge.storageDefer.resolve();
            clearTimeout(RemoteStorageBridge.rejectTimeout);
            return;
        }
        _super.prototype.receiverMessageHandler.call(this, event);
    };
    /** iframe 上的 db 是否已准备好 */
    RemoteStorageBridge.storageDefer = new SimpleDefer();
    /** iframe 的引用计数，每次 construct 时 +1， destroy -1，引用归零时，destroy 时移除 iframe 实例 */
    RemoteStorageBridge.instanceCount = 0;
    return RemoteStorageBridge;
}(MessageBridge));

/**
 * 延迟 iframe 加载到起播后或播放出错导致的结束
 */
var offlineLogLazyLoadStrategy = function (player) {
    var defer = new SimpleDefer();
    var cb = function () {
        defer.resolve();
    };
    // 默认情况下播放 广告 / 正片 / 播放结束（防止失败），resolve 来开始加载 iframe
    player.once(H5_PLAY_EVENT.AD_PLAYING, cb);
    player.once(H5_PLAY_EVENT.VIDEO_PLAYING, cb);
    player.once(H5_PLAY_EVENT.PLAY_SESSION_END, cb);
    return defer;
};
/** 立即加载 Iframe */
var offlineLogEagerLoadStrategy = function () {
    var defer = new SimpleDefer();
    defer.resolve();
    return defer;
};

var PageWatcher = /** @class */ (function (_super) {
    __extends(PageWatcher, _super);
    function PageWatcher() {
        var _this = _super.call(this) || this;
        _this.emitPageLeave = function () {
            if (document.visibilityState !== 'hidden')
                return;
            if (Date.now() - _this.pageLeaveTimeStamp <= PageWatcher.THROTTLE_GAP) {
                return;
            }
            _this.pageLeaveTimeStamp = Date.now();
            _this.emit(PageWatcherEvent.PageLeave);
        };
        _this.emitPageUnload = function () {
            if (Date.now() - _this.pageUnloadTimeStamp <= PageWatcher.THROTTLE_GAP) {
                return;
            }
            _this.pageUnloadTimeStamp = Date.now();
            _this.emit(PageWatcherEvent.UNLOAD);
        };
        _this.setPageLeave();
        _this.setPageUnload();
        return _this;
    }
    PageWatcher.prototype.setPageLeave = function () {
        window.addEventListener('pagehide', this.emitPageLeave);
        document.addEventListener('visibilitychange', this.emitPageLeave);
    };
    PageWatcher.prototype.setPageUnload = function () {
        window.addEventListener('beforeunload', this.emitPageUnload);
        window.addEventListener('unload', this.emitPageUnload);
    };
    PageWatcher.THROTTLE_GAP = 10;
    return PageWatcher;
}(EvtEmitter));
var PageWatcherEvent;
(function (PageWatcherEvent) {
    PageWatcherEvent["PageLeave"] = "pageLeave";
    PageWatcherEvent["UNLOAD"] = "unload";
})(PageWatcherEvent || (PageWatcherEvent = {}));
var singleton = new PageWatcher();
var PageWatcher$1 = {
    instance: singleton,
    PageWatcherEvent: PageWatcherEvent,
};

var WHITE_LIST_URL = 'https://v.qq.com/cache/wuji/object?appid=tenvideo_offline_log&schemaid=whiteListV2&schemakey=97c0ff59f25543e282072b75e4c287f7&otype=jsonp';
var cbIndex = 0;
/**
 * 拉取白名单
 * @param platform 平台号
 */
function fetchWhiteList(platform) {
    var timeout = 3000;
    var cbIndexRange = 200;
    var cb = 'offline_log';
    var params = encodeURIComponent("platform=[\"".concat(platform, "\"]&enable=true"));
    var requestUrl = "".concat(WHITE_LIST_URL, "&filter=").concat(params);
    cbIndex += 1;
    return netTool.jsonp(requestUrl, {
        name: cb + (cbIndex % cbIndexRange),
        timeout: timeout,
    });
}

function validateWhiteListItem(item, commonKv) {
    var condEnc = item.condEnc;
    var keys = Object.keys(condEnc);
    return keys.every(function (conditionKey) {
        var valueToValid = condEnc[conditionKey];
        // 如果是数组，则遍历数组校验
        if (Array.isArray(valueToValid)) {
            return valueToValid.some(function (value) { return validateValue(value, commonKv[conditionKey]); });
        }
        // 否则校验值
        return validateValue(valueToValid, commonKv[conditionKey]);
    });
}
function isRegCondition(value) {
    return typeof value === 'object' && 'regStr' in value;
}
/**
 * 校验具体 key-value 是否和 播放器中同名属性值相等，如果 value 值为 string，则对比 sha256 后的计算值
 * @param conditionValue 校验值
 * @param playerValue 播放器上的实际值
 */
function validateValue(conditionValue, playerValue) {
    try {
        // 先处理正则配置，创建正则匹配校验值
        if (isRegCondition(conditionValue)) {
            var _a = conditionValue.flags, flags = _a === void 0 ? 'i' : _a, regStr = conditionValue.regStr;
            return new RegExp(regStr, flags).test(String(playerValue));
        }
        // 如果是 string 类型，则判断下 sha256 值
        if (typeof conditionValue === 'string'
            && typeof playerValue === 'string') {
            return conditionValue === sha256(playerValue);
        }
        // 否则直接对比
        return conditionValue === playerValue;
    }
    catch (_b) {
        // 匹配失败，返回 false
        return false;
    }
}

/**
 * 离线日志插件，用于收集播放产生的 Logger 日志并按需上报至管理台
 */
var OfflineLogPlugin = /** @class */ (function (_super) {
    __extends(OfflineLogPlugin, _super);
    function OfflineLogPlugin(player, opts, extra) {
        var _this = _super.call(this, player, opts, extra) || this;
        /** 页面监听器，在页面即将销毁、页面切换 tab 时存储日志 */
        _this.pageWatcher = PageWatcher$1.instance;
        /** 日志索引数据变更情况，存在变更后，下次轮询存储变更信息 */
        _this.logInfoChange = {};
        /** 标志插件是否已执行 destroy 方法，因为 destroy 方法是异步的，所以不能拿 this.player 标志 */
        _this.isDestroy = false;
        /** 外部允许加载存储 iframe 且 iframe 已经准备好的 defer */
        _this.storageDefer = new SimpleDefer();
        _this.onPageLeave = function () {
            _this.storeLogs();
        };
        /**
         * 获取日志数据变更，并通知 iframe 写入到 indexedDB 中
         * @param ext 存储扩展字段
         */
        _this.storeLogs = function (ext) { return __awaiter(_this, void 0, void 0, function () {
            var instanceId, cache, messageData, shouldStore, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instanceId = this.instanceId;
                        // 若前置为异步操作，则可能在 storeLogs 时，插件已经销毁，此时不执行任何操作
                        if (!instanceId)
                            return [2 /*return*/];
                        cache = getLogCache(instanceId);
                        messageData = {
                            logs: cache,
                            info: this.logInfoChange,
                            ext: ext,
                        };
                        shouldStore = ext
                            || messageData.logs.length
                            || Boolean(Object.keys(this.logInfoChange).length);
                        clearLogCache(instanceId);
                        this.logInfoChange = {};
                        if (!shouldStore)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.storageDefer.promise];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.remoteStorage.storeLogs(messageData)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        // iframe storage 在初始化阶段就失败掉了，这种情况下静默失败
                        if (err_1 instanceof StorageInitError) {
                            return [2 /*return*/];
                        }
                        // 留下异常日志
                        this.logger.error("OfflineLog storeLogs failed: ".concat(err_1));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.onPlayerError = function (evt) {
            var _a, _b, _c;
            _this.logInfoChange.code = (_c = (_b = (_a = evt.data) === null || _a === void 0 ? void 0 : _a.videoInfo) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.code;
            _this.storeLogs();
        };
        _this.config = __assign(__assign(__assign({}, DEFAULT_CONFIG), (opts || {})), _this.player.config.offlineConfig);
        _this.logger = new Logger(_this.instanceId, OfflineLogPlugin.pluginName);
        _this.initStorage();
        _this.logEnvInfo();
        _this.setPageWatcher();
        _this.setPlayerEvt();
        _this.checkWhiteList();
        return _this;
    }
    Object.defineProperty(OfflineLogPlugin, "isEnvSupport", {
        get: function () {
            return typeof window.Proxy === 'function';
        },
        enumerable: false,
        configurable: true
    });
    OfflineLogPlugin.prototype.destroy = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, , 2, 3]);
                        this.isDestroy = true;
                        this.setPollLogger(false);
                        this.setPageWatcher(false);
                        this.setPlayerEvt(false);
                        // 尝试在销毁前写入最后一些日志
                        return [4 /*yield*/, this.storeLogs({ clearContentCache: true })];
                    case 1:
                        // 尝试在销毁前写入最后一些日志
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        (_a = this.remoteStorage) === null || _a === void 0 ? void 0 : _a.destroy();
                        // 这里无论 defer 状态如何，reject 一下
                        this.storageDefer.reject();
                        _super.prototype.destroy.call(this);
                        return [7 /*endfinally*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 上报离线日志
     * @deprecated 粒度太粗，建议使用 reportLogs 接口
     * @param isForce 是否强制上报，在非白名单时，必须指定强制上报，否则什么也不做
     * @param from 用于管理台区分上报来源
     */
    OfflineLogPlugin.prototype.report = function (isForce, from, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 不是强制上报，也不在白名单中时，不上报数据
                        if (!isForce) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.remoteStorage.report({
                                // 白名单上报时，不要触发上报失败下载日志到本地逻辑
                                downloadOnFailed: isForce,
                                reportSource: from,
                                onlyCurrent: false,
                            }, onProgress)];
                    case 2:
                        _a.sent();
                        // 兼容老的接口调用
                        return [2 /*return*/, {
                                status: true,
                                msg: '',
                            }];
                    case 3:
                        err_2 = _a.sent();
                        return [2 /*return*/, {
                                status: false,
                                msg: err_2.message,
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 上报离线日志，默认上报当前播放的日志
     * @param config 日志上报配置
     * @param onProgress 上报进度回调函数
     */
    OfflineLogPlugin.prototype.reportLogs = function (config, onProgress) {
        return this.remoteStorage.report(__assign(__assign({}, DEFAULT_REPORT_OPTIONS), config), onProgress);
    };
    /**
     * 下载日志到本地
     */
    OfflineLogPlugin.prototype.downloadLogs = function () {
        return this.remoteStorage.downloadLogs();
    };
    /**
     * 打印一些环境相关信息放到 Logger 中
     * 每次 SessionStart 都打印一次，用于区隔播放列表中的播放项
     */
    OfflineLogPlugin.prototype.logEnvInfo = function () {
        try {
            this.logger.log("URL: ".concat(location.href));
            this.logger.log("TOP URL: ".concat(urlTool.getTopFrameUrl()));
            this.logger.log("Kernel List: ".concat(Object.keys(KernelFactory.kernelMap).join(',')));
            this.logger.log("PlayItem: ".concat(jsonTool.safelyStringify(this.player.currentPlayItem)));
        }
        catch (_a) {
            // do nothing
        }
    };
    /**
     * 创建 iframe 存储实例
     * 完成后开始轮询写日志
     */
    OfflineLogPlugin.prototype.initStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, loadStrategy, _c, iframePath, err_3;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.config, _b = _a.loadStrategy, loadStrategy = _b === void 0 ? offlineLogEagerLoadStrategy : _b, _c = _a.iframePath, iframePath = _c === void 0 ? RECORDER_DEPLOY_URL : _c;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        // 外部可配置的延迟加载策略，先等待它 resolve
                        return [4 /*yield*/, loadStrategy(this.player).promise];
                    case 2:
                        // 外部可配置的延迟加载策略，先等待它 resolve
                        _d.sent();
                        this.remoteStorage = new RemoteStorageBridge(iframePath, this.instanceId);
                        return [4 /*yield*/, RemoteStorageBridge.storageDefer.promise];
                    case 3:
                        _d.sent();
                        this.storageDefer.resolve();
                        // 如果在等待 ready 的过程中，有调用 destroy 方法，则不进行后续操作
                        if (this.isDestroy)
                            return [2 /*return*/];
                        this.downloadOnQuery();
                        this.setPollLogger();
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _d.sent();
                        this.storageDefer.reject(new StorageInitError((err_3 === null || err_3 === void 0 ? void 0 : err_3.message) || ''));
                        this.logger.error("Error occur when init DB: ".concat(err_3));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 当页面的 url 存在特定 query 参数，下载日志
     * 同时使用一个 static 变量保证这个自动下载的操作只进行一次
     */
    OfflineLogPlugin.prototype.downloadOnQuery = function () {
        var useDownload = location.search.includes(DOWNLOAD_LOGS_QUERY);
        // 如果没有下载过日志，且 url 中设置播放器创建后下载日志
        if (!OfflineLogPlugin.hasDownloadOnInit && useDownload) {
            // 则开始下载日志
            this.downloadLogs();
            // 并设置状态，防止重复下载
            OfflineLogPlugin.hasDownloadOnInit = true;
        }
    };
    /**
     * 校验白名单，如果命中白名单则调用白名单上报
     * 使用一个变量保证只获取一次白名单，且在白名单时仅上报一次
     */
    OfflineLogPlugin.prototype.checkWhiteList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var platform, whiteList, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        platform = this.config.platform;
                        // 如果已经获取过，则不再尝试获取
                        if (OfflineLogPlugin.whiteListLoadDefer)
                            return [2 /*return*/];
                        OfflineLogPlugin.whiteListLoadDefer = new SimpleDefer();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchWhiteList(platform)];
                    case 2:
                        whiteList = (_a.sent()).data;
                        // 把自定义的 JSON 上报配置取出来
                        OfflineLogPlugin.whiteList = whiteList;
                        OfflineLogPlugin.whiteListLoadDefer.resolve();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        OfflineLogPlugin.whiteListLoadDefer.reject();
                        this.logger.error("@OfflineLogPlugin.checkWhiteList(), err=".concat(err_4));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 设置 Logger 轮询，隔一段时间从 Logger 中获取日志并写入
     */
    OfflineLogPlugin.prototype.setPollLogger = function (enable) {
        if (enable === void 0) { enable = true; }
        var _a = this.config.pollTime, pollTime = _a === void 0 ? 3000 : _a;
        clearInterval(this.pollTimer);
        if (enable) {
            this.pollTimer = window.setInterval(this.storeLogs, pollTime);
        }
    };
    /** 添加监听，当页面 unload 或者 hide 时，把日志写入，防止日志丢失 */
    OfflineLogPlugin.prototype.setPageWatcher = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        var watcher = this.pageWatcher;
        var binder = isBind ? watcher.on.bind(watcher) : watcher.off.bind(watcher);
        binder(PageWatcher$1.PageWatcherEvent.PageLeave, this.onPageLeave);
        binder(PageWatcher$1.PageWatcherEvent.UNLOAD, this.onPageLeave);
    };
    /**
     * 监听播放器出错，出错时写入日志
     */
    OfflineLogPlugin.prototype.setPlayerEvt = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        var binder = isBind ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
        binder(PLAY_EVENT.ERROR, this.onPlayerError);
    };
    /**
     * GetInfo 出错时写入状态码，正常情况下写入视频标题
     */
    OfflineLogPlugin.prototype.hookVideoReqInfoEnd = function (param) {
        var _a, _b;
        var code = (_b = (_a = param.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code;
        if (code) {
            this.logInfoChange.code = code;
        }
        this.logInfoChange.videoName = this.player.dataset.commonMap.videoName;
        this.storeLogs();
    };
    /**
     * SessionStart 时先收集一次静态数据，打印环境信息
     */
    OfflineLogPlugin.prototype.hookPlaySessionStart = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logInfoChange = this.collectLogInfo();
                        this.logEnvInfo();
                        return [4 /*yield*/, this.storeLogs()];
                    case 1:
                        _a.sent();
                        // 查询自定义 json 白名单上报情况，命中则上报
                        this.triggerReportIfHit(0 /* PLAY_SESSION_START */);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 播放结束后收集播放状态码并存储
     */
    OfflineLogPlugin.prototype.hookPlaySessionEnd = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logInfoChange.code = param.code;
                        return [4 /*yield*/, this.storeLogs({ clearInfoCache: true })];
                    case 1:
                        _a.sent();
                        // 查询自定义 json 白名单上报情况，命中则上报
                        this.triggerReportIfHit(1 /* PLAY_SESSION_END */, param.code);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 检查自定义 JSON 上报白名单是否命中，如果命中了，则触发对应的上报规则
     */
    OfflineLogPlugin.prototype.triggerReportIfHit = function (hook, code) {
        return __awaiter(this, void 0, void 0, function () {
            var err_5, commonMap, conf;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // 先判断爬虫，如果是的话，不触发上报
                        // 或者 Defer 不知道怎么消失了，也不上报（逻辑有错误）
                        if (uaTool.spider || !OfflineLogPlugin.whiteListLoadDefer)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        // 等白名单拉下来
                        return [4 /*yield*/, OfflineLogPlugin.whiteListLoadDefer.promise];
                    case 2:
                        // 等白名单拉下来
                        _b.sent();
                        // 如果等到白名单拉下来了，插件被 destroy 了，没必要上报
                        if (this.isDestroy)
                            return [2 /*return*/];
                        return [3 /*break*/, 4];
                    case 3:
                        err_5 = _b.sent();
                        // 失败了，兜住错误
                        this.logger.error("@OfflineLogPlugin.triggerReportIfHitCustom(), err=".concat(err_5));
                        return [2 /*return*/];
                    case 4:
                        commonMap = this.player.dataset.commonMap;
                        conf = OfflineLogPlugin.whiteList
                            .filter(function (conf) { return conf.hook === hook; })
                            .find(function (conf) { return validateWhiteListItem(conf, __assign(__assign({}, commonMap), { code: code })); });
                        if (!(conf && Math.random() <= conf.rate)) return [3 /*break*/, 8];
                        _b.label = 5;
                    case 5:
                        _b.trys.push([5, 7, , 8]);
                        // 等 iframe 创建
                        return [4 /*yield*/, this.storageDefer.promise];
                    case 6:
                        // 等 iframe 创建
                        _b.sent();
                        // 开始上报
                        return [2 /*return*/, this.remoteStorage.report({
                                onlyCurrent: conf.action === 0 /* Single */,
                                downloadOnFailed: false,
                                reportSource: conf.reason || ReportSource.WHITE_LIST,
                            })];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 从数据中心收集本次播放的静态数据
     */
    OfflineLogPlugin.prototype.collectLogInfo = function () {
        var commonMap = this.player.dataset.commonMap;
        var guid = commonMap.guid, drm = commonMap.drm, videoName = commonMap.videoName, vid = commonMap.vid, hcVuserid = commonMap.hc_vuserid, flowid = commonMap.flowid, platform = commonMap.platform;
        return {
            code: '',
            drm: Boolean(drm),
            startTime: Date.now(),
            endTime: Date.now(),
            guid: guid,
            ua: navigator.userAgent,
            url: location.href,
            videoName: videoName,
            vid: vid,
            platform: platform,
            vuid: hcVuserid,
            instanceId: this.instanceId,
            id: flowid,
        };
    };
    Object.defineProperty(OfflineLogPlugin.prototype, "instanceId", {
        get: function () {
            // 注意：有可能被异步回调取值，如果此时插件销毁，会抛出异常，因此需要 optional
            return this.player.config.instanceId;
        },
        enumerable: false,
        configurable: true
    });
    OfflineLogPlugin.pluginName = 'offlineLog';
    /** 是否初始化时，就已经下载过日志，保证多个播放器时，不会重复下载日志 */
    OfflineLogPlugin.hasDownloadOnInit = false;
    /** 自定义 JSON 上报映射表，当 */
    OfflineLogPlugin.whiteList = [];
    return OfflineLogPlugin;
}(Plugin));
var DEFAULT_CONFIG = {
    platform: '1',
    disable: false,
    pollTime: 3000,
};
/** 离线日志 iframe 页部署地址，部署项目 https://git.woa.com/vfe/v.qq.com_static，默认 1h 强缓存 */
var RECORDER_DEPLOY_URL = 'https://v.qq.com/thumbplayer-offline-log.html?max_age=3600';
/** 播放器页面中，如果存在这个 query，则创建离线日志 iframe 时，自动下载日志到本地 */
var DOWNLOAD_LOGS_QUERY = 'thumbplayer_download_logs=1';

// 未赋值 priority 属性时，默认的 priority 优先级
var DEFAULT_PRIORITY = 0;
/* 默认结束事件 -> 正常结束 */
var DEFAULT_END_STATE = END_STATE.NORMAL;
// 默认播放时长边界，播放开始 startTime 不为负，播放 endTime 不作限制
var DEFAULT_PLAYTIME_BOUNDARY = {
    startTime: 0,
    startPriority: DEFAULT_PRIORITY,
    endTime: Infinity,
    endPriority: DEFAULT_PRIORITY,
    endState: END_STATE.NORMAL,
};
/** 内置校验规则，当设置 PlayTimeLimitConfig 时遍历所有规则校验，符合所有规则才会继续设置操作 */
var ruleValidator = {
    // 绕过类型系统，直接传入一个空的配置 null / undefined
    emptyConfigCheck: function (config) {
        if (!config)
            return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_EMPTY_CONFIG);
    },
    // 传入 {}
    emptyStartAndEndCheck: function (_a) {
        var startPoint = _a.startPoint, endPoint = _a.endPoint;
        if (!startPoint && !endPoint)
            return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_POINTS_BOTH_EMPTY);
    },
    // 传入的 startPoint.value < 0
    startBelowZero: function (_a) {
        var startPoint = _a.startPoint;
        if (startPoint && startPoint.value < 0) {
            return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_START_TIME_BELOW_ZERO);
        }
    },
    // 传入的 endPoint.value <= startPoint.value
    endBelowStart: function (_a) {
        var startPoint = _a.startPoint, endPoint = _a.endPoint;
        if (startPoint && endPoint && startPoint.value >= endPoint.value) {
            return t(i18nConfig.h5player.ERROR_PLAY_LIMIT_END_TIME_BELOW_START_TIME);
        }
    },
};
var CONFIG_ID_START = 0;

/**
 * 播放保护逻辑，可以不断向其添加时长限制，这些时长限制数组最终会合并成一个播放区间，
 * SuperPlayer 只会在这个区间时长内播放
 */
var PlaytimeLimiterPlugin = /** @class */ (function (_super) {
    __extends(PlaytimeLimiterPlugin, _super);
    function PlaytimeLimiterPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 时长配置校验规则
        _this.configRules = ruleValidator;
        // TimeRange ID 自增，该变量为下一个产生的 id 值
        _this.nextId = CONFIG_ID_START;
        // 所有添加进来的 PlayTimeLimitConfig 点配置
        _this.limitConfigMap = {};
        // 是否已经产生 CANPLAY 事件，起播前再去添加配置，记录下 SEEK 的时间，起播后 SEEK 到相应位置
        _this.isCanplayEmitted = false;
        // 记录的 SEEK 位置
        _this.canplaySeekPos = null;
        /**
         * 之前讨论过在 Core 中添加 endTime 动态修改不合适，因此结束相关逻辑放置到 playTimeLimiter 中
         * 监听播放器 TIME_UPDATE 事件，当播放时长 > 播放保护时长时，stop
         * @param playtime
         */
        _this.hookVideoTimeupdate = function (_a) {
            var playtime = _a.playtime;
            if (playtime < _this.range.endTime)
                return;
            if (_this.isUsingNativeLoop) {
                _this.player.seek(_this.range.startTime);
                return;
            }
            // TODO:补充只停止正片的接口
            _this.player.corePlayer.stop(_this.range.endState);
            // 避免执行player.stop以后还有后续的timeupdate事件监听回调继续执行。
            return EvtEmitter.STOP_IMMEDIATE_PROPAGATION;
        };
        /**
         * 当播放结束后，清理掉 getInfo 标志
         */
        _this.hookPlaySessionEnd = function () {
            _this.isCanplayEmitted = null;
            _this.canplaySeekPos = null;
        };
        return _this;
    }
    Object.defineProperty(PlaytimeLimiterPlugin.prototype, "isUsingNativeLoop", {
        // 原生loop模式
        get: function () {
            var _a = this.player.config, loop = _a.loop, loopMode = _a.loopMode;
            return loop && loopMode === VideoLoopMode.native;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlaytimeLimiterPlugin.prototype, "range", {
        get: function () {
            if (!this.limitRange) {
                this.limitRange = this.mergePlaytimeLimitConfigs(Object.values(this.limitConfigMap));
            }
            // 返回一个拷贝，防止外部意外修改
            return __assign({}, this.limitRange);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 添加播放保护规则，并更新最终可播放时长
     * @param limitConfig
     * @return id 播放保护规则 ID
     */
    PlaytimeLimiterPlugin.prototype.addLimitConfig = function (limitConfig) {
        var _a;
        // 先检查传入值的合法性
        if (!this.validatePlayTimeConfig(limitConfig)) {
            return null;
        }
        // 如果外部没有指定 id，则使用内置的规则自增 id
        var id = (_a = limitConfig.id) !== null && _a !== void 0 ? _a : this.generateID();
        // 当配置添加进来，添加上配置所对应的 vid，高层清理配置时需要用到
        this.limitConfigMap[id] = __assign(__assign({}, limitConfig), { vidOrUrl: this.player.vid || this.player.url });
        this.onConfigChange();
        // 返回 id
        return id;
    };
    /**
     * 根据传入的 ID，删除某一条播放保护规则
     * @param id 播放保护 ID
     */
    PlaytimeLimiterPlugin.prototype.deleteLimitConfig = function (id) {
        delete this.limitConfigMap[id];
        this.onConfigChange();
    };
    /**
     * 清理所有时长配置
     */
    PlaytimeLimiterPlugin.prototype.clearAllConfig = function (excludeVidOrUrl) {
        var _this = this;
        Object.entries(this.limitConfigMap)
            .forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value.vidOrUrl !== excludeVidOrUrl) {
                delete _this.limitConfigMap[key];
            }
        });
        this.limitRange = null;
    };
    /**
     * 通过 ID 获取对应的播放保护规则配置
     * @param id 播放保护规则 ID
     */
    PlaytimeLimiterPlugin.prototype.getLimitConfig = function (id) {
        return this.limitConfigMap[id];
    };
    /**
     * 根据 ID 重新设置某个播放保护规则配置
     * @param id 播放保护规则 ID
     * @param limitConfig 播放保护规则
     */
    PlaytimeLimiterPlugin.prototype.setLimitConfig = function (id, limitConfig) {
        if (!(this.getLimitConfig(id) && this.validatePlayTimeConfig(limitConfig)))
            return false;
        this.limitConfigMap[id] = limitConfig;
        this.onConfigChange();
        return true;
    };
    /** 播放保护规则的 ID 生成器，目前使用简单自增逻辑 */
    PlaytimeLimiterPlugin.prototype.generateID = function () {
        return this.nextId++;
    };
    /**
     * 检查设置的播放保护规则是否合规
     * @param limitConfig
     */
    PlaytimeLimiterPlugin.prototype.validatePlayTimeConfig = function (limitConfig) {
        var _this = this;
        return Object.values(this.configRules)
            .every(function (ruleFunc) {
            var err = ruleFunc(limitConfig);
            if (err) {
                _this.player.log(err);
                return false;
            }
            return true;
        });
    };
    /**
     * 合并所有已传入的 LimitConfig 信息，并根据范围 / 优先级情况，得到最终的播放范围
     * @param limitConfigs 需要合并的 LimitConfig 数组
     */
    PlaytimeLimiterPlugin.prototype.mergePlaytimeLimitConfigs = function (limitConfigs) {
        var _this = this;
        var mergeResult = __assign({}, DEFAULT_PLAYTIME_BOUNDARY);
        // 优先级高的配置点覆盖掉优先级低的配置，最终合并成一个 startTime + endTime 的配置结果
        limitConfigs.forEach(function (config) {
            var startPoint = config.startPoint, endPoint = config.endPoint;
            mergeResult = _this.mergeStartPoint(mergeResult, startPoint);
            mergeResult = _this.mergeEndPoint(mergeResult, endPoint);
        });
        // 返回最终合并结果
        return mergeResult;
    };
    /** 判断是否需要合并 StartPoint，返回合并后的 Range 或原值 */
    PlaytimeLimiterPlugin.prototype.mergeStartPoint = function (currMergeResult, startPoint) {
        if (this.shouldUpdateStartTime(currMergeResult, startPoint)) {
            return __assign(__assign({}, currMergeResult), { startTime: startPoint.value, startPriority: startPoint.priority || DEFAULT_PRIORITY });
        }
        return currMergeResult;
    };
    /**
     * 判断是否需要合并：
     * 1. 配置的 startTime 必须小于当前 mergeResult.endTime，否则合并出一个矛盾的配置
     * 2. 优先级更高的配置点: 高优先级配置覆盖
     * 3. 优先级相同，但 startTime > before: 合并产生一个更小的播放范围
     */
    PlaytimeLimiterPlugin.prototype.shouldUpdateStartTime = function (currMergeResult, startPoint) {
        if (!startPoint)
            return false;
        var value = startPoint.value, _a = startPoint.priority, priority = _a === void 0 ? DEFAULT_PRIORITY : _a;
        var currStartTime = currMergeResult.startTime, currStartPriority = currMergeResult.startPriority, currEndTime = currMergeResult.endTime;
        return value < currEndTime
            && (priority > currStartPriority || (priority === currStartPriority && value > currStartTime));
    };
    /** 判断是否需要合并 endPoint，返回合并后的 Range 或原值 */
    PlaytimeLimiterPlugin.prototype.mergeEndPoint = function (currMergeResult, endPoint) {
        if (this.shouldUpdateEndTime(currMergeResult, endPoint)) {
            return __assign(__assign({}, currMergeResult), { endTime: endPoint.value, endPriority: endPoint.priority || DEFAULT_PRIORITY, endState: endPoint.endState || DEFAULT_END_STATE });
        }
        return currMergeResult;
    };
    /**
     * 判断是否需要合并，规则类似
     * @see shouldUpdateStartTime
     */
    PlaytimeLimiterPlugin.prototype.shouldUpdateEndTime = function (currMergeResult, endPoint) {
        if (!endPoint)
            return false;
        var value = endPoint.value, _a = endPoint.priority, priority = _a === void 0 ? DEFAULT_PRIORITY : _a;
        var currStartTime = currMergeResult.startTime, currEndPriority = currMergeResult.endPriority, currEndTime = currMergeResult.endTime;
        return value > currStartTime
            && (priority > currEndPriority || (priority === currEndPriority && value < currEndTime));
    };
    /** 更新播放范围保护，重设缓存 */
    PlaytimeLimiterPlugin.prototype.onConfigChange = function () {
        this.limitRange = this.mergePlaytimeLimitConfigs(Object.values(this.limitConfigMap));
        // 如果播放器处于播放范围内播放，或者没有起播，则什么都不做
        if (this.player.playtime >= this.range.startTime)
            return;
        this.seekPlayer(this.range.startTime);
        // 返回一个拷贝防止意外修改
        return __assign({}, this.limitRange);
    };
    /** 当播放器第一次 CANPLAY 时，取出先前记下的 SEEK 时间并 SEEK */
    PlaytimeLimiterPlugin.prototype.hookVideoCanplay = function () {
        if (!this.isCanplayEmitted && this.canplaySeekPos) {
            this.player.seek(this.canplaySeekPos);
            this.canplaySeekPos = null;
        }
        this.isCanplayEmitted = true;
    };
    /** 根据情况 SEEK 播放器，如果当前状态下可以 SEEK 就去 SEEK，否则记下来等 CANPLAY 再去 SEEK */
    PlaytimeLimiterPlugin.prototype.seekPlayer = function (point) {
        if (this.isCanplayEmitted) {
            this.player.seek(this.canplaySeekPos);
        }
        else {
            this.canplaySeekPos = point;
        }
    };
    PlaytimeLimiterPlugin.pluginName = 'playtimeLimiter';
    return PlaytimeLimiterPlugin;
}(Plugin));

var report = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.url, url = _c === void 0 ? '' : _c, _d = _a.forceImage, forceImage = _d === void 0 ? false : _d;
    var payload = constructPayload(data);
    if (!forceImage && payload.length > MAX_LENGTH_OF_PAYLOAD) {
        netTool.xhr({
            method: 'POST',
            url: url,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: payload,
        }).catch(function () { });
        return;
    }
    var img = new Image();
    img.src = "".concat(url, "&").concat(payload);
};
var constructPayload = function (data) {
    if (data === void 0) { data = {}; }
    var encodedData = Object.keys(data).reduce(function (acc, cur) {
        var _a;
        acc[cur] = encodeURIComponent((_a = data[cur]) !== null && _a !== void 0 ? _a : '');
        return acc;
    }, { _dc: Math.random() });
    return urlTool.object2string(encodedData, '&');
};
var MAX_LENGTH_OF_PAYLOAD = 2048;

var BaseReporter = /** @class */ (function (_super) {
    __extends(BaseReporter, _super);
    function BaseReporter(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.RELEASE_DELAY = 300000;
        /** 上报请求方式 */
        _this.reporter = report;
        /** 已经上报的事件 */
        _this.reportedEvt = {};
        /** 本地ls的缓存key */
        _this.FLOW_DATA_KEY = '';
        /** 上报地址 */
        _this.REPORT_URL = '';
        /** 上报key(灯塔或其他sdk使用) */
        _this.REPORT_KEY = '';
        _this.config = config;
        return _this;
    }
    BaseReporter.prototype.saveToLS = function (key, data) {
        var prevData = this.getPrevData();
        prevData[key] = { data: data, ts: Date.now() };
        lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(prevData));
    };
    BaseReporter.prototype.removeFromLS = function (key) {
        var prevData = this.getPrevData();
        delete prevData[key];
        lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(prevData));
    };
    /** 从ls中提取缓存数据上报 */
    BaseReporter.prototype.reportPrev = function () {
        var _this = this;
        var prevData = this.getPrevData();
        Object.keys(prevData).forEach(function (key) {
            // check ts and report then delete
            if (prevData[key].ts + _this.RELEASE_DELAY < Date.now()) {
                _this.report(prevData[key].data);
                delete prevData[key];
            }
        });
        lsTool.setData(this.FLOW_DATA_KEY, JSON.stringify(prevData));
    };
    BaseReporter.prototype.report = function (data) {
        var _a;
        if (data === void 0) { data = {}; }
        if (uaTool.spider)
            return;
        var reportData = __assign(__assign({}, this.reportHeader), data);
        this.reporter({
            data: reportData,
            url: this.REPORT_URL,
            key: this.REPORT_KEY,
            forceImage: this.config.forceImage,
        });
        if (typeof ((_a = this.config) === null || _a === void 0 ? void 0 : _a.onAfterReport) === 'function') {
            try {
                this.config.onAfterReport(reportData);
            }
            catch (_b) { }
        }
    };
    BaseReporter.prototype.handlePageHide = function (lastData) {
        if (lastData === void 0) { lastData = {}; }
        if (uaTool.spider || !this.reporterForPageHide)
            return;
        var reportData = __assign(__assign({}, this.reportHeader), lastData);
        this.reporterForPageHide({
            data: reportData,
            url: this.REPORT_URL,
            key: this.REPORT_KEY,
        });
    };
    BaseReporter.prototype.getPrevData = function () {
        var prevDataString = lsTool.getData(this.FLOW_DATA_KEY) || '{}';
        var prevData;
        try {
            prevData = JSON.parse(prevDataString);
        }
        catch (e) {
            prevData = {};
        }
        return prevData;
    };
    BaseReporter.prototype.getKvWithDefault = function (key, defaultVal) {
        var getCommonKv = this.player.getCommonKv;
        return getCommonKv(key) || defaultVal;
    };
    return BaseReporter;
}(Plugin));

var VodQaReportBeaconAppKey = '0WEB0QEJW44KW5A5';
var LiveQaReportBeaconAppKey = '0WEB0CN7W9446C2I';
var VodQaReportCacheKey = '__thumbplayer_vod_qa_report__';
var BeaconSDKPath = 'https://beacon.cdn.qq.com/sdk/4.5.16/beacon_web.min.js';
var RequestMaxRetry = 3;

var BeaconRequest = /** @class */ (function () {
    function BeaconRequest() {
    }
    BeaconRequest.loadBeaconSDK = function () {
        var _this = this;
        if (typeof window.BeaconAction === 'function')
            return Promise.resolve();
        if (!BeaconRequest.sdkLoadingDefer) {
            BeaconRequest.sdkLoadingDefer = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var err, i, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < RequestMaxRetry)) return [3 /*break*/, 6];
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, domTool.loadScript(BeaconSDKPath)];
                        case 3:
                            _a.sent();
                            resolve();
                            return [3 /*break*/, 6];
                        case 4:
                            e_1 = _a.sent();
                            err = e_1;
                            return [3 /*break*/, 5];
                        case 5:
                            i++;
                            return [3 /*break*/, 1];
                        case 6:
                            reject(err);
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        return BeaconRequest.sdkLoadingDefer;
    };
    BeaconRequest.flushQueue = function (appKey) {
        // 避免意外情况，flush的时候依然没有实例
        if (!BeaconRequest.queues[appKey] || !BeaconRequest.instances[appKey])
            return;
        BeaconRequest.queues[appKey].forEach(function (param) {
            BeaconRequest.report(param);
        });
        BeaconRequest.queues[appKey] = [];
    };
    BeaconRequest.clear = function (appKey) {
        BeaconRequest.queues[appKey] = [];
    };
    /** 上报方法，会使用对应app key的灯塔实例 */
    BeaconRequest.report = function (param) {
        var data = param.data, appKey = param.key;
        var instance = BeaconRequest.instances[appKey];
        var stepname = (data || {}).stepname;
        if (!instance) {
            if (BeaconRequest.queues[appKey].length >= MAX_QUEUE_SIZE)
                BeaconRequest.clear(appKey);
            BeaconRequest.queues[appKey].push(param);
            return;
        }
        instance.onDirectUserAction(stepname, data);
    };
    /** pagehide上报方法，会使用对应app key的灯塔实例 */
    BeaconRequest.reportWhenPageHide = function (param) {
        var data = param.data, appKey = param.key;
        var instance = BeaconRequest.instances[appKey];
        var stepname = (data || {}).stepname;
        if (!instance) {
            return;
        }
        if (typeof instance.onSendBeacon === 'function') {
            instance.onSendBeacon(stepname, data);
            return;
        }
        instance.onDirectUserAction(stepname, data);
    };
    /** 注册一个新的app key */
    BeaconRequest.register = function (appConfig, externalBeacon) {
        return __awaiter(this, void 0, void 0, function () {
            var appKey, isOversea, BeaconAction, instance, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appKey = appConfig;
                        isOversea = false;
                        if (typeof appConfig === 'object') {
                            appKey = appConfig.appKey;
                            isOversea = !!appConfig.isOversea;
                        }
                        // 这里用queue是否被初始化作为标记，避免重复初始化
                        if (BeaconRequest.queues[appKey])
                            return [2 /*return*/];
                        BeaconRequest.queues[appKey] = [];
                        // 允许外部指定BeaconSDK的加载
                        if (externalBeacon)
                            BeaconRequest.sdkLoadingDefer = externalBeacon;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, BeaconRequest.loadBeaconSDK()];
                    case 2:
                        _a.sent();
                        BeaconRequest.sdkLoadingDefer = null;
                        return [4 /*yield*/, this.requireBeaconModule()];
                    case 3:
                        BeaconAction = _a.sent();
                        instance = new BeaconAction({
                            needQueryConfig: false,
                            appkey: appKey,
                            strictMode: false,
                            isOversea: isOversea,
                        });
                        BeaconRequest.instances[appKey] = instance;
                        BeaconRequest.flushQueue(appKey);
                        return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BeaconRequest.requireBeaconModule = function () {
        return requireModule(BEACON_MODULE_NAME, BEACON_GLOBAL_NAME);
    };
    BeaconRequest.instances = {};
    BeaconRequest.queues = {};
    return BeaconRequest;
}());
// Todo: 现在 Beacon SDK 还是个匿名包，后续改好这里也同步修改下
var BEACON_MODULE_NAME = 'BeaconAction';
var BEACON_GLOBAL_NAME = 'BeaconAction';
var MAX_QUEUE_SIZE = 30;

var getQQFromCookie = function () {
    var uin = cookieTool.get('luin') || cookieTool.get('uin');
    if (uin)
        uin = uin.replace(/\D/g, '').replace(/^0+/, '');
    return uin;
};
var BufferThresholds = 1.2 * 1e3;

/** 平台类型 */
var PlatCode;
(function (PlatCode) {
    PlatCode["Web"] = "web";
    PlatCode["H5"] = "h5";
})(PlatCode || (PlatCode = {}));
var DEFAULT_KEYS$1 = {
    cdnuip: '',
    iqq: '',
    pvid: '',
    qqopen_id: COMMON_DATA_KEY.hc_openid,
    playno: COMMON_DATA_KEY.flowid,
    cdnid: COMMON_DATA_KEY.cdnid,
    guid: COMMON_DATA_KEY.guid,
    fplayerver: COMMON_DATA_KEY.playerver,
    dsip: '',
    sstrength: '',
    devtype: '',
    nettype: '',
    freetype: '',
    platform: COMMON_DATA_KEY.platform,
    vplatform: COMMON_DATA_KEY.platform,
    codec: COMMON_DATA_KEY.codec,
    device: COMMON_DATA_KEY.device,
    resolution: COMMON_DATA_KEY.resolution,
    osver: COMMON_DATA_KEY.osver,
    playertype: COMMON_DATA_KEY.playertype,
    appver: COMMON_DATA_KEY.appVer,
    use_p2p: COMMON_DATA_KEY.p2p,
    p2p_play: COMMON_DATA_KEY.p2p,
    p2pver: COMMON_DATA_KEY.p2pver,
    playtype: '',
    scenesid: COMMON_DATA_KEY.sid,
    sid: COMMON_DATA_KEY.vid,
    livepid: COMMON_DATA_KEY.livepid,
    contentid: COMMON_DATA_KEY.cid,
    drm: COMMON_DATA_KEY.drmtype,
    videocapability: COMMON_DATA_KEY.videoCapability,
    playtime: '',
    isuserpay: '',
    live_type: '',
    xserverip: '',
    durl: '',
    lookback: '',
    live_tag: '',
    extraInfo: '',
    spanId: '',
    tuid: '',
    ext1: '',
    ext2: '',
    ext3: '',
};
var LiveQaReporterPlugin = /** @class */ (function (_super) {
    __extends(LiveQaReporterPlugin, _super);
    function LiveQaReporterPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.REPORT_KEY = LiveQaReportBeaconAppKey;
        /** 自增值 */
        _this.seq = 0;
        /** 上一个周期时的用户播放总时长 */
        _this.lastPlayDuration = 0;
        /** 缓冲记录 */
        _this.bufferHistory = [];
        _this.flowHeader = {
            cnntime: 0,
            maxspeed: 0,
            testspeed: 0,
            downspeed: 0,
            recnncount: 0,
            loadingtime: 0,
            blockcount: 0,
            blocktime: 0,
            errorcode: 0,
            geturltime: 0,
            fullecode: '',
            prdlength: 0,
            get_stream_data_duration: 0,
            get_sync_frame_duration: 0,
            live_delay: 0, // ts的PDT时间差
        };
        _this.isSettingLevel = false;
        /** 事件监听 */
        _this.setEvtHandler = function () {
            _this.msg.on(H5_EXT_EVENT.DATASET_STATE_UPDATE, _this.onStateChange);
            _this.player.on(PLAY_EVENT.RETRY_BACKURL, _this.onRetryUrl);
        };
        _this.onRetryUrl = function () {
            // 跳过下一次load上报
            _this.flowHeader.recnncount = _this.flowHeader.recnncount + 1;
        };
        /** 数据中心stateMap更新 */
        _this.onStateChange = function (evt) {
            var _a;
            var data = evt.data;
            var key = data.key;
            var handlers = (_a = {},
                _a[DATA_STATE.LOAD_END] = _this.onLoad,
                _a[DATA_STATE.BUFFER_END] = _this.onBuffer,
                _a[DATA_STATE.GET_INFO_END] = _this.onGetinfoEnd,
                _a[DATA_STATE.SET_LEVEL_START] = _this.onSetLevel,
                _a[DATA_STATE.SESSION_START] = _this.onSessionStart,
                _a[DATA_STATE.SESSION_END] = _this.onSessionEnd,
                _a[DATA_STATE.CODEC_DEGRADE] = _this.onCodecDegrade,
                _a);
            if (handlers[key])
                handlers[key](data);
        };
        _this.onSessionStart = function () {
            _this.resetLoopData();
            _this.seq = 0;
        };
        _this.onSessionEnd = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a;
            var code = newVal.code;
            _this.onPeriod({ code: code });
            _this.seq = 0;
            _this.endPeriodReport();
            _this.reportedEvt = {};
        };
        _this.startPeriodReport = function () {
            _this.endPeriodReport();
            _this.period = setInterval(_this.onPeriod, 60000);
        };
        _this.endPeriodReport = function () {
            if (_this.period) {
                clearInterval(_this.period);
                _this.period = null;
            }
        };
        _this.onSetLevel = function () {
            _this.isSettingLevel = true;
            _this.onPeriod();
            _this.endPeriodReport();
        };
        _this.onBuffer = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a, _b = data.startEvent, startEvent = _b === void 0 ? {} : _b;
            var etime = newVal.ftime;
            var stime = startEvent.ftime;
            // 1.2s以内的缓冲不记录
            if (etime - stime <= BufferThresholds)
                return;
            _this.bufferHistory.push({
                stime: stime,
                etime: etime,
            });
        };
        _this.onGetinfoEnd = function (data) {
            var newVal = data.newVal, startEvent = data.startEvent;
            var etime = newVal.ftime;
            var stime = startEvent.ftime;
            _this.flowHeader.geturltime = etime - stime;
        };
        _this.onCodecDegrade = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a;
            var etime = newVal.ftime, code = newVal.code;
            _this.report({
                step: 701 /* CODEC_DEGRADE */,
                stepname: "codec_degrade" /* CODEC_DEGRADE */,
                etime: etime,
                code: code,
            });
        };
        /** load事件回调 */
        _this.onLoad = function (data) {
            if (_this.reportedEvt[205 /* START */] && !_this.isSettingLevel)
                return;
            _this.reportedEvt[205 /* START */] = true;
            _this.isSettingLevel = false;
            var _a = data.startEvent, startEvent = _a === void 0 ? {} : _a, _b = data.newVal, newVal = _b === void 0 ? {} : _b;
            var code = newVal.code;
            // 这里数据中心会抛出一个load事件，如果有报错的话跳过这次上报等候error事件
            if (code !== ErrorCode.SUC)
                return;
            _this.flowHeader.loadingtime = newVal.ftime - startEvent.ftime;
            _this.flowHeader.errorcode = code;
            _this.flowHeader.fullecode = code;
            _this.report({
                step: 205 /* START */,
                stepname: "live_loading" /* START */,
                code: code,
            });
            _this.startPeriodReport();
        };
        /** 周期上报 */
        _this.onPeriod = function (error) {
            var _a = (error || { code: ErrorCode.SUC }).code, code = _a === void 0 ? ErrorCode.SUC : _a;
            // 计算本周期内的二次缓冲数据
            var _b = _this.bufferHistory.reduce(function (acc, cur) {
                var b = acc[0], bt = acc[1];
                var etime = cur.etime, stime = cur.stime;
                var duration = etime - stime;
                return [b + 1, bt + duration];
            }, [0, 0]), block = _b[0], blocktime = _b[1];
            // 计算本周期时长，正常为60s，打断为实际时长
            var prd = _this.player.dataset.getStats().playDuration;
            _this.flowHeader.blockcount = block;
            _this.flowHeader.blocktime = blocktime;
            _this.flowHeader.prdlength = prd - _this.lastPlayDuration;
            _this.flowHeader.errorcode = code;
            _this.flowHeader.fullecode = code;
            var rptData = {
                step: code === ErrorCode.SUC ? 263 /* LOOP */ : 150 /* ERROR */,
                stepname: code === ErrorCode.SUC ? "live_period" /* LOOP */ : "live_error" /* ERROR */,
                code: code,
            };
            _this.report(rptData);
            _this.resetLoopData();
            _this.lastPlayDuration = prd;
        };
        /** 重置一些状态 */
        _this.resetLoopData = function () {
            _this.bufferHistory = [];
            _this.flowHeader = __assign(__assign({}, _this.flowHeader), { blockcount: 0, blocktime: 0, errorcode: 0, loadingtime: 0, fullecode: '', prdlength: 0, recnncount: 0, downspeed: 0, live_delay: 0 });
        };
        var liveQaReporterConfig = player.config.liveQaReporterConfig;
        _this.config = {
            paramsKey: __assign(__assign({}, DEFAULT_KEYS$1), ((liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.paramsKey) || {})),
            onAfterReport: liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.onAfterReport,
            onBeforeReport: liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.onBeforeReport,
        };
        _this.setEvtHandler();
        // 初始化beacon sdk
        BeaconRequest.register({
            appKey: _this.REPORT_KEY,
            isOversea: !!(liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.isOversea),
        }, liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.externalBeaconDefer);
        _this.log("live-qa-reporter registered to ".concat(_this.REPORT_KEY, ", oversea: ").concat(!!(liveQaReporterConfig === null || liveQaReporterConfig === void 0 ? void 0 : liveQaReporterConfig.isOversea)));
        _this.reporter = BeaconRequest.report;
        return _this;
    }
    Object.defineProperty(LiveQaReporterPlugin.prototype, "reportHeader", {
        get: function () {
            var _a, _b;
            var _c = this.config.paramsKey, paramsKey = _c === void 0 ? {} : _c;
            var header = __assign({ videocapability: this.getKvWithDefault(paramsKey.videocapability, ''), cdnuip: this.getKvWithDefault(paramsKey.cdnuip, ''), iqq: this.getKvWithDefault(paramsKey.iqq, getQQFromCookie()), qqopen_id: this.getKvWithDefault(paramsKey.qqopen_id, ''), pvid: cookieTool.get('pgv_pvid') || '', playno: this.getKvWithDefault(paramsKey.playno, ''), cdnid: this.getKvWithDefault(paramsKey.cdnid, ''), guid: this.getKvWithDefault(paramsKey.guid, ''), fplayerver: this.getKvWithDefault(paramsKey.fplayerver, ''), dsip: this.getKvWithDefault(paramsKey.dsip, ''), sstrength: this.getKvWithDefault(paramsKey.sstrength, 0), devtype: this.getKvWithDefault(paramsKey.devtype, 0), nettype: this.getKvWithDefault(paramsKey.nettype, 100), codec: this.getKvWithDefault(paramsKey.codec, CODEC.H264), freetype: this.getKvWithDefault(paramsKey.freetype, 0), platform: this.getKvWithDefault(paramsKey.platform, ''), vplatform: this.getKvWithDefault(paramsKey.platform, ''), device: this.getKvWithDefault(paramsKey.device, ''), resolution: this.getKvWithDefault(paramsKey.resolution, ''), osver: this.getKvWithDefault(paramsKey.osver, ''), playertype: this.getKvWithDefault(paramsKey.playertype, 0), appver: this.getKvWithDefault(paramsKey.appver, ''), use_p2p: this.getKvWithDefault(paramsKey.use_p2p, 0), p2p_play: this.getKvWithDefault(paramsKey.p2p_play, 0), p2pver: this.getKvWithDefault(paramsKey.p2pver, ''), playtype: this.getKvWithDefault(paramsKey.playtype, 1), scenesid: this.getKvWithDefault(paramsKey.scenesid, 0), drm: this.getKvWithDefault(paramsKey.drm, 0), sid: this.getKvWithDefault(paramsKey.sid, 0), livepid: this.getKvWithDefault(paramsKey.livepid, 0), contentid: this.getKvWithDefault(paramsKey.contentid, 0), playtime: this.getKvWithDefault(paramsKey.playtime, 0), isuerpay: this.getKvWithDefault(paramsKey.isuserpay, 0), live_type: this.getKvWithDefault(paramsKey.live_type, 0), xserverip: this.getKvWithDefault(paramsKey.xserverip, ''), durl: this.getKvWithDefault(paramsKey.durl, ((_b = (_a = this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) === null || _b === void 0 ? void 0 : _b.loadingUrl) || ''), lookback: this.getKvWithDefault(paramsKey.lookback, 0), live_tag: this.getKvWithDefault(paramsKey.live_tag, 0), extraInfo: this.getKvWithDefault(paramsKey.extraInfo, ''), spanId: this.getKvWithDefault(paramsKey.spanId, ''), tuid: this.getKvWithDefault(paramsKey.tuid, ''), kernel: this.player.kernelName, plat_code: uaTool.mobile ? PlatCode.H5 : PlatCode.Web, domain: urlTool.getDomainOfURL(urlTool.getTopFrameUrl()), seq: this.seq, ext1: this.getKvWithDefault(paramsKey.ext1, ''), ext2: this.getKvWithDefault(paramsKey.ext2, ''), ext3: this.getKvWithDefault(paramsKey.ext3, '') }, this.flowHeader);
            return header;
        },
        enumerable: false,
        configurable: true
    });
    LiveQaReporterPlugin.prototype.destroy = function () {
        this.endPeriodReport();
        BeaconRequest.clear(this.REPORT_KEY);
        _super.prototype.destroy.call(this);
    };
    LiveQaReporterPlugin.prototype.report = function (data) {
        _super.prototype.report.call(this, data);
        this.seq = this.seq + 1;
    };
    /** 插件名 */
    LiveQaReporterPlugin.pluginName = 'live-qa-reporter';
    return LiveQaReporterPlugin;
}(BaseReporter));

var AdReportHelper = /** @class */ (function () {
    function AdReportHelper(reporter) {
        var _this = this;
        this.reportData = {};
        this.currentBufferHistory = [];
        // event handlers
        this.onStateChange = function (e) {
            var _a;
            var data = e.data;
            var newState = data.new, oldState = data.old;
            var handlerMap = (_a = {},
                _a[VIDEO_STATE.CANPLAY] = _this.onCanPlay,
                _a[VIDEO_STATE.BUFFERING] = _this.onBuffering,
                _a[VIDEO_STATE.END] = _this.onEnd,
                _a);
            if (handlerMap[newState]) {
                handlerMap[newState](e.data.videoInfo, oldState);
            }
        };
        this.onError = function (e) {
            var _a, _b;
            var data = e.data;
            var videoInfo = data.videoInfo;
            if (!videoInfo)
                return;
            var uid = videoInfo.uid, error = videoInfo.error;
            var record = _this.reportData[uid];
            if (!record) {
                return;
            }
            if (record.load >= 0) {
                _this.emitToMainReporter({
                    code: error.code,
                    step: '30',
                    stime: record.load,
                    stepname: STEP_NAME.FIRST_LOAD,
                    etime: Date.now(),
                    url: videoInfo.loadingUrl,
                    urlIndex: ((_b = (_a = videoInfo.config) === null || _a === void 0 ? void 0 : _a.backupUrls) === null || _b === void 0 ? void 0 : _b.findIndex(function (url) { return url === videoInfo.loadingUrl; })) || -1,
                }, record);
                record.load = -1;
            }
            _this.emitToMainReporter({
                step: '50',
                playDuration: videoInfo.playtime,
                code: error.code,
                stepname: STEP_NAME.END,
                tbcount: 0,
                tbduration: 0,
                scount: 0,
                etime: Date.now(),
                bcount: _this.currentBufferHistory.length,
                tduration: _this.currentBufferHistory.reduce(function (acc, cur) { return acc + (cur.etime - cur.stime); }, 0),
            }, record);
        };
        this.onFirstPlaying = function (e) {
            var data = e.data;
            var videoInfo = data.videoInfo;
            if (!videoInfo)
                return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                if (record.load >= 0) {
                    _this.reportFirstLoad(videoInfo, record);
                }
                var now = Date.now();
                var reportData = {
                    step: '32',
                    stepname: STEP_NAME.FIRST_RENDERING,
                    stime: now,
                    etime: now,
                    code: ErrorCode.SUC,
                };
                _this.emitToMainReporter(reportData, record);
                return;
            }
        };
        /**
         * 这里以videonode change作为加载的标志。如果此时视频已经预加载好了，会很快的再出发playing
         * 如果视频还需要加载，则从这个时间开始计算首缓，因为这是用户感知到的部分
         */
        this.onVideoNodeChange = function (e) {
            var data = e.data;
            var videoInfo = data.videoInfo;
            // 如果同一个video info已经被记录过了 则跳过
            if (!videoInfo || _this.reportData[videoInfo.uid])
                return;
            _this.reportData[videoInfo.uid] = {
                seq: 0,
                flowidSuffix: "_ad".concat(_this.getAdClipNumber()),
                load: Date.now(),
            };
        };
        // state handlers
        this.reportFirstLoad = function (videoInfo, record) {
            var _a, _b, _c, _d;
            var cachesize = (_b = (_a = _this.adPlayer.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.cacheSize) !== null && _b !== void 0 ? _b : 0;
            var reportData = {
                step: '30',
                stepname: STEP_NAME.FIRST_LOAD,
                stime: record.load,
                etime: Date.now(),
                url: videoInfo.loadingUrl,
                urlIndex: ((_d = (_c = videoInfo.config) === null || _c === void 0 ? void 0 : _c.backupUrls) === null || _d === void 0 ? void 0 : _d.findIndex(function (url) { return url === videoInfo.loadingUrl; })) || -1,
                code: ErrorCode.SUC,
                cachesize: cachesize,
            };
            _this.emitToMainReporter(reportData, record);
            record.load = -1;
            return;
        };
        this.onCanPlay = function (videoInfo) {
            if (!videoInfo)
                return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                if (record.load >= 0) {
                    _this.reportFirstLoad(videoInfo, record);
                    return;
                }
                if (record.buffer >= 0) {
                    var now = Date.now();
                    var stime = record.buffer;
                    record.buffer = -1;
                    if (now - stime <= 1200)
                        return;
                    _this.currentBufferHistory.push({ stime: stime, etime: Date.now() });
                    var reportData = {
                        step: '35',
                        stime: stime,
                        stepname: STEP_NAME.BUFFERING,
                        etime: Date.now(),
                        ptime: _this.adPlayer.playtime,
                        code: ErrorCode.SUC,
                    };
                    _this.emitToMainReporter(reportData, record);
                    return;
                }
            }
        };
        this.onEnd = function (videoInfo) {
            if (!videoInfo)
                return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                var reportData = {
                    step: '50',
                    playDuration: videoInfo.playtime,
                    code: ErrorCode.SUC,
                    stepname: STEP_NAME.END,
                    tbcount: 0,
                    tbduration: 0,
                    scount: 0,
                    etime: Date.now(),
                    bcount: _this.currentBufferHistory.length,
                    tduration: _this.currentBufferHistory.reduce(function (acc, cur) { return acc + (cur.etime - cur.stime); }, 0),
                };
                _this.emitToMainReporter(reportData, record);
            }
        };
        this.onBuffering = function (videoInfo) {
            if (!videoInfo)
                return;
            var record = _this.reportData[videoInfo.uid];
            if (record) {
                record.buffer = Date.now();
            }
        };
        this.reporterPlugin = reporter;
    }
    AdReportHelper.prototype.destroy = function () {
        this.unbindCoreEvents();
    };
    AdReportHelper.prototype.init = function (adPlayer, adType) {
        if (this.adPlayer) {
            this.unbindCoreEvents();
        }
        var vinfo = adPlayer.currentVideoInfo;
        if (!vinfo)
            return;
        this.adPlayer = adPlayer;
        this.adType = adType;
        this.bindCoreEvents();
        this.reportData = {};
        // 这里主要是第一次进来之后，loadstart已经开始了。
        this.reportData[vinfo.uid] = {
            seq: 0,
            flowidSuffix: "ad".concat(this.getAdClipNumber()),
            load: Date.now(),
        };
    };
    AdReportHelper.prototype.getAdClipNumber = function () {
        return Object.keys(this.reportData).length;
    };
    AdReportHelper.prototype.bindCoreEvents = function () {
        this.adPlayer.on(PLAY_EVENT.STATE_CHANGE, this.onStateChange);
        this.adPlayer.on(PLAY_EVENT.ERROR, this.onError);
        this.adPlayer.on(PLAY_EVENT.VIDEONODE_FIRST_PLAYING, this.onFirstPlaying);
        this.adPlayer.on(PLAY_EVENT.VIDEONODE_CHANGE, this.onVideoNodeChange);
    };
    AdReportHelper.prototype.unbindCoreEvents = function () {
        this.adPlayer.off(PLAY_EVENT.STATE_CHANGE, this.onStateChange);
        this.adPlayer.off(PLAY_EVENT.ERROR, this.onError);
        this.adPlayer.off(PLAY_EVENT.VIDEONODE_FIRST_PLAYING, this.onFirstPlaying);
        this.adPlayer.off(PLAY_EVENT.VIDEONODE_CHANGE, this.onVideoNodeChange);
    };
    // helper
    AdReportHelper.prototype.emitToMainReporter = function (data, record) {
        var payload = __assign(__assign({ code: ErrorCode.SUC }, data), { 
            // 这里在外部拼接到原flowid上
            flowid: record.flowidSuffix, seq: record.seq, scenesid: SCENES_ID[this.adType] || SCENES_ID.otherAd, duration: this.adPlayer.duration, kernel: this.adPlayer.kernelName, 
            // ! 这里把一些参数置空，防止取到header中的正片参数
            vid: '', fmt: '', rate: '', cdnid: '', cdnip: '', drm: '', definition: '', dltype: '' });
        record.seq += 1;
        this.reporterPlugin.emit('adReport', payload);
    };
    return AdReportHelper;
}());

var STEP_NAME;
(function (STEP_NAME) {
    STEP_NAME["INIT"] = "init_player";
    STEP_NAME["GETINFO"] = "get_cdn_url";
    STEP_NAME["FIRST_LOAD"] = "first_load";
    STEP_NAME["FIRST_RENDERING"] = "first_rendering";
    STEP_NAME["BUFFERING"] = "second_buffering";
    STEP_NAME["SEEKING"] = "user_seek";
    STEP_NAME["END"] = "play_done";
    STEP_NAME["CODEC_DEGRADE"] = "codec_degrade";
    /** 是否正在打开调试面板（检测到一次报一次） */
    STEP_NAME["DT_OPEN"] = "dt_open";
})(STEP_NAME || (STEP_NAME = {}));
// SCENES_ID: 400-500为Web侧预留
var SCENES_ID;
(function (SCENES_ID) {
    SCENES_ID[SCENES_ID["preAd"] = 400] = "preAd";
    SCENES_ID[SCENES_ID["ZT"] = 401] = "ZT";
    SCENES_ID[SCENES_ID["postAd"] = 402] = "postAd";
    SCENES_ID[SCENES_ID["otherAd"] = 403] = "otherAd";
    SCENES_ID[SCENES_ID["video"] = 421] = "video";
})(SCENES_ID || (SCENES_ID = {}));
var DEFAULT_KEYS = {
    platform: COMMON_DATA_KEY.platform,
    vplatform: COMMON_DATA_KEY.platform,
    flowid: COMMON_DATA_KEY.flowid,
    uin: '',
    QQopenid: COMMON_DATA_KEY.hc_openid,
    WXopenid: COMMON_DATA_KEY.hc_openid,
    logintype: COMMON_DATA_KEY.hc_main_login,
    guid: COMMON_DATA_KEY.guid,
    uip: '',
    cdnuip: COMMON_DATA_KEY.cdnuip,
    codec: COMMON_DATA_KEY.codec,
    cdnip: COMMON_DATA_KEY.cdnip,
    online: COMMON_DATA_KEY.online,
    p2p: COMMON_DATA_KEY.p2p,
    sstrength: COMMON_DATA_KEY.sstrength,
    network: COMMON_DATA_KEY.network,
    speed: COMMON_DATA_KEY.speed,
    device: COMMON_DATA_KEY.device,
    resolution: COMMON_DATA_KEY.resolution,
    testid: COMMON_DATA_KEY.testid,
    osver: COMMON_DATA_KEY.osver,
    p2pver: COMMON_DATA_KEY.p2pver,
    appver: COMMON_DATA_KEY.appVer,
    playerver: COMMON_DATA_KEY.playerver,
    playertype: COMMON_DATA_KEY.playertype,
    confid: COMMON_DATA_KEY.confid,
    cdnid: COMMON_DATA_KEY.cdnid,
    drm: COMMON_DATA_KEY.drmtype,
    scenesid: '',
    playtype: '',
    dltype: COMMON_DATA_KEY.dltype,
    vid: COMMON_DATA_KEY.vid,
    definition: COMMON_DATA_KEY.currentDefn,
    fmt: COMMON_DATA_KEY.fmt,
    rate: COMMON_DATA_KEY.rate,
    videocapability: COMMON_DATA_KEY.videoCapability,
    ckeytime: COMMON_DATA_KEY.ckeytime,
    ckeydg: COMMON_DATA_KEY.ckeydg,
    isad: '',
    duration: '',
    kernel: '',
    ext1: '',
    ext2: '',
    ext3: '',
};
/**
 * 飞天2.0 点播播放质量上报
 * https://iwiki.woa.com/pages/viewpage.action?pageId=40649252
 */
var VodQaReporterPlugin = /** @class */ (function (_super) {
    __extends(VodQaReporterPlugin, _super);
    function VodQaReporterPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.REPORT_KEY = VodQaReportBeaconAppKey;
        _this.FLOW_DATA_KEY = VodQaReportCacheKey;
        /** 自增值 */
        _this.seq = 0;
        /** 缓冲记录 */
        _this.bufferHistory = [];
        /** 用户拖拽记录 */
        _this.seekHistory = [];
        /** 整个流程中不会重写的字段（首次xxx） */
        _this.initData = {
            fmt: '',
            rate: '',
            cdnid: '',
        };
        /** 缓冲计数，切换清晰度后重置 */
        _this.bufferCount = 0;
        /** 拖拽计数，切换清晰度后重置 */
        _this.seekCount = 0;
        _this.adReportHelperInitTimeoutId = 0;
        /** 事件监听 */
        _this.setEvtHandler = function () {
            _this.msg.on(H5_EXT_EVENT.DATASET_STATE_UPDATE, _this.onStateChange);
            _this.player.on(PLAY_EVENT.SETLEVEL_OVER, function () {
                _this.bufferCount = 0;
                _this.seekCount = 0;
            });
            window.addEventListener('pagehide', _this.onPageHide);
        };
        _this.onPageHide = function () {
            _this.handlePageHide(_this.collectFinalData());
        };
        /** 数据中心stateMap更新 */
        _this.onStateChange = function (evt) {
            var _a;
            var data = evt.data;
            var key = data.key;
            var handlers = (_a = {},
                _a[DATA_STATE.INIT] = _this.onPlayerInit,
                _a[DATA_STATE.LOAD_END] = _this.onLoad,
                _a[DATA_STATE.BUFFER_END] = _this.onBuffer,
                _a[DATA_STATE.GET_INFO_END] = _this.onGetinfoEnd,
                _a[DATA_STATE.SEEK_END] = _this.onSeek,
                _a[DATA_STATE.SESSION_END] = _this.onPlaySessionEnd,
                _a[DATA_STATE.FIRST_PLAY] = _this.onFirstPlay,
                _a[DATA_STATE.SESSION_START] = _this.reset,
                _a[DATA_STATE.CODEC_DEGRADE] = _this.onCodecDegrade,
                _a[DATA_STATE.RETRY_BACKURL] = function () {
                    _this.bufferCount = 0;
                    _this.seekCount = 0;
                },
                _a[DATA_STATE.DT_OPEN] = _this.onDtOpen,
                _a);
            if (handlers[key])
                handlers[key](data);
        };
        _this.onPlayerInit = function (data) {
            var newVal = data.newVal;
            var ftime = newVal.ftime, _a = newVal.ext, ext = _a === void 0 ? {} : _a;
            var stime = ext.stime;
            _this.report({
                stepname: STEP_NAME.INIT,
                step: "5" /* INIT */,
                stime: stime,
                etime: ftime,
                code: ErrorCode.SUC,
            });
        };
        /** step15: 获取CDN地址 结束并上报 */
        _this.onGetinfoEnd = function (data) {
            var newVal = data.newVal, startEvent = data.startEvent;
            var etime = newVal.ftime, code = newVal.code;
            var stime = startEvent.ftime;
            _this.report({
                stepname: STEP_NAME.GETINFO,
                step: "15" /* GETINFO */,
                stime: stime,
                etime: etime,
                code: code,
            });
        };
        /** step30: 视频首次加载 */
        _this.onLoad = function (data) {
            var _a;
            var _b = data.newVal, newVal = _b === void 0 ? {} : _b, _c = data.startEvent, startEvent = _c === void 0 ? {} : _c;
            var _d = newVal, etime = _d.ftime, currentUrl = _d.currentUrl, urlIndex = _d.urlIndex, code = _d.code, ext = _d.ext;
            // 广告过程中加载耗时设置为 0
            var stime = (ext === null || ext === void 0 ? void 0 : ext.isAdPlaying) ? etime : startEvent.ftime;
            // !FIXME: 这里比较尴尬，由于初始化时序的问题，只能从config上通过引用获取到值
            var videoUrl = ((_a = _this.player.config.vodQaReporterConfig) === null || _a === void 0 ? void 0 : _a.obfuscate)
                ? urlTool.obfuscatePathComponent(currentUrl)
                : currentUrl;
            _this.report({
                stepname: STEP_NAME.FIRST_LOAD,
                step: "30" /* FIRST_LOAD */,
                stime: stime,
                etime: etime,
                url: videoUrl || '',
                urlindex: urlIndex + 1,
                fileopenedtime: 0,
                firstpacketreadtime: 0,
                ext1: _this.player.getCommonKv(COMMON_DATA_KEY.isPreload) || 0,
                ext2: Number(ext === null || ext === void 0 ? void 0 : ext.isAdPlaying),
                code: code,
            });
        };
        /** step32 首帧渲染 */
        _this.onFirstPlay = function () {
            if (_this.reportedEvt[STEP_NAME.FIRST_RENDERING])
                return;
            _this.reportedEvt[STEP_NAME.FIRST_RENDERING] = true;
            var now = +new Date();
            _this.report({
                step: "32" /* FIRST_RENDERING */,
                stepname: STEP_NAME.FIRST_RENDERING,
                stime: now,
                etime: now,
                code: ErrorCode.SUC,
            });
        };
        /** step35 二次缓冲 */
        _this.onBuffer = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a, _b = data.startEvent, startEvent = _b === void 0 ? {} : _b;
            var etime = newVal.ftime, ptime = newVal.playtime, currentUrl = newVal.currentUrl, code = newVal.code;
            var stime = startEvent.ftime, prevState = startEvent.prevState;
            var levent = prevState === VIDEO_STATE.SEEKING ? 1 : 0; // seek触发为1，其他为0
            var scene = _this.player.playbackRate > 1 ? 2 : 1;
            // 1.2s以内的缓冲不记录
            if (etime - stime <= BufferThresholds)
                return;
            _this.bufferHistory.push({
                stime: stime,
                etime: etime,
            });
            if (_this.bufferCount < 20) {
                _this.report({
                    step: "35" /* BUFFERING */,
                    stepname: STEP_NAME.BUFFERING,
                    ptime: ptime,
                    levent: levent,
                    stime: stime,
                    etime: etime,
                    scene: scene,
                    format: _this.player.getCommonKv(_this.config.paramsKey.fmt) || 0,
                    url: currentUrl || '',
                    reason: 0,
                    code: code,
                    vt: _this.player.getCommonKv(_this.config.paramsKey.cdnid) || 0,
                });
                _this.bufferCount += 1;
            }
        };
        /** step40 用户拖拽 */
        _this.onSeek = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a, _b = data.startEvent, startEvent = _b === void 0 ? {} : _b;
            var letime = newVal.ftime, petime = newVal.playtime, code = newVal.code, _c = newVal.ext, ext = _c === void 0 ? {} : _c;
            var lstime = startEvent.ftime, pstime = startEvent.playtime;
            if (!ext.isUserSeek)
                return;
            _this.seekHistory.push({
                lstime: lstime,
                letime: letime,
            });
            if (_this.seekCount < 20) {
                _this.report({
                    step: "40" /* SEEKING */,
                    stepname: STEP_NAME.SEEKING,
                    lstime: lstime,
                    letime: letime,
                    pstime: pstime,
                    petime: petime,
                    format: _this.player.getCommonKv(_this.config.paramsKey.fmt) || 0,
                    code: code,
                });
                _this.seekCount += 1;
            }
        };
        _this.onPlaySessionEnd = function (data) {
            if (_this.reportedEvt[STEP_NAME.END])
                return;
            _this.reportedEvt[STEP_NAME.END] = true;
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a;
            var ftime = newVal.ftime, code = newVal.code;
            var playduration = _this.player.dataset.getStats().playDuration;
            var ignoreErrorCode = [
                // 服务端错误
                code.indexOf(ErrorCode.GETINFO_SERVER_CODE_PREFIX) === 0,
                // getinfo插件相关错误
                code.indexOf('70014') === 0,
                // 广告及未知错误
                code.indexOf('7004') === 0,
                // 传参错误
                code === '70011112',
                code === '70011113',
            ].some(function (i) { return i; });
            var finalCode = ignoreErrorCode ? ErrorCode.SUC : code;
            _this.report(__assign(__assign({ step: "50" /* END */, stepname: STEP_NAME.END, etime: ftime, playduration: playduration, code: finalCode }, _this.seekStat), _this.bufferStat));
            _this.removeFromLS(_this.player.getCommonKv(COMMON_DATA_KEY.flowid));
            _this.seq = 0;
        };
        _this.onCodecDegrade = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a;
            var etime = newVal.ftime, code = newVal.code;
            _this.report({
                step: "701" /* CODEC_DEGRADE */,
                stepname: STEP_NAME.CODEC_DEGRADE,
                etime: etime,
                code: code,
            });
        };
        _this.onDtOpen = function (data) {
            var _a = data.newVal, newVal = _a === void 0 ? {} : _a;
            var stime = newVal.ftime, code = newVal.code;
            _this.report({
                step: "702" /* DT_OPEN */,
                stepname: STEP_NAME.DT_OPEN,
                stime: stime,
                etime: +new Date(),
                code: code,
            });
        };
        _this.onInit = function () {
            _this.reportPrev(); // 上报缓存的step50事件
        };
        _this.collectFinalData = function () {
            var now = +new Date();
            var flowid = _this.player.getCommonKv(COMMON_DATA_KEY.flowid);
            if (!flowid || _this.reportedEvt[STEP_NAME.END])
                return;
            var playduration = _this.player.dataset.getStats().playDuration;
            var data = __assign(__assign({ step: "50" /* END */, stepname: STEP_NAME.END, etime: now, code: ErrorCode.SUC, // 这里的错误码一定是0，否则就是在onerror处理
                playduration: playduration }, _this.seekStat), _this.bufferStat);
            return data;
        };
        _this.reset = function () {
            _this.reportedEvt = {};
            _this.initData.fmt = '';
            _this.initData.rate = '';
            _this.initData.cdnid = '';
            _this.bufferHistory = [];
            _this.seekHistory = [];
            _this.bufferCount = 0;
            _this.seekCount = 0;
        };
        var vodQaReporterConfig = player.config.vodQaReporterConfig;
        _this.config = __assign(__assign({}, vodQaReporterConfig), { paramsKey: __assign(__assign({}, DEFAULT_KEYS), ((vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.paramsKey) || {})), onAfterReport: vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.onAfterReport, onBeforeReport: vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.onBeforeReport });
        _this.setEvtHandler();
        // 初始化beacon sdk
        BeaconRequest.register({
            appKey: _this.REPORT_KEY,
            isOversea: !!(vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.isOversea),
        }, vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.externalBeaconDefer);
        _this.log("vod-qa-reporter registered to ".concat(_this.REPORT_KEY, ", oversea: ").concat(!!(vodQaReporterConfig === null || vodQaReporterConfig === void 0 ? void 0 : vodQaReporterConfig.isOversea)));
        _this.reporter = BeaconRequest.report;
        _this.reporterForPageHide = BeaconRequest.reportWhenPageHide;
        _this.onInit();
        // 初始化广告上报
        _this.adReportHelper = new AdReportHelper(_this);
        _this.player.on(H5_PLAY_EVENT.AD_REQ_ASSETS_START, function (_a) {
            var data = _a.data;
            _this.adReportHelperInitTimeoutId = window.setTimeout(function () {
                var _a;
                var adPlugin = getAdPlugin(player === null || player === void 0 ? void 0 : player.config.instanceId);
                var adPlayer = (_a = adPlugin === null || adPlugin === void 0 ? void 0 : adPlugin.getPlayerInstance) === null || _a === void 0 ? void 0 : _a.call(adPlugin, data.adType);
                // ! 只支持特定的广告插件。
                if (!adPlayer)
                    return;
                _this.adReportHelper.init(adPlayer, data.adType);
            });
        });
        _this.on('adReport', function (payload) {
            _super.prototype.report.call(_this, __assign(__assign({}, payload.data), { flowid: "".concat(_this.reportHeader.flowid, "_").concat(payload.data.flowid), isad: 1 }));
        });
        return _this;
    }
    Object.defineProperty(VodQaReporterPlugin.prototype, "seekStat", {
        /** 拖拽总计数据 */
        get: function () {
            var _a = this.seekHistory.reduce(function (acc, cur) {
                var count = acc[0], duration = acc[1];
                var wait = cur.letime - cur.lstime;
                // 1200ms以下的不计入拖动缓冲
                if (wait > BufferThresholds) {
                    return [count + 1, duration + wait];
                }
                return acc;
            }, [0, 0]), tbcount = _a[0], tbduration = _a[1];
            return { tbcount: tbcount, tbduration: tbduration, scount: this.seekHistory.length };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VodQaReporterPlugin.prototype, "bufferStat", {
        /** 缓冲总计数据 */
        get: function () {
            var tduration = this.bufferHistory.reduce(function (acc, cur) { return acc + (cur.etime - cur.stime); }, 0);
            return { tduration: tduration, bcount: this.bufferHistory.length };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VodQaReporterPlugin.prototype, "reportHeader", {
        get: function () {
            var _this = this;
            var _a;
            var paramsKey = this.config.paramsKey;
            var _b = this.player.dataset.getStats(), averageDecodeTimeInMs = _b.averageDecodeTimeInMs, frameDroppedInPercentage = _b.frameDroppedInPercentage;
            Object.entries(this.initData).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (!value) {
                    _this.initData[key] = _this.getKvWithDefault(paramsKey[key], '');
                }
            });
            var header = {
                videocapability: this.getKvWithDefault(paramsKey.videocapability, ''),
                platform: this.getKvWithDefault(paramsKey.platform, ''),
                vplatform: this.getKvWithDefault(paramsKey.platform, ''),
                flowid: this.getKvWithDefault(paramsKey.flowid, ''),
                uin: this.getKvWithDefault(paramsKey.uin, getQQFromCookie()),
                QQopenid: this.getKvWithDefault(paramsKey.QQopenid, ''),
                WXopenid: this.getKvWithDefault(paramsKey.WXopenid, ''),
                logintype: this.getKvWithDefault(paramsKey.logintype, 0),
                guid: this.getKvWithDefault(paramsKey.guid, ''),
                uip: this.getKvWithDefault(paramsKey.uip, ''),
                cdnuip: this.getKvWithDefault(paramsKey.cdnuip, ''),
                cdnip: this.getKvWithDefault(paramsKey.cdnip, ''),
                online: this.getKvWithDefault(paramsKey.online, 1),
                p2p: this.getKvWithDefault(paramsKey.p2p, 0),
                sstrength: this.getKvWithDefault(paramsKey.sstrength, 0),
                network: this.getKvWithDefault(paramsKey.network, 0),
                speed: this.getKvWithDefault(paramsKey.speed, 0),
                device: this.getKvWithDefault(paramsKey.device, ''),
                resolution: this.getKvWithDefault(paramsKey.resolution, ''),
                testid: this.getKvWithDefault(paramsKey.testid, 0),
                codec: this.getKvWithDefault(paramsKey.codec, CODEC.H264),
                osver: this.getKvWithDefault(paramsKey.osver, ''),
                p2pver: this.getKvWithDefault(paramsKey.p2pver, ''),
                appver: this.getKvWithDefault(paramsKey.appver, ''),
                playerver: this.getKvWithDefault(paramsKey.playerver, ''),
                confid: this.getKvWithDefault(paramsKey.confid, 0),
                playertype: this.getKvWithDefault(paramsKey.playertype, 0),
                cdnid: this.initData.cdnid,
                scenesid: this.getKvWithDefault(paramsKey.scenesid, SCENES_ID.video),
                playtype: 0,
                dltype: this.getKvWithDefault(paramsKey.dltype, 0),
                vid: this.getKvWithDefault(paramsKey.vid, ''),
                fmt: this.initData.fmt,
                rate: this.initData.rate,
                drm: this.getKvWithDefault(paramsKey.drm, 0),
                definition: this.getKvWithDefault(paramsKey.definition, ''),
                duration: Math.round(this.getKvWithDefault(paramsKey.duration, this.player.duration)),
                seq: this.seq,
                kernel: (_a = this.player.kernelName) !== null && _a !== void 0 ? _a : 'unknown',
                domain: urlTool.getDomainOfURL(urlTool.getTopFrameUrl()),
                isad: 0,
                ext1: this.getKvWithDefault(paramsKey.ext1, ''),
                ext2: this.getKvWithDefault(paramsKey.ext2, ''),
                ext3: this.getKvWithDefault(paramsKey.ext3, ''),
                ckeytime: this.getKvWithDefault(paramsKey.ckeytime, -1),
                ckeydg: this.getKvWithDefault(paramsKey.ckeydg, 0),
                framedrop: frameDroppedInPercentage,
                avgdecodecost: averageDecodeTimeInMs,
                deved: this.getKvWithDefault(COMMON_DATA_KEY.deved, 0),
                vuid: this.getKvWithDefault(COMMON_DATA_KEY.hc_vuserid, ''),
                cid: this.getKvWithDefault(COMMON_DATA_KEY.cid, ''),
                ip: this.getKvWithDefault(COMMON_DATA_KEY.hh_ip, ''),
                devicescore: this.getKvWithDefault(COMMON_DATA_KEY.deviceScore, 0),
            };
            return header;
        },
        enumerable: false,
        configurable: true
    });
    VodQaReporterPlugin.prototype.destroy = function () {
        if (this.adReportHelperInitTimeoutId > 0) {
            window.clearTimeout(this.adReportHelperInitTimeoutId);
            this.adReportHelperInitTimeoutId = 0;
        }
        window.removeEventListener('pagehide', this.onPageHide);
        BeaconRequest.clear(this.REPORT_KEY);
        _super.prototype.destroy.call(this);
    };
    VodQaReporterPlugin.prototype.report = function (data) {
        _super.prototype.report.call(this, data);
        this.seq = this.seq + 1;
    };
    /** 插件名 */
    VodQaReporterPlugin.pluginName = 'vod-qa-reporter';
    return VodQaReporterPlugin;
}(BaseReporter));

var OFFICIAL_PLUGIN = {
    "VOD_FLOW_REPORTER": "vod-flow-reporter",
    "LIVE_FLOW_REPORTER": "live-flow-reporter",
    "GETINFO_LIVE": "getinfo-live",
    "GETINFO_VOD": "getinfo-vod",
    "GETINFO_TC": "getinfo-tc",
    "BARRAGE": "barrage",
    "MARKID": "markid",
    "CONTEXT_MENU": "context-menu",
    "WATERMARK": "ui-watermark",
    "UI_PREVIEW": "ui-preview",
    "UI_PREVIEW_LIST": "ui-preview-list",
    "POLL_DURATION": "poll-duration",
    "REPORTERS": "reporters",
    "UI_ROLE_FILTER": "ui-role-filter",
    "SETTING_BTN": "setting-btn",
    "CTRLBAR": "ctrlbar",
    "ERROR_PAGE": "error-page",
    "FULLSCREEN_RATIO": "fullscreen-ratio",
    "INFO_PANEL": "info-panel",
    "LIVE_POLL": "live-poll",
    "POSTER": "poster",
    "SUBTITLE": "subtitle",
    "TIPS": "tips",
    "UI_LOADING": "ui-loading",
    "VR": "vr",
    "TVK_UTILS": "tvk-utils",
    "UNMUTE_BTN": "unmute-btn"
};
var PLUGIN_MAP = {
    "vod-flow-reporter": {
        "cdnPath": "thumbplayer-plugin-atta-reporter",
        "version": "1.4.104"
    },
    "live-flow-reporter": {
        "cdnPath": "thumbplayer-plugin-atta-reporter",
        "version": "1.4.104"
    },
    "getinfo-live": {
        "pluginName": "__thumbplayer-video-request",
        "version": "1.4.133"
    },
    "getinfo-vod": {
        "pluginName": "__thumbplayer-video-request",
        "version": "1.4.133"
    },
    "getinfo-tc": {
        "pluginName": "__thumbplayer-video-request",
        "version": "1.4.125"
    },
    "barrage": {
        "pluginName": "Barrage",
        "version": "1.4.133"
    },
    "markid": {
        "pluginName": "ui-markid",
        "version": "1.4.133"
    },
    "context-menu": {
        "cdnPath": "thumbplayer-plugin-ui-contextmenu",
        "version": "1.4.133"
    },
    "ui-preview-list": {
        "cdnPath": "thumbplayer-plugin-ui-preview",
        "version": "1.4.133"
    },
    "ui-preview": {
        "cdnPath": "thumbplayer-plugin-ui-preview",
        "version": "1.4.133"
    },
    "ui-watermark": {
        "cdnPath": "thumbplayer-plugin-watermark",
        "version": "1.4.133"
    },
    "poll-duration": {
        "version": "1.4.133"
    },
    "reporters": {
        "version": "1.4.133"
    },
    "ui-role-filter": {
        "version": "1.4.133"
    },
    "setting-btn": {
        "version": "1.4.133"
    },
    "ctrlbar": {
        "version": "1.4.133"
    },
    "error-page": {
        "version": "1.4.133"
    },
    "fullscreen-ratio": {
        "version": "1.4.133"
    },
    "info-panel": {
        "version": "1.4.133"
    },
    "live-poll": {
        "version": "1.4.104"
    },
    "poster": {
        "version": "1.4.133"
    },
    "subtitle": {
        "version": "1.4.133"
    },
    "tips": {
        "version": "1.4.133"
    },
    "ui-loading": {
        "version": "1.4.133"
    },
    "vr": {
        "version": "1.4.133"
    },
    "tvk-utils": {
        "version": "1.4.133"
    },
    "unmute-btn": {
        "version": "1.4.133"
    }
};

var H5_PAUSE_TYPE;
(function (H5_PAUSE_TYPE) {
    H5_PAUSE_TYPE["USER_CLICK"] = "user-click";
})(H5_PAUSE_TYPE || (H5_PAUSE_TYPE = {}));
var AUTO_PLAY_POLICY;
(function (AUTO_PLAY_POLICY) {
    /** 当自动播放被浏览器阻止以后，尝试静音播放 */
    AUTO_PLAY_POLICY["IN_MUTED"] = "autoPlayInMuted";
    /** 自动播放一定需要用户手势 */
    AUTO_PLAY_POLICY["USER_GESTURE"] = "autoPlayRequireByUserGesture";
})(AUTO_PLAY_POLICY || (AUTO_PLAY_POLICY = {}));
var PictureDirection;
(function (PictureDirection) {
    PictureDirection["NORMAL"] = "normal";
    PictureDirection["VERTICAL"] = "vertical";
    PictureDirection["HORIZON"] = "horizon";
})(PictureDirection || (PictureDirection = {}));
var VideoLoopMode;
(function (VideoLoopMode) {
    VideoLoopMode["native"] = "native";
    VideoLoopMode["replay"] = "replay";
})(VideoLoopMode || (VideoLoopMode = {}));

/**
 * 自动播放重试逻辑
 * 当收到 Core 的自动播放被阻止事件时，根据配置来执行静音自动播放重试策略
 * 并抛出对应的自动播放事件（静音自动播放起播 / 自动播放失败）
 */
var AutoPlayLogics = /** @class */ (function () {
    function AutoPlayLogics(player) {
        var _this = this;
        this.hasRetried = false;
        /** 进行静音起播重试前的静音状态，当自动播放失败时一起带出去，以便外部有手势操作时，顺便恢复到静音前的状态 */
        this.mutedBefore = false;
        this.onPlaySessionStart = function () {
            _this.mutedBefore = _this.player.muted;
            _this.hasRetried = false;
            _this.cancelRetryCallback();
        };
        this.onAdAutoPlayBlocked = function () {
            clearTimeout(_this.adBlockTimer);
            // 因为广告节点内部是在play后监听到blocked时回退到preload状态的，执行时机比这里慢 所以setTimeout延迟一下
            _this.adBlockTimer = setTimeout(function () {
                _this.onAutoPlayBlocked();
            });
        };
        /**
         * 当自动播放被阻止时，进行重试 / 抛出失败事件
         */
        this.onAutoPlayBlocked = function () {
            var _a;
            // 如果策略允许静音重试起播，且没有重试过，则开始重试静音起播
            if (_this.allowRetry) {
                _this.hasRetried = true;
                // 设置播放器 & 广告静音
                _this.player.muted = true;
                try {
                    (_a = getAdPlugin(_this.player.config.instanceId)) === null || _a === void 0 ? void 0 : _a.setAdVolume(0);
                }
                catch (e) {
                    _this.logger.error('call @adPlugin.setAdVolume()', e);
                }
                // 重试起播
                _this.player.play();
                _this.logger.log('@onAutoPlayBlocked(), using AUTOPLAY_IN_MUTE policy...');
                // 添加事件监听，当真的起播的时候，抛出静音起播事件
                _this.player.once(H5_PLAY_EVENT.VIDEO_PLAYING, _this.onVideoPlayingOnMuteRetry);
                _this.player.once(H5_PLAY_EVENT.AD_PLAYING, _this.onVideoPlayingOnMuteRetry);
                return;
            }
            // 否则，一定需要用户手势才能够起播，抛出失败事件
            var blockedByBrowser = _this.shouldMuteRetry;
            var reason = blockedByBrowser
                ? h5playerI18nConfig.ERROR_AUTOPLAY_FAILED_BROWSER
                : h5playerI18nConfig.ERROR_AUTOPLAY_FAILED_CONFIG;
            _this.player.pluginMsg.emit(H5_EXT_EVENT.AUTOPLAY_FAILED, {
                mutedBefore: _this.mutedBefore,
                blockedByBrowser: blockedByBrowser,
                reason: reason,
            });
            _this.logger.warn("@onAutoPlayBlocked(), autoplay failed: ".concat(reason));
            // 取消掉事件监听
            _this.cancelRetryCallback();
        };
        /**
         * 使用静音策略重试自动播放成功
         */
        this.onVideoPlayingOnMuteRetry = function () {
            _this.logger.log('@onVideoPlayingOnMuteRetry(), AUTOPLAY_IN_MUTE retry successfully.');
            var muted = _this.player.muted;
            // 重试成功了，还需要额外判断下当前静音状态，防止重试中有用户手势介入
            // 比如 BLOCK->PLAYING 期间用户点了静音按钮给取消掉了
            if (muted) {
                _this.player.pluginMsg.emit(H5_EXT_EVENT.AUTOPLAY_IN_MUTED, { muted: muted, mutedBefore: _this.mutedBefore });
            }
            // 函数被调用有两个入口，这里任意一个入口触发后，要把另一个入口的监听器取消掉
            _this.cancelRetryCallback();
        };
        this.player = player;
        this.logger = new Logger(player.config.instanceId, 'AutoPlayLogics');
        this.logger.log('autoplay logics call @constructor()');
        this.bindEvents(true);
    }
    Object.defineProperty(AutoPlayLogics.prototype, "shouldMuteRetry", {
        /**
         * 当前播放器配置下，是否允许进行静音自动播放重试
         */
        get: function () {
            var _a = this.player.config, autoPlayPolicy = _a.autoPlayPolicy, autoPlayInMute = _a.autoPlayInMute;
            return autoPlayInMute || autoPlayPolicy === AUTO_PLAY_POLICY.IN_MUTED;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoPlayLogics.prototype, "allowRetry", {
        /**
         * 是否允许进行静音起播重试
         */
        get: function () {
            return this.shouldMuteRetry && !this.hasRetried;
        },
        enumerable: false,
        configurable: true
    });
    AutoPlayLogics.prototype.destroy = function () {
        // 把 this.player 作为 destroy 标记
        if (!this.player)
            return;
        this.logger.log('autoplay logics call @destroy()');
        clearTimeout(this.adBlockTimer);
        this.cancelRetryCallback();
        this.bindEvents(false);
        this.player = null;
    };
    AutoPlayLogics.prototype.bindEvents = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        var binder = getEventEmitterBinder(this.player, isBind);
        binder(H5_PLAY_EVENT.PLAY_SESSION_START, this.onPlaySessionStart);
        binder(H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdAutoPlayBlocked);
        binder(H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED, this.onAutoPlayBlocked);
    };
    /**
     * 取消对静音自动播放成功的监听器
     */
    AutoPlayLogics.prototype.cancelRetryCallback = function () {
        this.player.off(H5_PLAY_EVENT.VIDEO_PLAYING, this.onVideoPlayingOnMuteRetry);
        this.player.off(H5_PLAY_EVENT.AD_PLAYING, this.onVideoPlayingOnMuteRetry);
    };
    return AutoPlayLogics;
}());

var defaultH5PlayerConfig = {
    container: void 0,
    enableQAreporter: true,
    // 重试的默认配置
    maxRetryGetinfoTimes: 3,
    maxRetryGetinfoTimesInVodSession: 10,
    maxRetryGetinfoTimesInLiveSession: 30,
};

/** 从PLAY_EVENT代理事件 */
function proxyPlayEvent(player, corePlayer) {
    var _a;
    var evtTransformMap = (_a = {},
        _a[PLAY_EVENT.DURATION_CHANGE] = {
            evt: H5_PLAY_EVENT.VIDEO_DURATION_CHANGE,
            getParam: function (info) { return ({ duration: info.videoInfo.duration }); },
        },
        _a[PLAY_EVENT.METADATA_CHANGE] = {
            evt: H5_PLAY_EVENT.VIDEO_METADATA_CHANGE,
            getParam: function (info) { return ({ width: info.videoInfo.videoWidth, height: info.videoInfo.videoHeight }); },
        },
        _a[PLAY_EVENT.VIDEO_BUFFER_CHANGE] = {
            evt: H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
            getParam: function () { return ({ bufferRange: player.videoBuffered }); },
        },
        _a[PLAY_EVENT.TIME_UPDATE] = {
            evt: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
            getParam: function (info) { return ({ playtime: info.videoInfo.playtime }); },
        },
        _a[PLAY_EVENT.VOLUME_CHANGE] = {
            evt: H5_PLAY_EVENT.VIDEO_VOLUME_CHANGE,
            getParam: function () { return ({ volume: player.volume }); },
        },
        _a[PLAY_EVENT.RATE_CHANGE] = {
            evt: H5_PLAY_EVENT.VIDEO_RATE_CHANGE,
            getParam: function (_a) {
                var rate = _a.playbackRate;
                return ({ rate: rate });
            },
        },
        _a[PLAY_EVENT.VIDEO_RESIZE] = {
            evt: H5_PLAY_EVENT.VIDEO_RESIZE,
            getParam: function (info) { return ({ videoWidth: info.videoInfo.videoWidth, videoHeight: info.videoInfo.videoHeight }); },
        },
        _a[PLAY_EVENT.AUTOPLAY_BLOCKED] = {
            evt: H5_PLAY_EVENT.VIDEO_AUTOPLAY_BLOCKED,
            getParam: function () { },
        },
        _a[PLAY_EVENT.SETLEVEL_OVER] = {
            evt: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
            getParam: function (info) {
                var _a, _b, _c;
                var code = (_c = (_b = (_a = info.videoInfo) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : ErrorCode.UNKNOWN;
                return {
                    code: info.fail ? code : ErrorCode.SUC,
                };
            },
        },
        _a);
    Object.keys(evtTransformMap).forEach(function (coreEvt) {
        corePlayer.on(coreEvt, function (param) {
            var _a = evtTransformMap[coreEvt], evt = _a.evt, getParam = _a.getParam;
            player.emit(evt, getParam(param.data));
        });
    });
}
/** 广告插件需要广播的事件 */
var adEvents = [
    H5_PLAY_EVENT.AD_REQ_INFO_START,
    H5_PLAY_EVENT.AD_REQ_INFO_END,
    H5_PLAY_EVENT.AD_REQ_ASSETS_START,
    H5_PLAY_EVENT.AD_ASSETS_LOADED,
    H5_PLAY_EVENT.AD_END,
    H5_PLAY_EVENT.AD_PLAYING,
    H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED,
    H5_PLAY_EVENT.AD_PAUSE,
    H5_PLAY_EVENT.AD_RESUME,
    H5_PLAY_EVENT.AD_TIME_UPDATE,
    H5_PLAY_EVENT.AD_VOLUME_CHANGE,
];
/** 代理广告插件上指定的事件，当动态替换广告插件时 需要重新调用此方法 */
function proxyAdEvent(player) {
    var adPlugin = getAdPlugin(player.config.instanceId);
    if (!adPlugin)
        return;
    adEvents.forEach(function (evt) {
        adPlugin.on(evt, function (_a) {
            var data = _a.data;
            player.emit(evt, data);
        });
    });
}

/** 播放器全屏状态枚举 */
var FullScreenMode;
(function (FullScreenMode) {
    /** CSS 全屏，也称伪全屏，使用样式将播放器 DOM 撑满屏幕，移动端兼容性好 */
    FullScreenMode["FAKE_FULLSCREEN"] = "fakeFullscreen";
    /** 文档全屏或 Video 全屏，浏览器提供的系统级全屏 API，PC + iOS 默认使用规则 */
    FullScreenMode["FULL_SCREEN"] = "fullscreen";
})(FullScreenMode || (FullScreenMode = {}));

/**
 * 设置容器 CSS 填充满 viewport，并设置 z-index 保持在屏幕最顶部
 * !注意：如果父级元素使用了会创建层叠上下文 / containing block 的属性，则会导致此方法失效
 * ! 常见有:
 * ! position: fixed / sticky（创建层级上下文，全屏后 z-index 盖不住父级的兄弟元素）
 * ! transform / perspective / filter （修改了 containing block，大小受限）
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
 * @param container 容器元素
 * @param isEnter 进入 / 取消
 */
function requestFakeFullScreen(container, isEnter) {
    if (isEnter === void 0) { isEnter = true; }
    // 先检查 class 的样式是否注入
    {
        domTool.insertStyle(styleStr, styleTag);
    }
    // 设置对应的 CSS 全屏 className
    container.classList.toggle(FakeFullscreenClass, isEnter);
}
/**
 * 判断是否处于 CSS 全屏中
 * @param container 全屏容器
 */
function isFakeFullscreen(container) {
    return container.classList.contains(FakeFullscreenClass);
}
/** CSS 全屏类 */
var FakeFullscreenClass = 'thumbplayer-fake-fullscreen';
/** style 标签的 data-tag 属性 */
var styleTag = 'thumbplayer-fake-fullscreen-style';
/** CSS 全屏的样式 */
var styleStr = /* css */ "\n.".concat(FakeFullscreenClass, " {\n  position: fixed !important;\n  top: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 9999 !important;\n}\n");

/**
 * DOM 全屏方法，主要应用于 PC / 平板
 * @param container 进入全屏的 DOM 容器
 * @param isEnter 进入 / 退出全屏，true -> 进入，false -> 退出
 */
function requestElFullScreen(container, isEnter) {
    if (isEnter === void 0) { isEnter = true; }
    // 1. 传入的容器必须是 Element，否则 reject
    if (!(container instanceof HTMLElement)) {
        return Promise.reject('requestElFullScreen: container is not an element');
    }
    // 2. 获取对应的进入 / 退出全屏方法
    var getEnterFn = function (ele) {
        var _a;
        return (_a = (ele.requestFullscreen
            || ele.mozRequestFullScreen
            || ele.webkitRequestFullscreen
            || ele.webkitRequestFullScreen
            || ele.msRequestFullscreen)) === null || _a === void 0 ? void 0 : _a.bind(ele);
    };
    var getExitFn = function (ele) {
        var _a;
        return (_a = (ele.cancelFullScreen
            || ele.mozCancelFullScreen
            || ele.webkitCancelFullScreen
            || ele.exitFullscreen
            || ele.webkitExitFullscreen
            || ele.msExitFullscreen)) === null || _a === void 0 ? void 0 : _a.bind(ele);
    };
    var enterFn = getEnterFn(container) || getEnterFn(document);
    var exitFn = getExitFn(container) || getExitFn(document);
    var fn = isEnter ? enterFn : exitFn;
    // 3. 尝试调用进入 / 退出全屏方法，并返回对应 Promise
    try {
        return Promise.resolve(fn());
    }
    catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Video 进入 / 退出全屏，用于 iOS 移动端拉起系统播放器全屏
 * 原因是 HTMLElement 缺少 requestFullScreen 方法
 * @param video video 标签
 */
function requestVideoFullScreen(video, isEnter) {
    if (isEnter === void 0) { isEnter = true; }
    return __awaiter(this, void 0, void 0, function () {
        var enterFullScreenFn, fn;
        return __generator(this, function (_a) {
            if (!video || !(video instanceof HTMLVideoElement)) {
                throw new Error('videoRequestFullScreen: video is not an VideoElement');
            }
            enterFullScreenFn = video.requestFullscreen
                || video.webkitEnterFullscreen
                || video.webkitRequestFullScreen;
            fn = isEnter ? enterFullScreenFn : video.webkitExitFullscreen;
            if (!fn) {
                throw new Error('Video Fullscreen API is not supported.');
            }
            return [2 /*return*/, fn.call(video)];
        });
    });
}
/**
 * 检查是否进入 DOM 全屏
 * @param container 被全屏的 DOM 元素
 */
function isElFullScreen(container) {
    if (!container)
        return false;
    var doc = document;
    var isFull = doc.fullscreen
        || doc.mozFullScreen
        || doc.webkitIsFullScreen
        || doc.msFullscreenElement;
    if (!isFull)
        return false;
    var el = doc.fullscreenElement
        || doc.webkitFullscreenElement
        || doc.mozFullScreenElement
        || doc.msFullscreenElement;
    return (el === container || el === document);
}
function isVideoFullScreen(video) {
    if (!video)
        return false;
    // 这里有个 bug: 当全屏模式下，点击 Safari / iOS webkit 下的小窗播放，此时 `webkitDisplayingFullscreen` 仍然是 `true`
    // 所以如果在 iOS / macOS Safari 下，webkitDisplayingFullscreen 属性为 true 且不在小窗模式下，才认定为是真的在全屏
    return (video.webkitDisplayingFullscreen || video.webkitPresentationMode === 'fullscreen') && !isEnterPipInApple(video);
}
/**
 * 检测是否在 iOS 或 macOS Safari 下进入了画中画模式
 * 用于兼容 iOS / macOS 这类 webkit 内核上，先进入全屏，在进入小窗播放时，`video.webkitDisplayingFullscreen` 仍然为 `true`
 * @param video - 原生 Video 标签
 */
function isEnterPipInApple(video) {
    // 如果不是 iOS 设备或者不是 macOS 的 Safari，则返回 false
    if (!(uaTool.os.ios || uaTool.browser.safari)) {
        return false;
    }
    // 判断是否进入小窗模式播放
    return (document.pictureInPictureEnabled || document.pictureInPictureElement === video);
}

var VIDEO_FULLSCREEN_TAG = 'fullscreen_handler';
var fullscreenEvents = ['webkitfullscreenchange', 'mozfullscreenchange', 'fullscreenchange', 'MSFullscreenChange'];
var FullScreenLogics = /** @class */ (function () {
    function FullScreenLogics(player, container) {
        var _this = this;
        this.player = player;
        /**
         * 当 loadStart 后，播放器会选择内核创建 video。这时，监听 video 的全屏事件
         * 在全屏产生时，转发全屏事件
         */
        this.onVideoLoadStart = function () {
            var videoElements = _this.player.videoElements;
            videoElements.forEach(function (video) {
                // 检查是否非 wasm 内核，且是否添加过事件监听，如果没有，开始添加全屏的事件监听
                if (video instanceof HTMLVideoElement && !video.dataset[VIDEO_FULLSCREEN_TAG]) {
                    _this.bindVideoElFullscreenEvt(video, true);
                }
            });
        };
        /**
         * 播放结束时，检查如果处于 iOS 下的系统全屏，则退出全屏状态
         * 这么做是要防止用户通过系统全屏下的播控按钮重新起播或者 seek，造成播放器事件派发、各个插件的状态错误
         *
         * 伪全屏则无所谓，因为伪全屏的播控是播放器提供的
         */
        this.onPlaySessionEnd = function () {
            if (uaTool.mobile && _this.fullscreenMode === FullScreenMode.FULL_SCREEN) {
                _this.requestFullScreen(false, FullScreenMode.FULL_SCREEN);
            }
        };
        /**
         * 处理系统全屏事件，在播放器上补发对应的全屏变更事件
         */
        this.fullscreenChangeHandler = function () {
            var fullscreenMode = _this.fullscreenMode;
            _this.player.emit(PLAY_EVENT.FULLSCREEN_CHANGE, {
                isEnter: fullscreenMode === FullScreenMode.FULL_SCREEN,
                mode: FullScreenMode.FULL_SCREEN,
            });
        };
        /**
         * 处理全屏事件，特殊处理 Safari 16.4
         */
        this.fullscreenChangeDesktop = function (event) {
            var currTriggeredEvt = event.type;
            var lastTriggeredFullscreenEvt = _this.lastTriggeredFullscreenEvt;
            // Safari 16.4 版本下，有可能会同时触发 webkitfullscreenchange 和 fullscreenchange
            // 这里判断下，如果间隔触发的全屏事件事件名都不一样，则仅派发第一次事件，忽略第二次 fullscreen 事件
            if (lastTriggeredFullscreenEvt && lastTriggeredFullscreenEvt !== currTriggeredEvt) {
                return;
            }
            _this.lastTriggeredFullscreenEvt = currTriggeredEvt;
            _this.fullscreenChangeHandler();
        };
        this.logger = new Logger(player.config.instanceId, 'FullscreenLogics');
        this.container = container || player.container;
        this.listenFullScreenEvts(true);
    }
    Object.defineProperty(FullScreenLogics.prototype, "fullscreenMode", {
        /**
         * 当前的全屏模式
         * 全屏 / CSS 全屏 / null -> 非全屏
         */
        get: function () {
            var container = this.container;
            var currentVideoElement = this.player.currentVideoElement;
            var videoElements = this.player.config.videoElements;
            if (isElFullScreen(container)
                || isVideoFullScreen(currentVideoElement)
                // 如果播到 SessionEnd，player.currentVideoElement = null，这里取 videoElements 的第一个元素作为 video
                // 因为基本上只有 iOS 能走到这，而 iOS 下只会创建一个 video 标签
                || (videoElements[0] instanceof HTMLVideoElement && isVideoFullScreen(videoElements[0]))) {
                return FullScreenMode.FULL_SCREEN;
            }
            if (isFakeFullscreen(container)) {
                return FullScreenMode.FAKE_FULLSCREEN;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 进入 / 退出全屏状态
     * @param isEnter 是否进入全屏，true 进入全屏，false 退出全屏
     * @param mode 指定全屏模式，分为系统全屏和 CSS 全屏。默认情况下会自动判断
     * @param emit 防止递归调用时重复抛出事件
     */
    FullScreenLogics.prototype.requestFullScreen = function (isEnter, mode) {
        if (isEnter === void 0) { isEnter = true; }
        return __awaiter(this, void 0, void 0, function () {
            var container, _a, currentVideoElement, config, videoElements, currentMode, requestMode, videoTag, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        container = this.container;
                        _a = this.player, currentVideoElement = _a.currentVideoElement, config = _a.config;
                        videoElements = config.videoElements;
                        currentMode = this.fullscreenMode;
                        requestMode = this.getFullScreenMode(mode);
                        // 如果已经处于全屏模式下了，还要求全屏，分情况
                        if (isEnter && currentMode) {
                            // 1. 重复要求进入同一种全屏（如已经是系统全屏，还请求系统全屏），则什么也不做
                            if (currentMode === requestMode)
                                return [2 /*return*/];
                            // 2. 否则，先把退出当前全屏，再进行全屏操作
                            this.requestFullScreen(false, currentMode);
                        }
                        // 如果非全屏下请求退出全屏，或者退出的是另一个模式的全屏，什么也不做
                        if ((!isEnter && !currentMode) || (!isEnter && currentMode !== requestMode)) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        // 伪全屏，调用全屏方法并抛出事件
                        if (requestMode === FullScreenMode.FAKE_FULLSCREEN) {
                            requestFakeFullScreen(container, isEnter);
                            // 只有伪全屏直接发出事件，其他事件由 DOM / video 的原生事件捕获后发出
                            this.player.emit(PLAY_EVENT.FULLSCREEN_CHANGE, { isEnter: isEnter, mode: requestMode });
                            return [2 /*return*/];
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, requestElFullScreen(container, isEnter)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        _b.sent();
                        videoTag = currentVideoElement || videoElements[0];
                        // 错误直接外抛上层 try-catch
                        return [4 /*yield*/, requestVideoFullScreen(videoTag, isEnter)];
                    case 5:
                        // 错误直接外抛上层 try-catch
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_2 = _b.sent();
                        // 如果全屏报错，捕获打个 log，再外抛
                        this.logger.error("@FullscreenLogics.requestFullScreen, isEnter=".concat(isEnter, ", mode=").concat(requestMode, ", err=").concat(err_2));
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    FullScreenLogics.prototype.destroy = function () {
        this.listenFullScreenEvts(false);
    };
    /**
     * 指定全屏模式
     * @param mode 强制指定全屏模式
     */
    FullScreenLogics.prototype.getFullScreenMode = function (mode) {
        if (mode) {
            // 强制指定直接返回
            return mode;
        }
        // 内置规则： PC / iOS 使用系统全屏，其他移动端都使用伪全屏
        return (!uaTool.mobile || uaTool.os.ios)
            ? FullScreenMode.FULL_SCREEN
            : FullScreenMode.FAKE_FULLSCREEN;
    };
    /**
     * DOM 全屏和 video 全屏变更由对应元素抛出，这里捕获并在播放器实例上抛出 FULLSCREEN_CHANGE 事件
     * @param isBind 监听 / 取消监听
     */
    FullScreenLogics.prototype.listenFullScreenEvts = function (isBind) {
        var _this = this;
        var _a;
        if (isBind === void 0) { isBind = true; }
        var docBinder = isBind ? document.addEventListener.bind(document) : document.removeEventListener.bind(document);
        var playerBinder = isBind ? this.player.on.bind(this.player) : this.player.off.bind(this.player);
        playerBinder(H5_PLAY_EVENT.VIDEO_LOAD_START, this.onVideoLoadStart);
        playerBinder(H5_PLAY_EVENT.PLAY_SESSION_END, this.onPlaySessionEnd);
        // 监听 DOM 全屏的对应事件
        fullscreenEvents.forEach(function (evtName) {
            docBinder(evtName, _this.fullscreenChangeDesktop);
        });
        // 如果是取消监听，尝试取消对 video 全屏事件的监听
        if (!isBind) {
            (_a = this.player.videoElements) === null || _a === void 0 ? void 0 : _a.forEach(function (video) {
                if (!(video instanceof HTMLVideoElement))
                    return;
                _this.bindVideoElFullscreenEvt(video, false);
            });
        }
    };
    /**
     * 绑定 / 解绑 Video 标签发出的全屏事件，仅在 iOS 系统下才会调用
     */
    FullScreenLogics.prototype.bindVideoElFullscreenEvt = function (video, isBind) {
        var videoBinder = isBind ? video.addEventListener.bind(video) : video.removeEventListener.bind(video);
        videoBinder('webkitendfullscreen', this.fullscreenChangeHandler);
        videoBinder('webkitbeginfullscreen', this.fullscreenChangeHandler);
        if (isBind) {
            // 如果是绑定事件监听器，则在 dataset 上添加一个标记，确保只监听一次
            video.dataset[VIDEO_FULLSCREEN_TAG] = String(true);
        }
        else {
            // 否则，移除这个标记
            delete video.dataset[VIDEO_FULLSCREEN_TAG];
        }
    };
    return FullScreenLogics;
}());

/** 用局部变量保存getinfo模块实例 */
var getinfoModuleMap = {};
/**
* 创建getinfo模块
*/
function createGetinfoModule(GetinfoModule, config, extra) {
    var instanceId = config.instanceId;
    var getinfoModule = getinfoModuleMap[instanceId];
    if (!getinfoModule) {
        getinfoModule = new GetinfoModule(config, extra);
        getinfoModuleMap[instanceId] = getinfoModule;
    }
    return getinfoModule;
}
/**
* 销毁getinfo模块
*/
function destroyGetinfoModule(instanceId) {
    var _a;
    (_a = getinfoModuleMap[instanceId]) === null || _a === void 0 ? void 0 : _a.destroy();
    delete getinfoModuleMap[instanceId];
}
function getGetinfoModule(instanceId) {
    return getinfoModuleMap[instanceId];
}
/**
 * 执行getinfo请求
 */
function doGetinfo(instanceId, reqInfoRef, extra) {
    return __awaiter(this, void 0, void 0, function () {
        var getinfoModule, _a, adType, emitGetinfoEvts, vid, adParam, videoReqInfoParam, flowid, srvData, ctx;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    getinfoModule = getinfoModuleMap[instanceId];
                    if (!getinfoModule || !reqInfoRef || !reqInfoRef.vid) {
                        // TODO: 应该抛出错误？（miropeng）
                        return [2 /*return*/];
                    }
                    _a = extra || {}, adType = _a.adType, emitGetinfoEvts = _a.emitGetinfoEvts;
                    vid = reqInfoRef.vid, adParam = reqInfoRef.adParam, videoReqInfoParam = reqInfoRef.videoReqInfoParam, flowid = reqInfoRef.flowid, srvData = reqInfoRef.srvData;
                    return [4 /*yield*/, getinfoModule.request(vid, {
                            emitGetinfoEvts: emitGetinfoEvts,
                            adParams: adType ? getAdReqParams(instanceId, __assign({ adType: adType, vid: vid }, adParam)) : void 0,
                            // vinfoParams的flowid比较特殊，一定要每次请求都写入。
                            // 原因是在getinfo模块里面，只取了数据中心的flowid，但是doGetinfo可能发生在当前session，也可能发生在预加载的session。因此这里覆盖一下
                            vinfoParams: __assign(__assign({}, videoReqInfoParam), { flowid: flowid }),
                            srvData: srvData,
                        })];
                case 1:
                    ctx = _b.sent();
                    return [2 /*return*/, ctx];
            }
        });
    });
}
function hasGetinfoModule(instanceId) {
    return instanceId in getinfoModuleMap;
}

/** 附加插件化功能，并直接对外暴露插件化接口 */
var PluginablePlayer = /** @class */ (function (_super) {
    __extends(PluginablePlayer, _super);
    function PluginablePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 挂载所有插件实例 */
        _this.plugins = {};
        _this.pluginMsg = new EvtEmitter();
        _this.playerApiProxy = {};
        /** 作为私有变量（用户不需要监听）提供给插件，只允许监听/解除监听，不允许广播事件 */
        _this.pluginMsgProxy = {
            on: _this.pluginMsg.on.bind(_this.pluginMsg),
            off: _this.pluginMsg.off.bind(_this.pluginMsg),
            once: _this.pluginMsg.once.bind(_this.pluginMsg),
        };
        /** 播放器已经被销毁 */
        _this._destroyed = false;
        /**
         * 异步加载插件
         * @param plugin.url 插件地址
         * @param plugin.globalName 插件全局变量名
         * @param plugin.pluginName 要注册的插件名
         * @param plugin.insName 挂在plugins下的属性名
         * @param [plugin.config] 插件创建参数
         * @param plugin.timeout 插件js最大加载时长
         */
        _this.loadPlugin = function (plugin) {
            // 这里赋值有先后顺序要求。默认使用全局变量名作为插件名，使用插件名作为实例名
            var config = plugin.config, timeout = plugin.timeout, version = plugin.version, crossOrigin = plugin.crossOrigin, globalName = plugin.globalName;
            var _a = plugin.pluginName, pluginName = _a === void 0 ? globalName : _a, insName = plugin.insName, url = plugin.url;
            if (!url && !PLUGIN_MAP[pluginName]) {
                throw new Error(t(i18nConfig.h5player.ERROR_UNOFFICIAL_PLUGIN_NEEDS_URL));
            }
            if (!url && PLUGIN_MAP[pluginName]) {
                var pluginVersion = version || PLUGIN_MAP[pluginName].version;
                var cdnPath = PLUGIN_MAP[pluginName].cdnPath || "thumbplayer-plugin-".concat(pluginName);
                pluginName = PLUGIN_MAP[pluginName].pluginName || pluginName;
                url = "https://vm.gtimg.cn/thumbplayer/plugins/".concat(cdnPath, "/").concat(pluginVersion, "/index.min.js");
            }
            insName = insName || pluginName;
            // 暂时不指定script标签的tag属性 每次都重新加载js
            return domTool.loadScript(url, undefined, timeout, { crossOrigin: crossOrigin }).then(function () {
                if (_this._destroyed) {
                    return;
                }
                if (!getPlugin(pluginName)) {
                    // script没有自己注册的话，帮它注册
                    registerPlugin(pluginName, window[globalName]);
                }
                if (!_this.plugins[insName]) {
                    // 避免重复实例化
                    _this.createPlugin(insName, __assign(__assign({}, config), { pluginName: pluginName }));
                }
            });
        };
        return _this;
    }
    /** 创建插件实例，并挂载到 player.plugins[insName] */
    PluginablePlayer.prototype.createPlugin = function (insName, option) {
        if (option === void 0) { option = {}; }
        var _a = option.pluginName, pluginName = _a === void 0 ? insName : _a;
        var pluginFunction = getPlugin(pluginName);
        if (!pluginFunction)
            throw new Error("Cannot find plugin: ".concat(pluginName));
        if (this._destroyed)
            throw new Error("Create plugin '".concat(pluginName, "' failed because player has destroyed."));
        this.triggerSetupEvent({ name: insName, plugin: pluginFunction, instance: null }, true);
        // as any因为插件是面向H5Player的
        createPluginFactory(insName, pluginFunction, this, option, {
            msg: this.pluginMsgProxy,
            api: this.playerApiProxy,
        });
        if (pluginName === AdPluginName) {
            // 特殊处理，隐藏广告插件
            setAdPlugin(this.config.instanceId, this.plugins[AdPluginName]);
            delete this.plugins[AdPluginName];
        }
        this.triggerSetupEvent({ name: insName, plugin: pluginFunction, instance: null });
    };
    /** 批量创建插件 */
    PluginablePlayer.prototype.createPlugins = function (configs) {
        var _this = this;
        configs.forEach(function (val) {
            // 避免插件创建失败时影响后面的插件
            try {
                if (typeof val === 'string') {
                    _this.createPlugin(val);
                }
                else {
                    _this.createPlugin.apply(_this, val);
                }
            }
            catch (err) {
                console.error(err);
            }
        });
    };
    PluginablePlayer.prototype.destroy = function () {
        this.removeAllListeners();
        this.pluginMsg.removeAllListeners();
        this._destroyed = true;
    };
    /** 创建插件时广播事件 */
    PluginablePlayer.prototype.triggerSetupEvent = function (data, before) {
        var _this = this;
        if (before === void 0) { before = false; }
        var eventName = "".concat(before ? 'before' : '', "pluginsetup");
        // setTimeout让监听的插件周期事件可以触发
        setTimeout(function () {
            _this.pluginMsg.emit("".concat(eventName, ":").concat(data.name), data);
        });
    };
    // 插件化静态方法
    PluginablePlayer.registerPlugin = registerPlugin;
    PluginablePlayer.deregisterPlugin = deregisterPlugin;
    PluginablePlayer.getPlugins = getPlugins;
    PluginablePlayer.getPlugin = getPlugin;
    PluginablePlayer.isFunctionPlugin = isFunctionPlugin;
    PluginablePlayer.pluginExists = pluginExists;
    /** @deprecated */
    PluginablePlayer.isBasicPlugin = isFunctionPlugin;
    return PluginablePlayer;
}(EvtEmitter));

var FlowNodeReqInfo = /** @class */ (function () {
    function FlowNodeReqInfo(config) {
        this.getinfoOutputCacheInner = void 0;
        this.config = config;
    }
    Object.defineProperty(FlowNodeReqInfo.prototype, "srvData", {
        /** 服务端直出的播放信息数据 */
        get: function () {
            return this.config.startParam.srvData;
        },
        enumerable: false,
        configurable: true
    });
    FlowNodeReqInfo.prototype.clearSrvData = function () {
        this.config.startParam.srvData = null;
    };
    Object.defineProperty(FlowNodeReqInfo.prototype, "getinfoOutputCache", {
        /** 视频信息（可能包括广告）缓存数据 */
        get: function () {
            return this.getinfoOutputCacheInner;
        },
        set: function (value) {
            this.getinfoOutputCacheInner = value;
            this.adInfoCacheInner = value === null || value === void 0 ? void 0 : value.adInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "adInfoCache", {
        /** 广告信息缓存数据 */
        get: function () {
            return this.adInfoCacheInner;
        },
        set: function (value) {
            this.adInfoCacheInner = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "startParam", {
        get: function () {
            return this.config.startParam;
        },
        set: function (val) {
            this.config.startParam = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "flowid", {
        get: function () {
            return this.config.flowid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "instanceId", {
        get: function () {
            return this.config.instanceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "videoLoadParam", {
        get: function () {
            return this.config.startParam.videoLoadParam;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "videoReqInfoParam", {
        get: function () {
            return this.config.startParam.videoReqInfoParam;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "vid", {
        get: function () {
            return this.config.startParam.vid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowNodeReqInfo.prototype, "adParam", {
        get: function () {
            return this.config.startParam.adParam;
        },
        enumerable: false,
        configurable: true
    });
    return FlowNodeReqInfo;
}());

/**
 * 当使用vid播放时的重试请求getinfo后台逻辑管理器。
 */
var RetryManager = /** @class */ (function () {
    function RetryManager(player) {
        var _a;
        var _this = this;
        this.player = player;
        this.retryCheckers = [];
        /** session内已经重试的次数 */
        this.retryTimesInSession = 0;
        this.onPlaySessionStartHandler = function () {
            _this.retryTimesInSession = 0;
            _this.retryCheckers.forEach(function (checker) { return checker.onSessionStart(); });
        };
        this.onVideoPlaying = function () {
            _this.retryCheckers.forEach(function (checker) { return checker.onRetrySucc(); });
        };
        this.checkerEvtHandler = function (evt) {
            var _a;
            if (!_this.player.canGetinfoRetry()) {
                // 不能重试的话，都不用检查是否需要重试
                return;
            }
            var retryConfig = _this.getHitChecker(evt);
            if (!retryConfig) {
                // 没有命中任何重试逻辑
                return;
            }
            var _b = retryConfig.outOfTimes, outOfTimes = _b === void 0 ? false : _b;
            var _c = _this.player.config, playMode = _c.type, maxLiveTimes = _c.maxRetryGetinfoTimesInLiveSession, maxVodTimes = _c.maxRetryGetinfoTimesInVodSession;
            if (_this.retryTimesInSession >= (playMode === PLAY_MODE.LIVE ? maxLiveTimes : maxVodTimes)) {
                // 超过session内错误重试最大次数，重试结束
                outOfTimes = true;
            }
            _this.retryTimesInSession++;
            _this.logger.log("retry on ".concat(evt.type, ",\n    outOfTimes=").concat(outOfTimes, ",\n    retryTimes=").concat(retryConfig.retryTimes, ", retryTimesInSession=").concat(_this.retryTimesInSession, ",\n    playParam=").concat(jsonTool.safelyStringify(retryConfig.updatePlayParam), ",\n    error=").concat((_a = retryConfig.error) === null || _a === void 0 ? void 0 : _a.code));
            _this.player.startGetinfoRetry(retryConfig, outOfTimes);
        };
        this.player.getRetryCheckClasses().forEach(function (Checker) {
            _this.retryCheckers.push(new Checker(player));
        });
        this.logger = new Logger(this.player.config.instanceId, 'RetryManager');
        this.evtMap = (_a = {},
            _a[H5_PLAY_EVENT.PLAY_SESSION_START] = this.onPlaySessionStartHandler,
            _a[H5_PLAY_EVENT.VIDEO_PLAYING] = this.onVideoPlaying,
            _a);
        this.setCheckEvents(true);
        this.setPlayerEvents(true);
    }
    RetryManager.prototype.destroy = function () {
        this.setCheckEvents(false);
        this.setPlayerEvents(false);
        this.retryCheckers.forEach(function (checker) { return checker.destroy(); });
        this.player = null;
        this.retryCheckers = null;
    };
    /**
     * 根据事件查找命中了哪个检查逻辑
     */
    RetryManager.prototype.getHitChecker = function (evt) {
        // for循环保证每种重试逻辑的检查顺序
        for (var i = 0; i < this.retryCheckers.length; i++) {
            var checker = this.retryCheckers[i];
            if (checker.checkEvt !== evt.type) {
                continue;
            }
            var retryConfig = checker.check(evt);
            if (retryConfig) {
                this.logger.log("checker hit ".concat(checker.name));
                return retryConfig;
            }
        }
        return null;
    };
    /**
     * 设置每个检查逻辑需要监听的事件
     */
    RetryManager.prototype.setCheckEvents = function (isBind) {
        var _this = this;
        if (isBind === void 0) { isBind = true; }
        var func = isBind ? this.player.on : this.player.off;
        var checkerEvts = [];
        for (var i = 0; i < this.retryCheckers.length; i++) {
            if (checkerEvts.indexOf(this.retryCheckers[i].checkEvt) === -1) {
                checkerEvts.push(this.retryCheckers[i].checkEvt);
            }
        }
        checkerEvts.forEach(function (evt) {
            func.call(_this.player, evt, _this.checkerEvtHandler);
        });
    };
    /**
     * 设置manager内部需要监听的事件
     */
    RetryManager.prototype.setPlayerEvents = function (value) {
        var _this = this;
        var func = value ? this.player.on : this.player.off;
        Object.keys(this.evtMap).forEach(function (evtName) {
            func.call(_this.player, evtName, _this.evtMap[evtName]);
        });
    };
    return RetryManager;
}());

var BaseCheck = /** @class */ (function () {
    function BaseCheck(player) {
        this.name = '';
        this.checkEvt = null;
        /** 当次连续重试的重试次数，只要重试成功就重置为0 */
        this.retryTimes = 0;
        this.player = player;
        this.logger = new Logger(this.player.config.instanceId, 'RetryChecker');
    }
    BaseCheck.prototype.destroy = function () {
        this.player = null;
    };
    BaseCheck.prototype.onSessionStart = function () {
        this.retryTimes = 0;
    };
    BaseCheck.prototype.onRetrySucc = function () {
        // 每次重试成功，都重置重试次数
        this.retryTimes = 0;
    };
    BaseCheck.prototype.check = function (_evt) {
        // to be override
        return null;
    };
    BaseCheck.prototype.getRetryConfig = function (videoInfo) {
        var playtime = videoInfo.playtime, error = videoInfo.error;
        var updatePlayParam = {
            videoReqInfoParam: {},
            videoLoadParam: {
                startTime: playtime,
                // VideoFlowNode缓存了上一次kernelName，后续重构loadParam这一块
                kernelName: void 0,
            },
        };
        return {
            error: error,
            updatePlayParam: updatePlayParam,
            retryTimes: this.retryTimes,
        };
    };
    return BaseCheck;
}());

/** 在出错时记录播放时间点的初始值 */
var REC_PLAY_TIME_INIT_VALUE = -1;
var RetryNames = {
    CheckNormalError: 'CheckNormalError',
};

var CheckNormalError = /** @class */ (function (_super) {
    __extends(CheckNormalError, _super);
    function CheckNormalError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = RetryNames.CheckNormalError;
        _this.checkEvt = PLAY_EVENT.ERROR;
        /** 在出错时记录发生重试时的状态，重试后需要根据此状态判断是继续播放，还是保持用户当前状态（例如保持暂停） */
        _this.stateWhenErrorHappen = null;
        /** 在出错时记录播放时间点 */
        _this.playtimeWhenErrorHappen = REC_PLAY_TIME_INIT_VALUE;
        return _this;
    }
    CheckNormalError.prototype.check = function (evt) {
        var videoInfo = evt.data.videoInfo;
        var error = videoInfo.error;
        var maxRetryGetinfoTimes = this.player.config.maxRetryGetinfoTimes;
        // 如果是加密模块的报错，不需要进行getinfo重试
        if (error.type === TpCoreError.Encryption) {
            return {
                outOfTimes: true,
                error: error,
                retryTimes: this.retryTimes,
            };
        }
        if (this.retryTimes >= maxRetryGetinfoTimes) {
            // 超过最大重试次数，重试结束
            return {
                outOfTimes: true,
                error: error,
                retryTimes: this.retryTimes,
            };
        }
        return this.checkNormalErrorCode(evt);
    };
    CheckNormalError.prototype.onRetrySucc = function () {
        _super.prototype.onRetrySucc.call(this);
        this.stateWhenErrorHappen = null;
        this.playtimeWhenErrorHappen = REC_PLAY_TIME_INIT_VALUE;
    };
    CheckNormalError.prototype.updateRetryTimes = function () {
        this.retryTimes += 1;
    };
    /**
     * 一般的错误码的检查，getinfo级别的重试也是从这里发起
     */
    CheckNormalError.prototype.checkNormalErrorCode = function (evt) {
        var _a;
        var videoInfo = evt.data.videoInfo;
        var stateWhenErrorHappen = videoInfo.stateWhenErrorHappen, playtime = videoInfo.playtime;
        if (this.stateWhenErrorHappen === null) {
            // 1. 避免连续getinfo重试时候被覆盖，只记录一次，恢复播放以后设置为null，因此要判断下null
            // 2. 另外这里并没有使用videoinfo上的state，因为这时候core层已经停止播放，videoinfo上的state已经为idle了，而videoinfo上的
            // `stateWhenErrorHappen`为停止播放前记录的
            this.stateWhenErrorHappen = stateWhenErrorHappen;
        }
        if (this.playtimeWhenErrorHappen === REC_PLAY_TIME_INIT_VALUE) {
            // 避免连续getinfo重试时候被覆盖，只记录一次
            this.playtimeWhenErrorHappen = playtime;
        }
        this.updateRetryTimes();
        var retryConfig = this.getRetryConfig(videoInfo);
        // 出错时候带上`stateWhenErrorHappen`到VideoNode层，告知出错时是什么播放状态
        retryConfig.stateWhenErrorHappen = this.stateWhenErrorHappen;
        // 出错时候带上`playtimeWhenErrorHappen`到VideoNode层，告知出错时的播放时间点
        if (this.playtimeWhenErrorHappen !== REC_PLAY_TIME_INIT_VALUE
            && ((_a = retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.updatePlayParam) === null || _a === void 0 ? void 0 : _a.videoLoadParam)
            && this.player.config.type === PLAY_MODE.VOD) {
            retryConfig.updatePlayParam.videoLoadParam.startTime = this.playtimeWhenErrorHappen;
        }
        return retryConfig;
    };
    return CheckNormalError;
}(BaseCheck));

/** 在没有创建播放器实例之前记录的一些执行步骤耗时信息，此时用一个假的播放器实例id */
var stepTimerFakeGlobalInstanceId = '-1';
/**
 * 执行步骤计时器
 */
var StepTimer = /** @class */ (function () {
    function StepTimer() {
    }
    StepTimer.push = function (key, start, end, instanceId) {
        if (instanceId === void 0) { instanceId = stepTimerFakeGlobalInstanceId; }
        var recordMap = this.getRecordMap(instanceId);
        recordMap[key] = { start: start, end: end, cost: end - start };
    };
    /**
     * 启动一个计时器来跟踪某一个操作的占用时长
     */
    StepTimer.start = function (key, instanceId) {
        if (instanceId === void 0) { instanceId = stepTimerFakeGlobalInstanceId; }
        var recordMap = this.getRecordMap(instanceId);
        recordMap[key] = { start: performance.now(), end: 0, cost: 0 };
    };
    StepTimer.end = function (key, instanceId) {
        if (instanceId === void 0) { instanceId = stepTimerFakeGlobalInstanceId; }
        var recordMap = this.recordMap[instanceId];
        if (!(recordMap === null || recordMap === void 0 ? void 0 : recordMap[key])) {
            return -1;
        }
        var record = recordMap[key];
        if (record.end === 0) {
            // 后面记录的不覆盖前面的（例如广告起播以后记录了一个耗时，那正片再起播时候就不会覆盖第一次记录）
            record.end = performance.now();
            record.cost = Math.round(record.end - record.start);
        }
        return record.cost;
    };
    StepTimer.getCostMap = function (instanceId, isClean) {
        var _this = this;
        if (isClean === void 0) { isClean = false; }
        var ret = {};
        if (this.recordMap[instanceId]) {
            Object.keys(this.recordMap[instanceId]).forEach(function (k) {
                var fk = k.replace(/-/g, '_'); // atta表不接受cp_vod-qa-reporter这种格式，换成cp_vod_qa_reporter
                ret[fk] = _this.recordMap[instanceId][k].cost;
            });
            if (isClean) {
                delete this.recordMap[instanceId];
            }
        }
        return ret;
    };
    StepTimer.getRecordMap = function (instanceId) {
        var recordMap = this.recordMap[instanceId];
        if (!recordMap) {
            recordMap = {};
            this.recordMap[instanceId] = recordMap;
        }
        return recordMap;
    };
    StepTimer.recordMap = {};
    return StepTimer;
}());

var StepKey;
(function (StepKey) {
    StepKey["CREATE_PLUGIN_PREFIX"] = "cp";
    StepKey["SESSION_START_EVT"] = "startEvt";
    StepKey["CREATE_FLOW_NODES"] = "createFlow";
    StepKey["GETINFO"] = "infoReq";
    StepKey["GETINFO_END"] = "infoEndEvt";
    /** 整个前贴广告flowNode从开始到结束（没有前贴广告的情况） */
    StepKey["PRE_AD_FLOW_NODE"] = "preAdFlow";
    /** 广告cdn加载 */
    StepKey["AD_CDN_REQ"] = "adCdnReq";
    /** 正片cdn加载 */
    StepKey["V_CDN_REQ"] = "cdnReq";
})(StepKey || (StepKey = {}));

/** 将传入二维数组里的插件类转换成插件名，同时提供类型校验 */
function definePlugins(plugins) {
    return plugins.map(function (p) { return [p[0].pluginName, p[1]]; });
}
/**
 * 自动监听player事件
 * @param {string} [name] 要监听的事件名，默认会使用函数名.slice(2)
 * @returns {Function}
 */
function autobind(name) {
    return function (_target, key, desc) {
        var evtName = name;
        // 没传入name时从函数名推断事件名
        if (!evtName) {
            // onPlayerEvent, onXX
            var nameOffset = 'on'.length;
            var evt_1 = key.slice(nameOffset).toLowerCase();
            var evtKey = Object.keys(PLAY_EVENT).find(function (key) { return PLAY_EVENT[key].toLowerCase() === evt_1; });
            if (evtKey) {
                evtName = PLAY_EVENT[evtKey];
            }
            else {
                evtKey = Object.keys(H5_PLAY_EVENT).find(function (key) { return H5_PLAY_EVENT[key].toLowerCase() === evt_1; });
                evtName = H5_PLAY_EVENT[evtKey];
            }
        }
        var rawValue = desc.value;
        desc.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (evtName && this.player) {
                this.player.on(evtName, rawValue.bind(this));
            }
            else {
                rawValue.apply(this, args);
            }
        };
    };
}
/**
 * 记录接口调用和调用参数到离线日志
 * !注意：此装饰器会JSON.stringify参数，如果有高频调用、超大参数可能导致性能问题。
 */
var logApiInvoke = function (_target, name, desc) {
    var rawValue = desc.value;
    desc.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var argString = '';
        try {
            argString = JSON.stringify(args);
        }
        catch (e) {
            argString = 'parse arg failed';
        }
        this.setStateKv(name, {
            type: LOG_TYPE.API_INVOKE,
            ftime: Date.now(),
            ext: {
                from: 'thumbplayer-h5',
                // stringify是为了过滤函数属性，避免indexedDB报错
                args: argString,
            },
        });
        return rawValue.apply(this, args);
    };
};
/** 让实例方法只执行一次 */
var once = function (_target, propertyKey, desc) {
    var func = desc.value;
    desc.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this["__hasRun".concat(propertyKey)])
            return;
        this["__hasRun".concat(propertyKey)] = true;
        return func.apply(this, args);
    };
};
function tryEmit(emitFunc, logger) {
    try {
        emitFunc();
    }
    catch (err) {
        logger === null || logger === void 0 ? void 0 : logger.error(err);
    }
}
function getEnvVals() {
    var VERSION = '';
    try {
        // @ts-ignore
        VERSION = "1.29.13";
    }
    catch (_a) { }
    var BUILD_TIME = '';
    try {
        // @ts-ignore
        BUILD_TIME = 1702361852454;
    }
    catch (_b) { }
    var IS_BETA = false;
    try {
        // @ts-ignore
        IS_BETA = "0" === '1';
    }
    catch (_c) { }
    return {
        VERSION: IS_BETA ? "".concat(VERSION, "-beta") : VERSION,
        BUILD_TIME: BUILD_TIME,
        IS_BETA: IS_BETA,
    };
}

var BaseFlowNode = /** @class */ (function (_super) {
    __extends(BaseFlowNode, _super);
    function BaseFlowNode(config) {
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.isDestroyedInner = false;
        return _this;
    }
    Object.defineProperty(BaseFlowNode.prototype, "flowid", {
        get: function () {
            return this.config.reqInfo.flowid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseFlowNode.prototype, "extEvtDispatcher", {
        /** H5_EXT_EVENT的事件派发器 */
        get: function () {
            return this.config.extEvtDispatcher;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseFlowNode.prototype, "instanceId", {
        /** 播放器实例id */
        get: function () {
            return this.config.reqInfo.instanceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseFlowNode.prototype, "reqInfo", {
        get: function () {
            return this.config.reqInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseFlowNode.prototype, "isDestroyed", {
        get: function () {
            return this.isDestroyedInner;
        },
        enumerable: false,
        configurable: true
    });
    BaseFlowNode.prototype.destroy = function () {
        this.config = null;
        this.isDestroyedInner = true;
        this.removeAllListeners();
    };
    BaseFlowNode.prototype.getName = function () {
        return '';
    };
    /** 暂停播放 */
    BaseFlowNode.prototype.pause = function (_pauseType) { };
    /** 恢复播放 */
    BaseFlowNode.prototype.resume = function () { };
    /**
     * 节点内重播。
     */
    BaseFlowNode.prototype.replay = function (_vid, _param) {
        return Promise.reject("replay not implemented! (".concat(this.getName(), ")"));
    };
    /** 开始执行流程，需要判断是否预加载 */
    BaseFlowNode.prototype.start = function () {
        return Promise.resolve();
    };
    /** 执行预加载操作 */
    BaseFlowNode.prototype.preload = function (_forceLoad) {
        return Promise.resolve();
    };
    BaseFlowNode.prototype.retry = function (_fatal, _data) {
        // to be override
    };
    BaseFlowNode.prototype.emitFlowEvt = function (evtName, data) {
        this.emit(evtName, __assign({ name: this.getName() }, data));
    };
    return BaseFlowNode;
}(EvtEmitter));
var FLOW_NODE_EVENT;
(function (FLOW_NODE_EVENT) {
    /** 触发下一节点的预加载 */
    FLOW_NODE_EVENT["PRELOAD_NEXT"] = "PRELOAD_NEXT";
    /** 进入预加载流程 */
    FLOW_NODE_EVENT["PRELOAD"] = "PRELOAD";
    /** 进入节点流程（可能还未开始播放，例如预加载了但是还在loading过程中） */
    FLOW_NODE_EVENT["START"] = "START";
    /** 当前节点结束/出错后，进入下一节点 */
    FLOW_NODE_EVENT["END"] = "END";
    /** 中断当前流程。getinfo接口报错或者正片出错时中断，抛出此事件时一般需要带上数据 */
    FLOW_NODE_EVENT["ABORT"] = "ABORT";
    FLOW_NODE_EVENT["VIDEO_SETLEVEL_START"] = "VIDEO_SETLEVEL_START";
    FLOW_NODE_EVENT["VIDEO_SETLEVEL_END"] = "VIDEO_SETLEVEL_END";
    FLOW_NODE_EVENT["VIDEO_REQ_INFO_START"] = "VIDEO_REQ_INFO_START";
    FLOW_NODE_EVENT["VIDEO_REQ_INFO_END"] = "VIDEO_REQ_INFO_END";
    /** 广告或者正片起播 */
    FLOW_NODE_EVENT["SESSION_FIRST_PLAYING"] = "SESSION_FIRST_PLAYING";
})(FLOW_NODE_EVENT || (FLOW_NODE_EVENT = {}));

/** 广告流程节点
 * 由于腾讯视频广告插件内部区分空单/没有订单，需要在节点内实现一些兼容性逻辑.
 * 没有订单: loadAd -> reject; playAd -> reject; 表现无广告，无 ad_end 事件
 * 空单: loadAd -> resolve(false); playAd -> resolve; 表现无广告，playAd后，抛出 ad_end 事件
 * 实单: loadAd -> resolve(true); playAd -> resolve; 表现有广告，广告结束后，抛出 ad_end 事件
 */
var AdFlowNode = /** @class */ (function (_super) {
    __extends(AdFlowNode, _super);
    function AdFlowNode(config) {
        var _this = this;
        var _a;
        _this = _super.call(this, config) || this;
        _this.enableP2P = false;
        _this.isFirstPlaying = false;
        /** 同步广告倒计时给内核 */
        _this.onAdCountdown = function (_a) {
            var data = _a.data;
            // 开启 p2p 情况下，倒计时前 60 秒开启预加载
            var preloadTime = 60;
            if (data.adType !== AD_TYPE.PRE
                || !_this.enableP2P
                || data.countdown > preloadTime)
                return;
            _this.preloadNext(false);
            preloadEvtBus.emit(PRELOAD_EVENT.UPDATE, {
                instanceId: _this.instanceId,
                remainTime: data.countdown,
            });
        };
        _this.onAdEnd = function (_a) {
            var _b;
            var data = _a.data;
            if (data.adType === AD_TYPE.PRE) {
                // 前贴结束时，同步广告音量到正片
                _this.corePlayer.volume = (_b = getAdPlugin(_this.instanceId)) === null || _b === void 0 ? void 0 : _b.getAdVolume();
            }
            if (_this.isInValidAd(data))
                return;
            _this.endFlow();
        };
        _this.onAdAssetsLoaded = function (_a) {
            var data = _a.data;
            if (_this.isInValidAd(data))
                return;
            _this.preloadNext(false);
        };
        _this.onAdPlayBlocked = function (_a) {
            var data = _a.data;
            if (_this.isInValidAd(data))
                return;
            _this.isPreload = true;
        };
        _this.onAdPlaying = function () {
            _this.onFirstPlaying();
        };
        _this.onAdTimeUpdate = function () {
            // TODO:
            // 广告有个bug，如果第一个分片失败，没有AD_PLAYING事件。在这个事件里面弥补广告起播
            _this.onFirstPlaying();
        };
        _this.logger = new Logger(_this.instanceId, 'AdFlowNode');
        _this.adType = config.adType;
        // TODO: 这里可以把传进来的corePlayer包装成一个对象，只传入需要使用的东西。（miropeng）
        _this.corePlayer = config.corePlayer;
        _this.enableP2P = config.enableP2P;
        // 自动播放被拦截后 回退到preload状态
        (_a = getAdPlugin(_this.instanceId)) === null || _a === void 0 ? void 0 : _a.on(H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, _this.onAdPlayBlocked);
        return _this;
    }
    AdFlowNode.prototype.getName = function () {
        return "AdFlowNode.".concat(this.adType);
    };
    AdFlowNode.prototype.start = function () {
        this.timeStart(StepKey.PRE_AD_FLOW_NODE);
        this.logger.log("".concat(this.getName(), " exec start"));
        this.emitFlowEvt(FLOW_NODE_EVENT.START);
        if (!this.checkCanPlayAd()) {
            this.logger.log("".concat(this.getName(), " skip exec start"));
            this.endFlow();
            return;
        }
        this.isPreload = false;
        this.bindAdEvents();
        return this.playAd();
    };
    /** 预加载广告，没有广告时继续预加载正片 */
    AdFlowNode.prototype.preload = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log("".concat(this.getName(), " exec preload"));
                        this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD);
                        if (!this.checkCanPlayAd()) {
                            this.logger.log("".concat(this.getName(), " skip exec preload"));
                            this.preloadNext();
                            return [2 /*return*/];
                        }
                        this.isPreload = true;
                        this.bindAdEvents();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ((_a = getAdPlugin(this.instanceId)) === null || _a === void 0 ? void 0 : _a.loadAd(this.startParam))];
                    case 2:
                        data = _b.sent();
                        if (data === false) {
                            this.preloadNext();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        this.preloadNext();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** 暂停广告 */
    AdFlowNode.prototype.pause = function () {
        var _a;
        this.logger.log("".concat(this.getName(), " exec pause"));
        try {
            (_a = getAdPlugin(this.instanceId)) === null || _a === void 0 ? void 0 : _a.pauseAd(this.adType);
        }
        catch (e) {
            this.logger.error('call adPlugin::pauseAd', e);
        }
    };
    /** 恢复播放 */
    AdFlowNode.prototype.resume = function () {
        var _a;
        this.logger.log("".concat(this.getName(), " exec resume"));
        try {
            (_a = getAdPlugin(this.instanceId)) === null || _a === void 0 ? void 0 : _a.resumeAd(this.adType);
        }
        catch (e) {
            this.logger.error('call adPlugin::resumeAd', e);
        }
    };
    AdFlowNode.prototype.destroy = function () {
        if (this.isDestroyed) {
            return;
        }
        var adPlugin = getAdPlugin(this.instanceId);
        if (adPlugin) {
            adPlugin.off(H5_EXT_EVENT.AD_COUNTDOWN_CHANGE, this.onAdCountdown);
            adPlugin.off(H5_PLAY_EVENT.AD_END, this.onAdEnd);
            adPlugin.off(H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying);
            adPlugin.off(H5_PLAY_EVENT.AD_TIME_UPDATE, this.onAdTimeUpdate);
            adPlugin.off(H5_PLAY_EVENT.AD_ASSETS_LOADED, this.onAdAssetsLoaded);
            adPlugin.off(H5_PLAY_EVENT.AD_AUTOPLAY_BLOCKED, this.onAdPlayBlocked);
        }
        this.corePlayer = null;
        _super.prototype.destroy.call(this);
    };
    /** 返回是否可播广告。不可播时直接进入下一流程 */
    AdFlowNode.prototype.checkCanPlayAd = function () {
        var _a = this, instanceId = _a.instanceId, reqInfo = _a.reqInfo;
        var adPlugin = getAdPlugin(instanceId);
        if (!adPlugin || !this.startParam)
            return false;
        var canPlayAd = true;
        if (reqInfo === null || reqInfo === void 0 ? void 0 : reqInfo.adInfoCache) {
            try {
                adPlugin.setAdInfo(reqInfo.adInfoCache);
            }
            catch (e) {
                this.logger.error('checkCanPlayAd, call adPlugin::setAdInfo', e);
                canPlayAd = false;
            }
            // 用一次就销毁
            reqInfo.adInfoCache = void 0;
        }
        return canPlayAd;
    };
    AdFlowNode.prototype.bindAdEvents = function () {
        var adPlugin = getAdPlugin(this.instanceId);
        if (!adPlugin)
            return;
        adPlugin.on(H5_EXT_EVENT.AD_COUNTDOWN_CHANGE, this.onAdCountdown);
        adPlugin.on(H5_PLAY_EVENT.AD_PLAYING, this.onAdPlaying);
        adPlugin.on(H5_PLAY_EVENT.AD_TIME_UPDATE, this.onAdTimeUpdate);
        adPlugin.on(H5_PLAY_EVENT.AD_END, this.onAdEnd);
        adPlugin.on(H5_PLAY_EVENT.AD_ASSETS_LOADED, this.onAdAssetsLoaded);
    };
    AdFlowNode.prototype.playAd = function () {
        var _this = this;
        var _a;
        this.timeStart(StepKey.AD_CDN_REQ);
        // playAd后如果没有广告内容会进入catch，需要手动结束当前节点；其他情况（广告播放结束、播放异常、cgi未返回等）则会自己触发ad_end
        return (_a = getAdPlugin(this.instanceId)) === null || _a === void 0 ? void 0 : _a.playAd(this.startParam).catch(function () { return _this.endFlow(); });
    };
    Object.defineProperty(AdFlowNode.prototype, "startParam", {
        get: function () {
            return __assign({ adType: this.adType }, this.reqInfo.startParam.adParam);
        },
        enumerable: false,
        configurable: true
    });
    /** 预加载下一个节点 */
    AdFlowNode.prototype.preloadNext = function (forceLoad) {
        if (forceLoad === void 0) { forceLoad = true; }
        this.emit(FLOW_NODE_EVENT.PRELOAD_NEXT, {
            name: this.getName(),
            forceLoad: forceLoad,
        });
    };
    /** 当前广告播放完毕后销毁自身节点 */
    AdFlowNode.prototype.endFlow = function () {
        this.timeEnd(StepKey.PRE_AD_FLOW_NODE);
        this.emitFlowEvt(FLOW_NODE_EVENT.END);
        this.destroy();
    };
    /** 触发事件的是否非当前广告 */
    AdFlowNode.prototype.isInValidAd = function (data) {
        return data.adType !== this.adType;
    };
    AdFlowNode.prototype.timeStart = function (key) {
        if (this.adType === AD_TYPE.PRE) {
            StepTimer.start(key, this.instanceId);
        }
    };
    AdFlowNode.prototype.timeEnd = function (key) {
        if (this.adType === AD_TYPE.PRE) {
            StepTimer.end(key, this.instanceId);
        }
    };
    AdFlowNode.prototype.onFirstPlaying = function () {
        if (this.isFirstPlaying) {
            return;
        }
        if (this.adType !== AD_TYPE.PRE) {
            // 前贴才有首播
            return;
        }
        this.isFirstPlaying = true;
        this.timeEnd(StepKey.AD_CDN_REQ);
        this.emit(FLOW_NODE_EVENT.SESSION_FIRST_PLAYING, { name: this.getName() });
    };
    __decorate([
        once,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AdFlowNode.prototype, "bindAdEvents", null);
    __decorate([
        once,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AdFlowNode.prototype, "preloadNext", null);
    return AdFlowNode;
}(BaseFlowNode));

/** 流程控制器，当前流程结束时会调用onFlowEnd */
var FlowManager = /** @class */ (function () {
    // eslint-disable-next-line no-useless-constructor
    function FlowManager(config) {
        this.config = config;
        /** 流程节点数组 */
        this.flowNodeList = [];
        /** 当前节点序号 */
        this.currentFlowNodeIndex = 0;
        /** 所有标记为last的节点 */
        this.lastNodeList = [];
        this.logger = new Logger(config.playerInstanceId, 'FlowManager');
    }
    Object.defineProperty(FlowManager.prototype, "onFlowEnd", {
        /** 1.没有下一节点 2.节点主动clear 3.标记为last的节点结束 这三种情况会调用此方法 */
        get: function () {
            return this.config.onFlowEnd || (function () { });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowManager.prototype, "onFlowEvts", {
        get: function () {
            return this.config.onFlowEvts || (function () { });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowManager.prototype, "currentFlowNode", {
        /** 当前节点 */
        get: function () {
            return this.flowNodeList[this.currentFlowNodeIndex];
        },
        enumerable: false,
        configurable: true
    });
    /** push节点 */
    FlowManager.prototype.push = function () {
        var _a;
        var _this = this;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        nodes.forEach(function (v) { return _this.bindNodeEvents(v); });
        (_a = this.flowNodeList).push.apply(_a, nodes);
    };
    /** 设置Last节点 */
    FlowManager.prototype.setLastNode = function (node) {
        this.lastNodeList.push(node);
    };
    /** 清除当前流程节点，解绑事件 */
    FlowManager.prototype.clear = function () {
        this.flowNodeList.forEach(function (node) { return node.destroy(); });
        this.flowNodeList = [];
        this.lastNodeList = [];
        this.currentFlowNodeIndex = 0;
    };
    /** 监听节点事件 */
    FlowManager.prototype.bindNodeEvents = function (node) {
        var _a;
        var _this = this;
        var nodeEvtMap = (_a = {},
            _a[FLOW_NODE_EVENT.PRELOAD_NEXT] = function (_a) {
                var _b;
                var data = _a.data;
                // 当传入 forceLoad: true 时，可以在单 video 模式下执行预加载。主要是为了让 load({ vid }) 能加载到正片信息，否则后续调用 play() 无法起播
                // 1. load 时如果没有广告，需要加载正片
                // 2. 前贴 proxyHttp 节点结束后，需要预加载广告
                if (!_this.config.disablePreload || (data === null || data === void 0 ? void 0 : data.forceLoad)) {
                    (_b = _this.getNextNode(node)) === null || _b === void 0 ? void 0 : _b.preload(!!(data === null || data === void 0 ? void 0 : data.forceLoad));
                }
            },
            _a[FLOW_NODE_EVENT.END] = function (_a) {
                var data = _a.data;
                // 当正片结束抛出 endState 时记录这个状态，等流程结束抛出 session end 时带上
                if (data.videoEndState) {
                    _this.videoEndState = data.videoEndState;
                }
                node.removeAllListeners();
                var nextNode = _this.getNextNode(node);
                // 没有下一个节点，清空流程
                if (!nextNode) {
                    var curFlowNodeName = node.getName();
                    _this.logger.log("no next node after ".concat(curFlowNodeName, ", clear"));
                    // 必须clear再在onFlowEnd中派发SESSION_END事件，否则别人监听的SESSION_END同步执行时，flow-manager里面变量还未被清理
                    _this.clear();
                    _this.onFlowEnd({ code: ErrorCode.SUC, endState: _this.videoEndState, curFlowNodeName: curFlowNodeName });
                    _this.videoEndState = '';
                    return;
                }
                // 判断是否结束当前流程
                if (_this.lastNodeList.includes(node)) {
                    var curFlowNodeName = node.getName();
                    _this.logger.log("lastNodeList includes ".concat(curFlowNodeName, ", end"));
                    return _this.onFlowEnd({ code: ErrorCode.SUC, curFlowNodeName: curFlowNodeName });
                }
                _this.currentFlowNodeIndex += 1;
                _this.logger.log("next node start, current index is ".concat(_this.currentFlowNodeIndex));
                nextNode.start();
            },
            _a[FLOW_NODE_EVENT.ABORT] = function (_a) {
                var data = _a.data;
                var curFlowNodeName = node.getName();
                _this.clear();
                _this.onFlowEnd(__assign(__assign({}, data), { endState: data.endState || END_STATE.ERROR, curFlowNodeName: curFlowNodeName }));
            },
            _a);
        Object.keys(FLOW_NODE_EVENT).forEach(function (k) {
            node.on(FLOW_NODE_EVENT[k], function (_a) {
                var type = _a.type, data = _a.data;
                _this.logger.log("".concat(node.getName(), " emited FLOW_NODE_EVENT: ").concat(type));
                _this.onFlowEvts(type, data);
                if (nodeEvtMap[type]) {
                    nodeEvtMap[type]({ data: data });
                }
            });
        });
    };
    /** 实时获取下一节点 */
    FlowManager.prototype.getNextNode = function (node) {
        var nodeIndex = this.flowNodeList.indexOf(node);
        if (nodeIndex === -1)
            return;
        return this.flowNodeList[nodeIndex + 1];
    };
    return FlowManager;
}());

/**
 * 请求广告信息的节点。例如请求后贴广告
 */
var GetAdinfoFlowNode = /** @class */ (function (_super) {
    __extends(GetAdinfoFlowNode, _super);
    function GetAdinfoFlowNode(flowNodeConfig) {
        var _this = _super.call(this, flowNodeConfig) || this;
        _this.flowNodeConfig = flowNodeConfig;
        _this.logger = new Logger(_this.instanceId, 'GetAdinfoFlowNode');
        return _this;
    }
    GetAdinfoFlowNode.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.flowNodeConfig = null;
    };
    GetAdinfoFlowNode.prototype.getName = function () {
        return 'GetAdinfoFlowNode';
    };
    GetAdinfoFlowNode.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.emitFlowEvt(FLOW_NODE_EVENT.START);
                        this.isPreload = false;
                        if (!this.loadDefer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadDefer];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.requestProxyHttpWithParams(this.flowNodeConfig.adType)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        // 广告请求信息出错并不是致命的，不播放广告就可以了，因此不派发ABORT事件
                        this.logger.error("".concat(this.getName(), " start err=").concat(error_1 === null || error_1 === void 0 ? void 0 : error_1.message));
                        return [3 /*break*/, 5];
                    case 5:
                        this.emitFlowEvt(FLOW_NODE_EVENT.END);
                        return [2 /*return*/];
                }
            });
        });
    };
    GetAdinfoFlowNode.prototype.pause = function () { };
    GetAdinfoFlowNode.prototype.resume = function () { };
    GetAdinfoFlowNode.prototype.preload = function () {
        var _this = this;
        this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD);
        this.isPreload = true;
        this.loadDefer = this.requestProxyHttpWithParams(this.flowNodeConfig.adType)
            .then(function () {
            _this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD_NEXT);
        })
            .catch(function (error) {
            // 广告请求信息出错并不是致命的，不播放广告就可以了，因此不派发ABORT事件
            _this.logger.error("".concat(_this.getName(), " preload err=").concat(error === null || error === void 0 ? void 0 : error.message));
        });
        return this.loadDefer;
    };
    GetAdinfoFlowNode.prototype.requestProxyHttpWithParams = function (adType) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var adInfo;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ((_b = (_a = this.flowNodeConfig).requestAdCallback) === null || _b === void 0 ? void 0 : _b.call(_a, adType))];
                    case 1:
                        adInfo = _c.sent();
                        if (this.isDestroyed) {
                            // 避免stop等调用后流程都结束了还在继续往下执行
                            return [2 /*return*/, new Promise(function () { })];
                        }
                        if (!adInfo) {
                            this.logger.warn('no ad info');
                            return [2 /*return*/];
                        }
                        this.reqInfo.adInfoCache = adInfo;
                        return [2 /*return*/];
                }
            });
        });
    };
    return GetAdinfoFlowNode;
}(BaseFlowNode));

var performanceCost$1 = performanceCostDecoratorCreator('GetVideoInfoFlowNode');
/**
 * 请求视频信息（可能包含广告信息）的节点。用于开播时请求视频信息和前贴广告信息。
 */
var GetVideoInfoFlowNode = /** @class */ (function (_super) {
    __extends(GetVideoInfoFlowNode, _super);
    function GetVideoInfoFlowNode(flowNodeConfig) {
        var _this = _super.call(this, flowNodeConfig) || this;
        _this.logger = new Logger(_this.instanceId, 'GetVideoInfoFlowNode');
        return _this;
    }
    GetVideoInfoFlowNode.prototype.destroy = function () {
        this.logger = null;
        this.loadDefer = null;
        _super.prototype.destroy.call(this);
    };
    GetVideoInfoFlowNode.prototype.getName = function () {
        return 'GetVideoInfoFlowNode';
    };
    GetVideoInfoFlowNode.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.emitFlowEvt(FLOW_NODE_EVENT.START);
                        this.isPreload = false;
                        if (!this.loadDefer) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadDefer];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.request()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.isDestroyed) {
                            return [2 /*return*/];
                        }
                        this.emitFlowEvt(FLOW_NODE_EVENT.END);
                        return [2 /*return*/];
                }
            });
        });
    };
    GetVideoInfoFlowNode.prototype.pause = function () { };
    GetVideoInfoFlowNode.prototype.resume = function () { };
    GetVideoInfoFlowNode.prototype.preload = function () {
        var _this = this;
        this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD);
        this.isPreload = true;
        this.loadDefer = this.request().then(function () {
            // 前贴 cgi 加载完成时，需要强制预加载正片
            _this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD_NEXT, { forceLoad: true });
        });
        return this.loadDefer;
    };
    GetVideoInfoFlowNode.prototype.request = function () {
        var _this = this;
        return this.requestProxyHttpWithParams(AD_TYPE.PRE).catch(function (error) {
            if (_this.isDestroyed) {
                return;
            }
            // 没有code可能是代码报错等
            var _a = error || {}, _b = _a.code, code = _b === void 0 ? ErrorCode.GETINFO_INNER : _b, _c = _a.message, message = _c === void 0 ? t(i18nConfig.h5player.ERROR_GETINFO_INNER) : _c, _d = _a.stack, stack = _d === void 0 ? '' : _d, data = _a.data;
            _this.logger.error("request err, code=".concat(code, ", msg=").concat(message, ", stack=").concat(stack));
            _this.emitFlowEvt(FLOW_NODE_EVENT.ABORT, { code: code, message: message, stack: stack, data: data });
        });
    };
    GetVideoInfoFlowNode.prototype.requestProxyHttpWithParams = function (adType) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var ctx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.reqInfo.getinfoOutputCache) {
                            this.requestFromPreSessionGetinfoCache(this.reqInfo.getinfoOutputCache);
                            return [2 /*return*/];
                        }
                        // 发起新的请求
                        this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_REQ_INFO_START);
                        StepTimer.start(StepKey.GETINFO, this.instanceId);
                        return [4 /*yield*/, doGetinfo(this.instanceId, this.reqInfo, { adType: adType, emitGetinfoEvts: true })];
                    case 1:
                        ctx = _b.sent();
                        // 尝试删除掉直出数据，避免后续再次读到
                        this.reqInfo.clearSrvData();
                        if (this.isDestroyed) {
                            // 避免stop等调用后流程都结束了还在继续往下执行
                            return [2 /*return*/, new Promise(function () { })];
                        }
                        StepTimer.end(StepKey.GETINFO, this.instanceId);
                        this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_REQ_INFO_END, {
                            code: ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.error) === null || _a === void 0 ? void 0 : _a.code) || ErrorCode.SUC,
                            data: ctx,
                        });
                        if (ctx === null || ctx === void 0 ? void 0 : ctx.error) {
                            this.logger.warn('proxyhttp request error data: ', JSON.stringify(ctx.error));
                            throw ctx.error;
                        }
                        this.reqInfo.getinfoOutputCache = ctx;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 可能有上一个session播放时，预加载请求的视频信息数据，有的话直接用
     */
    GetVideoInfoFlowNode.prototype.requestFromPreSessionGetinfoCache = function (getinfoOutputCache) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_REQ_INFO_START);
                        tryEmit(function () { return _this.extEvtDispatcher.emit(H5_EXT_EVENT.GETINFO_START, getinfoOutputCache.reqParams); }, this.logger);
                        return [4 /*yield*/, 0];
                    case 1:
                        _b.sent(); // 不确定有没有必要，感觉这两个事件不同步发好一些
                        this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_REQ_INFO_END, {
                            code: ((_a = getinfoOutputCache === null || getinfoOutputCache === void 0 ? void 0 : getinfoOutputCache.error) === null || _a === void 0 ? void 0 : _a.code) || ErrorCode.SUC,
                            data: getinfoOutputCache,
                        });
                        tryEmit(function () { return _this.extEvtDispatcher.emit(H5_EXT_EVENT.GETINFO_OVER, getinfoOutputCache); }, this.logger);
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        performanceCost$1,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], GetVideoInfoFlowNode.prototype, "requestProxyHttpWithParams", null);
    __decorate([
        performanceCost$1,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], GetVideoInfoFlowNode.prototype, "requestFromPreSessionGetinfoCache", null);
    return GetVideoInfoFlowNode;
}(BaseFlowNode));

/**
 * 预加载下一个视频。首先会请求下一个视频信息（可能包含广告），然后使用读取到的视频地址开始预加载视频数据。
 * 同时会cache住视频信息（可能包含广告），在下一次真正播放时，再次读取cache的视频信息而不会真正请求视频信息后台了。
 */
var PreloadFlowNode = /** @class */ (function (_super) {
    __extends(PreloadFlowNode, _super);
    function PreloadFlowNode(flowNodeConfig) {
        var _this = _super.call(this, flowNodeConfig) || this;
        _this.flowNodeConfig = flowNodeConfig;
        _this.logger = new Logger(_this.instanceId, 'PreloadFlowNode');
        return _this;
    }
    PreloadFlowNode.prototype.getName = function () {
        return 'PreloadFlowNode';
    };
    PreloadFlowNode.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, videoEndTime, corePlayer, playerConfig, isSucc, data, outputData, kernelName, urlConfig, lastRemainTime;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.flowNodeConfig, videoEndTime = _a.videoEndTime, corePlayer = _a.corePlayer, playerConfig = _a.playerConfig;
                        return [4 /*yield*/, this.getNextSessionVideoInfo()];
                    case 1:
                        isSucc = _b.sent();
                        if (!isSucc) {
                            return [2 /*return*/];
                        }
                        if (this.flowNodeConfig.playerConfig.maxVideoNodeCount <= 1)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.loadAd()];
                    case 2:
                        data = _b.sent();
                        if (data !== false)
                            return [2 /*return*/];
                        outputData = this.reqInfo.getinfoOutputCache;
                        // 将 m3u8 内容交给 tvk 处理
                        this.extEvtDispatcher.emit(H5_EXT_EVENT.PRELOAD_GETINFO_OVER, outputData);
                        kernelName = outputData.kernelName, urlConfig = outputData.urlConfig;
                        this.preloadKernel = kernelName;
                        preloadEvtBus.emit(PRELOAD_EVENT.START, {
                            kernelName: kernelName,
                            urlConfig: urlConfig,
                            instanceId: this.instanceId,
                            videoLoadParam: this.reqInfo.videoLoadParam,
                            playerConfig: playerConfig,
                        });
                        this.logger.log("start; kernelName=".concat(kernelName));
                        lastRemainTime = -1;
                        this.preloadLoop = new TaskLoop(function () {
                            var endTime = videoEndTime || corePlayer.duration;
                            var remainTime = Math.floor(Math.max(endTime - corePlayer.playtime, 0));
                            // 防止暂停时重复写日志
                            if (lastRemainTime === remainTime)
                                return;
                            lastRemainTime = remainTime;
                            preloadEvtBus.emit(PRELOAD_EVENT.UPDATE, {
                                kernelName: kernelName,
                                remainTime: remainTime,
                            });
                            _this.logger.log("update; kernelName=".concat(kernelName, ", remainTime=").concat(remainTime));
                            if (!remainTime) {
                                _this.preloadLoop.destroy();
                            }
                        }, LoopMode.Timer);
                        this.preloadLoop.start(LOOP_INTERVAL);
                        return [2 /*return*/];
                }
            });
        });
    };
    PreloadFlowNode.prototype.loadAd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reqInfo, adPlugin;
            return __generator(this, function (_a) {
                reqInfo = this.config.reqInfo;
                adPlugin = getAdPlugin(this.instanceId);
                if (!adPlugin || !reqInfo)
                    return [2 /*return*/, false];
                if (reqInfo.adInfoCache) {
                    try {
                        adPlugin.setAdInfo(reqInfo.adInfoCache);
                    }
                    catch (e) {
                        this.logger.error('loadAd, call adPlugin::setAdInfo', e);
                    }
                }
                return [2 /*return*/, adPlugin.loadAd(__assign({ adType: AD_TYPE.PRE }, reqInfo.adParam)).catch(function () { return false; })];
            });
        });
    };
    PreloadFlowNode.prototype.destroy = function () {
        var _a;
        _super.prototype.destroy.call(this);
        preloadEvtBus.emit(PRELOAD_EVENT.STOP, { kernelName: this.preloadKernel });
        this.logger.log("stop; kernelName=".concat(this.preloadKernel));
        (_a = this.preloadLoop) === null || _a === void 0 ? void 0 : _a.destroy();
        this.flowNodeConfig = null;
    };
    PreloadFlowNode.prototype.getNextSessionVideoInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var outputData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, doGetinfo(this.instanceId, this.reqInfo, { adType: AD_TYPE.PRE, emitGetinfoEvts: false })];
                    case 1:
                        outputData = _a.sent();
                        if (this.isDestroyed) {
                            return [2 /*return*/, false];
                        }
                        if (!(outputData === null || outputData === void 0 ? void 0 : outputData.urlConfig) || outputData.error) {
                            this.logger.error('preload() error; urlConfig=', outputData);
                            return [2 /*return*/, false];
                        }
                        this.reqInfo.getinfoOutputCache = outputData;
                        return [2 /*return*/, true];
                }
            });
        });
    };
    return PreloadFlowNode;
}(BaseFlowNode));
var LOOP_INTERVAL = 1000;

/** 正片播放流程节点 */
var VideoFlowNode = /** @class */ (function (_super) {
    __extends(VideoFlowNode, _super);
    function VideoFlowNode(flowNodeConfig) {
        var _a;
        var _this = this;
        var _b;
        _this = _super.call(this, flowNodeConfig) || this;
        _this.flowNodeConfig = flowNodeConfig;
        /** 代表正在进行FlowNode中的内部重播流程 */
        _this.isReplaying = false;
        _this.onStateChange = function (_a) {
            var _b;
            var data = _a.data;
            if (data.new === VIDEO_STATE.PLAYING && _this.isReplaying) {
                _this.logger.log('play retry succ');
                _this.isReplaying = false; // 进入playing状态后反转标记,表示结束内部重试流程
                (_b = _this.setLevelDeferWhenReplaying) === null || _b === void 0 ? void 0 : _b.resolve();
                _this.setLevelDeferWhenReplaying = null;
                _this.extEvtDispatcher.emit(H5_EXT_EVENT.RETRY_PLAY_SUCC);
            }
        };
        /** 自动播放被拦截后 回退到preload状态 */
        _this.onVideoPlayBlocked = function () { return _this.isPreload = true; };
        /** 结束前10s（可配置）预加载下一节点 */
        _this.onVideoTimeUpdate = function () {
            var _a;
            if (_this.isLive) {
                // 直播没有下一个节点了
                return;
            }
            var defaultPostAdReqTime = 10;
            var leftTime = (_a = _this.startParam.postAdReqLeftTime) !== null && _a !== void 0 ? _a : defaultPostAdReqTime;
            if (Number.isNaN(leftTime))
                return;
            if (_this.corePlayer.playtime + leftTime >= _this.corePlayer.duration) {
                _this.emitPreloadNext();
            }
        };
        /** video正常结束时进入下一节点 */
        _this.onVideoStop = function (_a) {
            var _b;
            var data = _a.data;
            if (_this.isReplaying) {
                // 如果是在FlowNode中内部重播，会停掉上一次的core中的播放流程，但我们不需要在flow-manager中结束当前节点
                _this.isReplaying = false;
                return;
            }
            var error = (_b = data.videoInfo) === null || _b === void 0 ? void 0 : _b.error;
            if (error)
                return;
            _this.flowOverHandler();
            // 用户手动跳过的，接下来的流程不再继续
            var eventName = data.isUserStop ? FLOW_NODE_EVENT.ABORT : FLOW_NODE_EVENT.END;
            _this.emit(eventName, { videoEndState: data.endState, name: _this.getName() });
        };
        _this.onVideoError = function (_a) {
            var _b;
            var data = _a.data;
            // 仅处理url播放的情况，vid播放的情况由专门的getinfo重试模块处理
            if (!_this.startParam.vid) {
                var error = (_b = data === null || data === void 0 ? void 0 : data.videoInfo) === null || _b === void 0 ? void 0 : _b.error;
                _this.flowOverHandler();
                _this.emitFlowEvt(FLOW_NODE_EVENT.ABORT, __assign(__assign({}, error), { code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.UNKNOWN }));
            }
        };
        _this.onVideoFirstPlaying = function () {
            StepTimer.end(StepKey.V_CDN_REQ, _this.instanceId);
            _this.emit(FLOW_NODE_EVENT.SESSION_FIRST_PLAYING, { name: _this.getName() });
        };
        // 在构造函数这里存一下用户传的kernelName，是为了fix这个值，因为在后续的getinfo返回解析、重试等过程中，都可能修改reqInfo上的此参数
        _this.assignKernelNameByUser = (_b = _this.startParam.videoLoadParam) === null || _b === void 0 ? void 0 : _b.kernelName;
        _this.logger = new Logger(_this.instanceId, 'VideoFlowNode');
        _this.evtMap = (_a = {},
            _a[PLAY_EVENT.FIRST_PLAYING] = _this.onVideoFirstPlaying,
            _a[PLAY_EVENT.TIME_UPDATE] = _this.onVideoTimeUpdate,
            _a[PLAY_EVENT.STOPED] = _this.onVideoStop,
            _a[PLAY_EVENT.ERROR] = _this.onVideoError,
            _a[PLAY_EVENT.STATE_CHANGE] = _this.onStateChange,
            _a[PLAY_EVENT.AUTOPLAY_BLOCKED] = _this.onVideoPlayBlocked,
            _a);
        _this.setPlayerEvents(true);
        return _this;
    }
    Object.defineProperty(VideoFlowNode.prototype, "isLive", {
        get: function () {
            return this.corePlayer.config.type === PLAY_MODE.LIVE;
        },
        enumerable: false,
        configurable: true
    });
    VideoFlowNode.prototype.getName = function () {
        return 'VideoFlowNode';
    };
    /** 播放视频 */
    VideoFlowNode.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, urlConfig, kernelName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log("".concat(this.getName(), " exec start"));
                        this.emitFlowEvt(FLOW_NODE_EVENT.START);
                        if (!this.isPreload) return [3 /*break*/, 3];
                        this.logger.log("".concat(this.getName(), " exec start on preloaded"));
                        if (!this.loadDefer) return [3 /*break*/, 2];
                        // 消费loadDefer
                        return [4 /*yield*/, this.loadDefer.promise];
                    case 1:
                        // 消费loadDefer
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.isLive) {
                            this.corePlayer.resize({ width: '100%' });
                        }
                        this.corePlayer.play();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.getVideoRsp()];
                    case 4:
                        _a = _b.sent(), urlConfig = _a.urlConfig, kernelName = _a.kernelName;
                        if (this.isDestroyed) {
                            // getinfo阶段报错，会直接ABORT整个流程，导致此节点被销毁
                            return [2 /*return*/];
                        }
                        this.updateKernel(kernelName);
                        if (typeof this.flowNodeConfig.videoLoadParamModifier === 'function') {
                            this.startParam.videoLoadParam = this.flowNodeConfig.videoLoadParamModifier(this.startParam.videoLoadParam);
                        }
                        StepTimer.start(StepKey.V_CDN_REQ, this.instanceId);
                        this.corePlayer.play(urlConfig, this.startParam.videoLoadParam);
                        _b.label = 5;
                    case 5:
                        // 通知内核停止预加载
                        this.isPreload = false;
                        preloadEvtBus.emit(PRELOAD_EVENT.STOP, { instanceId: this.corePlayer.config.instanceId });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** 请求接口并加载视频 */
    VideoFlowNode.prototype.preload = function (forceLoad) {
        if (forceLoad === void 0) { forceLoad = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, urlConfig, kernelName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log("".concat(this.getName(), " exec preload"));
                        this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD);
                        this.isPreload = true;
                        this.loadDefer = new SimpleDefer();
                        return [4 /*yield*/, this.getVideoRsp()];
                    case 1:
                        _a = _b.sent(), urlConfig = _a.urlConfig, kernelName = _a.kernelName;
                        if (this.isDestroyed) {
                            // getinfo阶段报错，会直接ABORT整个流程，导致此节点被销毁
                            return [2 /*return*/];
                        }
                        this.updateKernel(kernelName);
                        if (!this.isLive) return [3 /*break*/, 3];
                        // 直播时静音播放正片
                        this.corePlayer.volume = 0;
                        return [4 /*yield*/, this.corePlayer.play(urlConfig, this.startParam.videoLoadParam)];
                    case 2:
                        _b.sent();
                        this.corePlayer.resize({ width: 0 });
                        this.loadDefer.resolve();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.corePlayer.load(urlConfig, __assign(__assign({}, this.startParam.videoLoadParam), { isPreload: !forceLoad }))];
                    case 4:
                        _b.sent();
                        this.loadDefer.resolve();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VideoFlowNode.prototype.pause = function (pauseType) {
        this.logger.log("".concat(this.getName(), " exec pause"));
        this.corePlayer.pause(pauseType);
    };
    VideoFlowNode.prototype.resume = function () {
        this.logger.log("".concat(this.getName(), " exec resume"));
        this.corePlayer.play();
    };
    VideoFlowNode.prototype.setLevel = function (level, extra) {
        var _a, _b, _c;
        if (extra === void 0) { extra = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var preUrlConfig, urlConfig;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        preUrlConfig = (_a = this.corePlayer.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.config;
                        this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_SETLEVEL_START, { level: level });
                        return [4 /*yield*/, this.getLevelUrlConfig(level)];
                    case 1:
                        urlConfig = _d.sent();
                        if (!(urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.url)) {
                            throw new Error('setLevel url is empty');
                        }
                        if (extra.setLevelMode) {
                            urlConfig.setLevelMode = extra.setLevelMode;
                        }
                        else if (!!(preUrlConfig === null || preUrlConfig === void 0 ? void 0 : preUrlConfig.drmConfig) || !!urlConfig.drmConfig || !!urlConfig.chachaParam) {
                            // 加密&非加密交叉播放，需要硬切清晰度
                            urlConfig.setLevelMode = SET_LEVEL_MODE.HARD;
                        }
                        // 未传入的情况下显式指定为hard，避免不兼容的m3u8触发hls无缝切换能力
                        (_b = urlConfig.setLevelMode) !== null && _b !== void 0 ? _b : (urlConfig.setLevelMode = SET_LEVEL_MODE.HARD);
                        // 如果正在进行内部重播流程中，在此时切换清晰度直接重新播放（而不是走切换清晰度流程）。相当于用户主动使用新的清晰度重播
                        if (this.isReplaying) {
                            this.logger.warn('setLevel when replaying');
                            this.setLevelDeferWhenReplaying = new SimpleDefer();
                            // 这里跟规范中async和then不能混用的规则冲突。
                            // 主要是因为本函数先派发了VIDEO_SETLEVEL_START事件，为了阅读逻辑更通顺，函数内也写上了VIDEO_SETLEVEL_END事件
                            this.setLevelDeferWhenReplaying.promise.then(function () {
                                // 因为是重播，core并不会抛出切换清晰度成功事件，需要在这里补事件
                                _this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_SETLEVEL_END, { code: ErrorCode.SUC });
                            });
                            this.replay(urlConfig);
                            return [2 /*return*/, this.setLevelDeferWhenReplaying.promise];
                        }
                        // 切换失败需要补发VIDEO_SETLEVEL_END事件
                        return [2 /*return*/, (_c = this.corePlayer.setLevel(urlConfig.url, urlConfig.backupUrls, urlConfig)) === null || _c === void 0 ? void 0 : _c.catch(function (err) {
                                var _a = err || {}, _b = _a.code, code = _b === void 0 ? ErrorCode.UNKNOWN : _b, message = _a.message;
                                _this.logger.error("core setlevel err, code=".concat(code, ", msg=").concat(message));
                                _this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_SETLEVEL_END, {
                                    code: code,
                                    message: message,
                                    level: level,
                                });
                                throw err;
                            })];
                }
            });
        });
    };
    VideoFlowNode.prototype.updatePlayParam = function (param) {
        var updatedReqParam = __assign(__assign({}, this.startParam.videoReqInfoParam), param === null || param === void 0 ? void 0 : param.videoReqInfoParam);
        var updatedCoreLoadParam = __assign(__assign({}, this.startParam.videoLoadParam), param === null || param === void 0 ? void 0 : param.videoLoadParam);
        this.startParam = __assign(__assign({}, this.startParam), { videoReqInfoParam: updatedReqParam, videoLoadParam: updatedCoreLoadParam });
    };
    /**
     * getinfo级别重播
     * @param vid 播放id
     * @param param 播放参数
     * @param stateWhenErrorHappen 如果是出错时候发生的重播，传入出错时的状态来决定是load还是play
     * @returns
     */
    VideoFlowNode.prototype.replay = function (vid, param, stateWhenErrorHappen) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, error, urlConfig, kernelName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.updatePlayParam(param);
                        // a) url地址重播
                        if (!isVideoId(vid)) {
                            this.logger.log('replay(), start replay urlConfig: ', vid);
                            this.isReplaying = true;
                            return [2 /*return*/, this.corePlayer.play(vid, this.startParam.videoLoadParam)];
                        }
                        // b) 腾讯视频的点播或直播重播
                        this.logger.log('replay(), start request video info: ', this.startParam.videoReqInfoParam);
                        return [4 /*yield*/, doGetinfo(this.instanceId, this.reqInfo, { emitGetinfoEvts: true })];
                    case 1:
                        data = _b.sent();
                        if (this.isDestroyed) {
                            // 避免stop等调用后流程都结束了还在继续往下执行
                            return [2 /*return*/];
                        }
                        _a = data || {}, error = _a.error, urlConfig = _a.urlConfig, kernelName = _a.kernelName;
                        if (error) {
                            throw error;
                        }
                        // 在重试的最后时刻，更新kernelName，主要为了保证用户初始传入的kernelName仍然有效
                        this.updateKernel(kernelName);
                        this.isReplaying = true;
                        this.logger.log("do retry [getinfo], stateWhenErrorHappen=".concat(stateWhenErrorHappen));
                        if (stateWhenErrorHappen === VIDEO_STATE.PAUSE) {
                            return [2 /*return*/, this.corePlayer.load(urlConfig, this.startParam.videoLoadParam)];
                        }
                        return [2 /*return*/, this.corePlayer.play(urlConfig, this.startParam.videoLoadParam)];
                }
            });
        });
    };
    VideoFlowNode.prototype.retry = function (fatal, extra) {
        var _this = this;
        var _a = extra || {}, error = _a.error, updatePlayParam = _a.updatePlayParam, _b = _a.retryTimes, retryTimes = _b === void 0 ? 0 : _b, _c = _a.degradeReason, degradeReason = _c === void 0 ? 0 : _c;
        // 重试前需要把vinfo cache清掉
        this.reqInfo.getinfoOutputCache = void 0;
        if (fatal) {
            // 重试结束
            this.flowOverHandler();
            this.emitFlowEvt(FLOW_NODE_EVENT.ABORT, __assign(__assign({}, error), { code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.UNKNOWN }));
            return;
        }
        // 继续重试
        this.logger.log("play retry, retryTimes=".concat(retryTimes, ", degradeReason=").concat(degradeReason));
        this.extEvtDispatcher.emit(H5_EXT_EVENT.RETRY_PLAY, { retryTimes: retryTimes, degradeReason: degradeReason });
        if (degradeReason !== 0) {
            // 0代表没有降级原因
            this.extEvtDispatcher.emit(H5_EXT_EVENT.DEGRADE_CODEC_PLAY, { degradeReason: degradeReason });
        }
        if (this.isPreload) {
            this.updatePlayParam(updatePlayParam);
            this.preload(true);
        }
        else {
            this.replay(this.startParam.vid, updatePlayParam, extra === null || extra === void 0 ? void 0 : extra.stateWhenErrorHappen).catch(function (error) {
                _this.logger.log("retry replay err=".concat(error === null || error === void 0 ? void 0 : error.code, ", ").concat(error === null || error === void 0 ? void 0 : error.message));
                _this.flowOverHandler();
                _this.emitFlowEvt(FLOW_NODE_EVENT.ABORT, __assign(__assign({}, error), { code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.UNKNOWN }));
            });
        }
    };
    VideoFlowNode.prototype.destroy = function () {
        this.setPlayerEvents(false);
        this.flowNodeConfig = null;
        this.setLevelDeferWhenReplaying = null;
        _super.prototype.destroy.call(this);
    };
    VideoFlowNode.prototype.emitPreloadNext = function () {
        this.emitFlowEvt(FLOW_NODE_EVENT.PRELOAD_NEXT, { forceLoad: true });
    };
    /**
     * 在传给core之前更新内核
     * @param getinfoKernelName getinfo模块自动判断的用哪种kernelName
     */
    VideoFlowNode.prototype.updateKernel = function (getinfoKernelName) {
        var kernelName = getinfoKernelName;
        this.startParam.videoLoadParam = __assign({ kernelName: kernelName }, this.startParam.videoLoadParam);
        if (this.assignKernelNameByUser) {
            // 用播放器接口中用户传入的videoLoadParam中的kernelName，这个变量是不会被逻辑改来改去的
            this.startParam.videoLoadParam.kernelName = this.assignKernelNameByUser;
        }
    };
    VideoFlowNode.prototype.getVideoRsp = function () {
        return __awaiter(this, void 0, void 0, function () {
            var urlConfig, vInfo, _a, urlConfig_1, error, err_1, _b, _c, code, message;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        urlConfig = this.startParam.urlConfig;
                        if (urlConfig)
                            return [2 /*return*/, { urlConfig: urlConfig }];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        vInfo = this.reqInfo.getinfoOutputCache;
                        // 用一次就销毁
                        this.reqInfo.getinfoOutputCache = void 0;
                        if (!!vInfo) return [3 /*break*/, 3];
                        return [4 /*yield*/, doGetinfo(this.instanceId, this.reqInfo, { emitGetinfoEvts: true })];
                    case 2:
                        // 可能cache被消耗了会走到此分支。比如在preload过程中发生了重试，那么proxyhttp的结果就被消耗了。
                        vInfo = _d.sent();
                        _d.label = 3;
                    case 3:
                        _a = vInfo || {}, urlConfig_1 = _a.urlConfig, error = _a.error;
                        if (error) {
                            // url 返回异常时中断流程 TODO: 区分预加载下一集时不中断
                            throw error;
                        }
                        if (!isUrlConfigValid(urlConfig_1)) {
                            throw { message: t(i18nConfig.h5player.ERROR_URL_INVALID), code: ErrorCode.GETINFO_PARSE };
                        }
                        return [2 /*return*/, vInfo];
                    case 4:
                        err_1 = _d.sent();
                        _b = err_1 || {}, _c = _b.code, code = _c === void 0 ? ErrorCode.GETINFO_NET : _c, message = _b.message;
                        this.logger.error("getVideoRsp err, code=".concat(code, ", msg=").concat(message));
                        this.flowOverHandler();
                        this.emitFlowEvt(FLOW_NODE_EVENT.ABORT, __assign(__assign({}, err_1), { code: code }));
                        return [2 /*return*/, { urlConfig: null }];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VideoFlowNode.prototype.setPlayerEvents = function (isBind) {
        var _this = this;
        if (isBind === void 0) { isBind = true; }
        var func = isBind ? this.corePlayer.on : this.corePlayer.off;
        Object.keys(this.evtMap).forEach(function (evtName) {
            func.call(_this.corePlayer, evtName, _this.evtMap[evtName]);
        });
    };
    /**
     * 处理当前flownode结束时的逻辑
     */
    VideoFlowNode.prototype.flowOverHandler = function () {
        // pass
    };
    Object.defineProperty(VideoFlowNode.prototype, "corePlayer", {
        get: function () {
            return this.flowNodeConfig.corePlayer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoFlowNode.prototype, "startParam", {
        get: function () {
            return this.reqInfo.startParam;
        },
        set: function (val) {
            this.reqInfo.startParam = val;
        },
        enumerable: false,
        configurable: true
    });
    VideoFlowNode.prototype.getLevelUrlConfig = function (level) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var urlConfig, updatedReqParam, data, liveErrorMessage;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!isUrlConfig(level)) return [3 /*break*/, 1];
                        urlConfig = level;
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(typeof level === 'string')) return [3 /*break*/, 2];
                        urlConfig = { url: level };
                        return [3 /*break*/, 4];
                    case 2:
                        updatedReqParam = __assign(__assign({}, this.startParam.videoReqInfoParam), level);
                        // 更新 videoReqInfoParam, 保留清晰度等请求参数
                        this.startParam = __assign(__assign({}, this.startParam), { videoReqInfoParam: updatedReqParam });
                        return [4 /*yield*/, doGetinfo(this.instanceId, this.reqInfo, { emitGetinfoEvts: true })];
                    case 3:
                        data = _c.sent();
                        if (!data) {
                            this.logger.error('getLevelUrlConfig err, null data');
                            throw new Error();
                        }
                        urlConfig = data.urlConfig;
                        if (data.error) {
                            liveErrorMessage = (_b = (_a = data.error.data) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.msg;
                            this.emitFlowEvt(FLOW_NODE_EVENT.VIDEO_SETLEVEL_END, {
                                code: data.error.code || ErrorCode.UNKNOWN,
                                // 优先取直播的错误文案
                                message: liveErrorMessage || data.error.message,
                                level: level,
                            });
                            throw data.error;
                        }
                        _c.label = 4;
                    case 4: return [2 /*return*/, urlConfig];
                }
            });
        });
    };
    __decorate([
        once,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VideoFlowNode.prototype, "emitPreloadNext", null);
    return VideoFlowNode;
}(BaseFlowNode));
/** 检查urlConfig(数组)是否都包含url字段 */
function isUrlConfigValid(urlConfig) {
    if (Array.isArray(urlConfig)) {
        return urlConfig.every(isUrlConfig);
    }
    return isUrlConfig(urlConfig);
}
function isUrlConfig(param) {
    return typeof (param === null || param === void 0 ? void 0 : param.url) === 'string';
}

/** 实现流程化功能的播放器 */
var FlowPlayer = /** @class */ (function (_super) {
    __extends(FlowPlayer, _super);
    function FlowPlayer(config) {
        var _this = _super.call(this) || this;
        /** 是否正在切换清晰度 */
        _this.isSettingLevel = false;
        /** 是否是正片首次播放（区别于core中的首次播放，在h5player这里需要考虑发生重试等情况） */
        _this.isFirstPlaying = true;
        /** 是否是首次播放，这个变量不区分正片还是广告 */
        _this.isSessionFirstPlaying = false;
        /** 在当前流程结束时广播session end,data: { code: string; endState: END_STATE } */
        _this.onFlowEnd = function (data) {
            var _a;
            var _b = data.code, code = _b === void 0 ? ErrorCode.SUC : _b, _c = data.endState, endState = _c === void 0 ? END_STATE.NORMAL : _c, curFlowNodeName = data.curFlowNodeName;
            _this.log("onFlowEnd, code=".concat(code, ", endState=").concat(endState, ", curFlowNodeName=").concat(curFlowNodeName));
            // 直播正片出错时停止广告 TODO:直播切换合并接口后可删除此逻辑
            if (_this.config.type === PLAY_MODE.LIVE) {
                try {
                    (_a = getAdPlugin(_this.config.instanceId)) === null || _a === void 0 ? void 0 : _a.stopAd();
                }
                catch (e) {
                    _this.logger.error('onFlowEnd, call adPlugin::stopAd', e);
                }
            }
            _this.emit(PLAY_EVENT.SET_LOADING, { show: false });
            _this.emit(H5_PLAY_EVENT.PLAY_SESSION_END, __assign(__assign({}, data), { endState: endState, code: code, curFlowNodeName: curFlowNodeName }));
        };
        _this.onFlowEvts = function (evtType, data) {
            var _a;
            // 将`FLOW_NODE_EVENT`事件转发为`H5_EXT_EVENT`事件
            var evtNameMap = (_a = {},
                _a[FLOW_NODE_EVENT.PRELOAD] = H5_EXT_EVENT.FLOW_NODE_PRELOAD,
                _a[FLOW_NODE_EVENT.START] = H5_EXT_EVENT.FLOW_NODE_START,
                _a[FLOW_NODE_EVENT.END] = H5_EXT_EVENT.FLOW_NODE_END,
                _a[FLOW_NODE_EVENT.ABORT] = H5_EXT_EVENT.FLOW_NODE_ABORT,
                _a);
            if (evtNameMap[evtType]) {
                _this.pluginMsg.emit(evtNameMap[evtType], data);
            }
            else if (evtType === FLOW_NODE_EVENT.SESSION_FIRST_PLAYING && !_this.isSessionFirstPlaying) {
                // SESSION_FIRST_PLAYING事件需要单独处理下，因为广告和正片的事件只需要发出去一个
                _this.isSessionFirstPlaying = true;
                _this.pluginMsg.emit(H5_EXT_EVENT.SESSION_FIRST_PLAYING, { isAd: (data === null || data === void 0 ? void 0 : data.name) !== 'VideoFlowNode' });
            }
            // 将`FLOW_NODE_EVENT`事件转发为`H5_PLAY_EVENT`事件（这里可以用map重构下）
            // 下面的事件不需要name属性
            data.name; var evtData = __rest(data, ["name"]);
            if ((data === null || data === void 0 ? void 0 : data.name) === 'GetVideoInfoFlowNode') {
                // 请求视频信息的节点需要触发播放器流程事件
                if (evtType === FLOW_NODE_EVENT.VIDEO_REQ_INFO_START) {
                    tryEmit(function () { return _this.emit(H5_PLAY_EVENT.VIDEO_REQ_INFO_START); }, _this.logger);
                }
                else if (evtType === FLOW_NODE_EVENT.VIDEO_REQ_INFO_END) {
                    _this.timeStart(StepKey.GETINFO_END);
                    tryEmit(function () { return _this.emit(H5_PLAY_EVENT.VIDEO_REQ_INFO_END, evtData); }, _this.logger);
                    _this.timeEnd(StepKey.GETINFO_END);
                }
            }
            else if ((data === null || data === void 0 ? void 0 : data.name) === 'VideoFlowNode') {
                if (evtType === FLOW_NODE_EVENT.VIDEO_SETLEVEL_START) {
                    tryEmit(function () { return _this.emit(H5_PLAY_EVENT.VIDEO_SETLEVEL_START, evtData); }, _this.logger);
                }
                else if (evtType === FLOW_NODE_EVENT.VIDEO_SETLEVEL_END) {
                    tryEmit(function () { return _this.emit(H5_PLAY_EVENT.VIDEO_SETLEVEL_END, evtData); }, _this.logger);
                }
            }
        };
        // 移动端默认启用单video模式
        var _a = config.useSingleVideoElement, useSingleVideoElement = _a === void 0 ? uaTool.mobile : _a;
        _this.corePlayer = new KernelProxy(__assign(__assign({}, config), { maxVideoNodeCount: useSingleVideoElement ? 1 : config === null || config === void 0 ? void 0 : config.maxVideoNodeCount, createVideoNodeWhenLoad: useSingleVideoElement }));
        _this.logger = new Logger(_this.config.instanceId, 'FlowPlayer');
        _this.flowManager = new FlowManager({
            playerInstanceId: _this.config.instanceId,
            onFlowEnd: _this.onFlowEnd,
            onFlowEvts: _this.onFlowEvts,
            disablePreload: useSingleVideoElement,
        });
        _this.retryManager = new RetryManager(_this);
        _this.proxyAllPlayEvent();
        _this.proxyStateChange();
        _this.proxyVideoStopped();
        proxyPlayEvent(_this, _this.corePlayer);
        _this.on(H5_PLAY_EVENT.PLAY_SESSION_START, function () {
            _this.isSettingLevel = false;
        });
        return _this;
    }
    Object.defineProperty(FlowPlayer.prototype, "container", {
        get: function () {
            return this.corePlayer.container;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "instanceId", {
        /**
         * 播放器实例id
         */
        get: function () {
            return this.config.instanceId;
        },
        enumerable: false,
        configurable: true
    });
    FlowPlayer.prototype.timeStart = function (key) {
        StepTimer.start(key, this.instanceId);
    };
    FlowPlayer.prototype.timeEnd = function (key) {
        if (this._destroyed) {
            // 统计某些异步耗时的结束时，播放器可能已经被销毁
            return;
        }
        StepTimer.end(key, this.instanceId);
    };
    Object.defineProperty(FlowPlayer.prototype, "videoElementsContainer", {
        /**
         * video标签容器
         */
        get: function () {
            return this.corePlayer.videoElementsContainer;
        },
        enumerable: false,
        configurable: true
    });
    FlowPlayer.prototype.load = function (item, param) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!item)
                    return [2 /*return*/, this.corePlayer.load()];
                this.createFlowNodes(item, param);
                return [2 /*return*/, (_a = this.flowManager.currentFlowNode) === null || _a === void 0 ? void 0 : _a.preload()];
            });
        });
    };
    FlowPlayer.prototype.play = function (item, param) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!item)
                    return [2 /*return*/, this.resumePlay()];
                this.createFlowNodes(item, param);
                this.emit(PLAY_EVENT.SET_LOADING, { show: true });
                return [2 /*return*/, (_a = this.flowManager.currentFlowNode) === null || _a === void 0 ? void 0 : _a.start()];
            });
        });
    };
    /** 预加载下一集流程 */
    FlowPlayer.prototype.preload = function (item, param, videoEndTime) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.log('preload()', item, param);
                this.endPreload();
                this.nextReqInfo = new FlowNodeReqInfo({
                    flowid: commonTool.createGUID(),
                    startParam: this.getStartParam(item, param),
                    instanceId: this.config.instanceId,
                });
                this.nextFlowManager = new FlowManager({
                    playerInstanceId: this.config.instanceId,
                });
                this.nextFlowManager.push(new PreloadFlowNode({
                    corePlayer: this.corePlayer,
                    extEvtDispatcher: this.pluginMsg,
                    reqInfo: this.nextReqInfo,
                    playerConfig: this.config,
                    videoEndTime: videoEndTime,
                }));
                this.nextFlowManager.currentFlowNode.start();
                return [2 /*return*/];
            });
        });
    };
    FlowPlayer.prototype.setAudioTrack = function (id) {
        return this.corePlayer.setAudioTrack(id);
    };
    FlowPlayer.prototype.getAudioTrackList = function () {
        if (!this.currentVideoInfo)
            return [];
        return this.currentVideoInfo.audioTracks;
    };
    FlowPlayer.prototype.getCurrentAudioTrack = function () {
        if (!this.currentVideoInfo)
            return NaN;
        return this.currentVideoInfo.currentAudioTrack;
    };
    /**
     * 更新当前播放参数。（例如直播回看场景下，播放进度一直在更新，此时需要更新播放时间避免VideoFlowNode切换清晰度时当前回看时间未更新）
     * @param reqInfo 需要更新的播放参数
     */
    FlowPlayer.prototype.updateReqInfo = function (reqInfo) {
        if (!reqInfo || !this.curReqInfo) {
            return;
        }
        var videoReqInfoParam = reqInfo.videoReqInfoParam, videoLoadParam = reqInfo.videoLoadParam;
        if (videoLoadParam) {
            Object.assign(this.curReqInfo.videoLoadParam, videoLoadParam);
        }
        if (videoReqInfoParam) {
            Object.assign(this.curReqInfo.videoReqInfoParam, videoReqInfoParam);
        }
    };
    FlowPlayer.prototype.setLevel = function (level, extra) {
        if (extra === void 0) { extra = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.checkCanSetLevel()) {
                            throw new Error('setLevel can\'t start');
                        }
                        this.isSettingLevel = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.videoNode.setLevel(level, extra)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        // 抛出异常，让外部不要更新UI
                        throw err_1;
                    case 4:
                        this.isSettingLevel = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FlowPlayer.prototype.preloadVid = function (_vid) {
        throw new Error('Method not implemented.');
    };
    FlowPlayer.prototype.pause = function (pauseType) {
        var flowNode = this.flowManager.currentFlowNode;
        if (!flowNode) {
            return this.corePlayer.pause(pauseType);
        }
        return flowNode.pause(pauseType);
    };
    FlowPlayer.prototype.seek = function (time) {
        return this.corePlayer.seek(time);
    };
    /** 终止当前广告和视频，中断VideoReq */
    FlowPlayer.prototype.stop = function (endState) {
        var _a, _b, _c, _d;
        // 检查流程控制器是否处于播放流程中，如果没有则无法 stop
        if (!this.flowManager.currentFlowNode)
            return;
        var curFlowNodeName = this.flowManager.currentFlowNode.getName();
        this.log("stop(), endState=".concat(endState, ", curFlowNodeName=").concat(curFlowNodeName));
        // 先清空流程，然后停止广告和正片，保证停止时不继续触发流程
        this.flowManager.clear();
        // 停止播放时要停止预加载下一集
        this.endPreload();
        try {
            (_b = getAdPlugin((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceId)) === null || _b === void 0 ? void 0 : _b.stopAd();
        }
        catch (e) {
            this.logger.error('stop, call adPlugin::stopAd', e);
        }
        (_d = getGetinfoModule((_c = this.config) === null || _c === void 0 ? void 0 : _c.instanceId)) === null || _d === void 0 ? void 0 : _d.abort();
        this.corePlayer.stop(endState);
        this.emit(PLAY_EVENT.SET_LOADING, { show: false });
        this.emit(H5_PLAY_EVENT.PLAY_SESSION_END, {
            curFlowNodeName: curFlowNodeName,
            code: ErrorCode.SUC,
            endState: endState || END_STATE.INTERRUPT,
        });
    };
    /**
     * 开始执行getinfo级别重试播放
     * @param retryConfig 重试配置
     * @param fatal 是否最终重试
     * @returns
     */
    FlowPlayer.prototype.startGetinfoRetry = function (retryConfig, fatal) {
        if (!this.videoNode) {
            return false;
        }
        this.videoNode.retry(fatal, retryConfig);
        return true;
    };
    FlowPlayer.prototype.canGetinfoRetry = function () {
        return true;
    };
    FlowPlayer.prototype.getRetryCheckClasses = function () {
        return [CheckNormalError];
    };
    FlowPlayer.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.corePlayer.destroy();
    };
    /** 判断是否可以执行切换清晰度的逻辑 */
    FlowPlayer.prototype.checkCanSetLevel = function () {
        return this.videoNode && !this.isSettingLevel;
    };
    /** 判断是否使用预加载缓存 */
    FlowPlayer.prototype.checkUsePreloadCache = function (startParam) {
        var _a;
        return !!((_a = this.nextReqInfo) === null || _a === void 0 ? void 0 : _a.vid) && startParam.vid === this.nextReqInfo.vid;
    };
    /** 加载后贴广告。默认是正片结束前10s加载，子类可以调用这个方法来自行决定时机 */
    FlowPlayer.prototype.loadPostAd = function () {
        // 当前节点不是 video-flow-node 时，不做操作
        if (!this.videoNode || this.flowManager.currentFlowNode !== this.videoNode)
            return;
        this.videoNode.emitPreloadNext();
    };
    /**
     * 获取请求“请视频信息”（可能包括广告）节点
     */
    FlowPlayer.prototype.nodeBeforePreAd = function (reqInfo) {
        if (!reqInfo.vid) {
            return null;
        }
        return new GetVideoInfoFlowNode({ reqInfo: reqInfo, extEvtDispatcher: this.pluginMsg });
    };
    /**
     * 获取请求“后贴广告信息”的节点
     */
    FlowPlayer.prototype.nodeBeforePostAd = function (reqInfo) {
        if (this.config.type === PLAY_MODE.LIVE || !reqInfo.vid) {
            return null;
        }
        return new GetAdinfoFlowNode({
            reqInfo: reqInfo,
            adType: AD_TYPE.POST,
            requestAdCallback: this.requestAdCallback.bind(this),
        });
    };
    /**
     * 根据传入的广告类型来请求当前vid下的广告
     * @param adType 广告类型
     * @param adReqParam 广告扩展参数
     * @returns 广告订单信息
     */
    FlowPlayer.prototype.requestAdCallback = function (_adType, _adReqParam) {
        return null;
    };
    Object.defineProperty(FlowPlayer.prototype, "videoNode", {
        get: function () {
            return this.flowManager.flowNodeList.find(function (v) { return v instanceof VideoFlowNode; });
        },
        enumerable: false,
        configurable: true
    });
    /** 转发PLAY_EVENT到当前实例 */
    FlowPlayer.prototype.proxyAllPlayEvent = function () {
        var _this = this;
        Object.keys(PLAY_EVENT).forEach(function (v) {
            _this.corePlayer.on(PLAY_EVENT[v], function (_a) {
                var data = _a.data;
                return _this.emit(PLAY_EVENT[v], data);
            });
        });
    };
    /** 从 PLAY_EVENT.STATE_CHANGE 转发事件 */
    FlowPlayer.prototype.proxyStateChange = function () {
        var _a;
        var _this = this;
        /** 可以直接转发的事件 */
        var eventMap = (_a = {},
            _a[VIDEO_STATE.LOAD_START] = H5_PLAY_EVENT.VIDEO_LOAD_START,
            _a[VIDEO_STATE.CANPLAY] = H5_PLAY_EVENT.VIDEO_CANPLAY,
            _a[VIDEO_STATE.BUFFERING] = H5_PLAY_EVENT.VIDEO_BUFFERING,
            _a[VIDEO_STATE.SEEKING] = H5_PLAY_EVENT.VIDEO_SEEKING,
            _a[VIDEO_STATE.SEEKED] = H5_PLAY_EVENT.VIDEO_SEEKED,
            _a);
        this.corePlayer.on(PLAY_EVENT.STATE_CHANGE, function (_a) {
            var data = _a.data;
            var state = data.new;
            if (eventMap[state])
                return _this.emit(eventMap[state], {});
            if (state === VIDEO_STATE.PLAYING || state === VIDEO_STATE.PAUSE) {
                _this.proxyPlayPause(state, data);
            }
        });
    };
    /** 从 PLAY_EVENT.STOPPED 转发VIDEO_END */
    FlowPlayer.prototype.proxyVideoStopped = function () {
        var _this = this;
        this.corePlayer.on(PLAY_EVENT.STOPED, function (_a) {
            var _b;
            var data = _a.data;
            var error = (_b = data === null || data === void 0 ? void 0 : data.videoInfo) === null || _b === void 0 ? void 0 : _b.error;
            var evtData = __assign(__assign({}, data), { code: (error === null || error === void 0 ? void 0 : error.code) || ErrorCode.SUC });
            _this.emit(H5_PLAY_EVENT.VIDEO_END, evtData);
        });
    };
    /** 转发pause/play事件 */
    FlowPlayer.prototype.proxyPlayPause = function (state, data) {
        if (state === VIDEO_STATE.PLAYING) {
            var isFirst = this.isFirstPlaying;
            this.isFirstPlaying = false;
            // todo: 直播播放广告时，直播可能在后台静音播放，此时也不广播?
            this.emit(H5_PLAY_EVENT.VIDEO_PLAYING, { isFirst: isFirst });
        }
        else if (state === VIDEO_STATE.PAUSE) {
            this.emit(H5_PLAY_EVENT.VIDEO_PAUSE, { pauseType: data.pauseType });
        }
    };
    /** play()，load->play时需要启动当前节点 其他情况直接播放 */
    FlowPlayer.prototype.resumePlay = function () {
        var flowNode = this.flowManager.currentFlowNode;
        if (!flowNode) {
            this.corePlayer.play();
            return;
        }
        if (flowNode.isPreload) {
            flowNode.start();
            return;
        }
        flowNode.resume();
    };
    /** 获取起播参数 */
    FlowPlayer.prototype.getStartParam = function (item, param) {
        var startParam = __assign({}, param);
        if (isVideoId(item)) {
            startParam.vid = item;
        }
        else {
            startParam.urlConfig = item;
        }
        return startParam;
    };
    /** 创建一次播放需要的流程节点 */
    FlowPlayer.prototype.createFlowNodes = function (item, param) {
        var _a, _b, _c, _d;
        // 当前节点不为空时，先终止上次播放
        if (this.flowManager.currentFlowNode) {
            this.log('loadItem(), stop because of currentFlowNode is running');
            this.stop();
        }
        this.endPreload();
        var startParam = this.getStartParam(item, param);
        var isPreload = this.checkUsePreloadCache(startParam);
        var _e = this.config, instanceId = _e.instanceId, enableP2P = _e.enableP2P;
        this.curReqInfo = isPreload
            ? this.nextReqInfo
            : new FlowNodeReqInfo({
                flowid: ((_a = param === null || param === void 0 ? void 0 : param.srvData) === null || _a === void 0 ? void 0 : _a.flowid) || commonTool.createGUID(),
                startParam: startParam,
                instanceId: instanceId,
            });
        this.log("createFlowNodes(), isPreload=".concat(isPreload, ", hasSrvData=").concat(!!(param === null || param === void 0 ? void 0 : param.srvData), ", flowid=").concat(this.curReqInfo.flowid));
        // 清除上次预加载信息
        this.nextReqInfo = null;
        this.curReqInfo.startParam = startParam;
        // 数据中心会监听session start写入flowid
        var flowid = this.curReqInfo.flowid; // 默认32位
        this.resetWhenSessionStart();
        this.timeStart(StepKey.SESSION_START_EVT);
        this.emit(H5_PLAY_EVENT.PLAY_SESSION_START, { flowid: flowid, playItem: item, isPreload: isPreload });
        if (this._destroyed) {
            // 可能在PLAY_SESSION_START事件回调用中播放器被销毁
            return;
        }
        this.timeEnd(StepKey.SESSION_START_EVT);
        // 播放条件的前置检查
        var errorNotMeetPrerequisite = (_c = (_b = this.config).prerequisiteCheck) === null || _c === void 0 ? void 0 : _c.call(_b, item);
        if (errorNotMeetPrerequisite) {
            this.emit(H5_PLAY_EVENT.PLAY_SESSION_END, {
                endState: END_STATE.ERROR,
                code: errorNotMeetPrerequisite.code,
                message: errorNotMeetPrerequisite.message,
            });
            return;
        }
        this.timeStart(StepKey.CREATE_FLOW_NODES);
        // 下面是创建、插入每个节点的逻辑
        var getVideoInfoFlowNode = this.nodeBeforePreAd(this.curReqInfo);
        if (getVideoInfoFlowNode) {
            // 1. 插入请求视频信息（可能包括广告）节点
            this.flowManager.push(getVideoInfoFlowNode);
            // 2. 插入前贴播放节点
            var preAdFlowNode = new AdFlowNode({
                enableP2P: enableP2P,
                adType: AD_TYPE.PRE,
                reqInfo: this.curReqInfo,
                corePlayer: this.corePlayer,
            });
            this.flowManager.push(preAdFlowNode);
        }
        // 3. 插入正片节点
        var videoFlowNode = new VideoFlowNode({
            corePlayer: this.corePlayer,
            reqInfo: this.curReqInfo,
            extEvtDispatcher: this.pluginMsg,
            videoLoadParamModifier: this.videoLoadParamModifier,
        });
        this.flowManager.push(videoFlowNode);
        // 判断下是否需要后贴广告
        var getPostAdInfoFlowNode = this.nodeBeforePostAd(this.curReqInfo);
        if (getPostAdInfoFlowNode) {
            // 4. 插入后贴广告请求节点
            this.flowManager.push(getPostAdInfoFlowNode);
            // 5. 插入后贴广告播放节点
            var postAdFlowNode = new AdFlowNode({
                reqInfo: this.curReqInfo,
                adType: AD_TYPE.POST,
                corePlayer: this.corePlayer,
            });
            this.flowManager.push(postAdFlowNode);
            this.flowManager.setLastNode(postAdFlowNode);
        }
        this.log("loadItem(), flowNodeList=".concat((_d = this.flowManager.flowNodeList) === null || _d === void 0 ? void 0 : _d.map(function (node) { return node.getName(); })));
        this.timeEnd(StepKey.CREATE_FLOW_NODES);
    };
    FlowPlayer.prototype.resetWhenSessionStart = function () {
        this.isFirstPlaying = true;
        this.isSessionFirstPlaying = false;
    };
    FlowPlayer.prototype.endPreload = function () {
        var _a;
        (_a = this.nextFlowManager) === null || _a === void 0 ? void 0 : _a.clear();
        this.nextFlowManager = null;
    };
    Object.defineProperty(FlowPlayer.prototype, "config", {
        get: function () {
            return this.corePlayer.config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "useWorker", {
        get: function () {
            return this.corePlayer.useWorker;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "kernelName", {
        get: function () {
            return this.corePlayer.kernelName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "videoElements", {
        get: function () {
            return this.corePlayer.videoElements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "currentVideoElement", {
        get: function () {
            return this.corePlayer.currentVideoElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "supportPreload", {
        get: function () {
            return this.corePlayer.supportPreload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "duration", {
        get: function () {
            return this.corePlayer.duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "playtime", {
        get: function () {
            return this.corePlayer.playtime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "videoInfos", {
        get: function () {
            return this.corePlayer.videoInfos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "preloadVideoInfos", {
        get: function () {
            return this.corePlayer.preloadVideoInfos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "currentVideoInfo", {
        get: function () {
            return this.corePlayer.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "currentVideoInfoIdx", {
        get: function () {
            return this.corePlayer.currentVideoInfoIdx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "totalVideoInfoCount", {
        get: function () {
            return this.corePlayer.totalVideoInfoCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "supportPlaybackRate", {
        get: function () {
            return this.corePlayer.supportPlaybackRate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "played", {
        get: function () {
            return this.corePlayer.played;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "state", {
        get: function () {
            return this.corePlayer.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "videoSize", {
        get: function () {
            return this.corePlayer.videoSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "videoBuffered", {
        get: function () {
            return this.corePlayer.videoBuffered;
        },
        enumerable: false,
        configurable: true
    });
    FlowPlayer.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this.logger).log.apply(_a, args);
    };
    FlowPlayer.prototype.hasAppended = function (value) {
        return this.corePlayer.hasAppended(value);
    };
    FlowPlayer.prototype.hasPreloaded = function (value) {
        return this.corePlayer.hasPreloaded(value);
    };
    Object.defineProperty(FlowPlayer.prototype, "volume", {
        get: function () {
            return this.corePlayer.volume;
        },
        set: function (val) {
            this.corePlayer.volume = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "volumeGain", {
        get: function () {
            return this.corePlayer.volumeGain;
        },
        set: function (val) {
            this.corePlayer.volumeGain = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "audioEffect", {
        get: function () {
            return this.corePlayer.audioEffect;
        },
        set: function (val) {
            this.corePlayer.audioEffect = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FlowPlayer.prototype, "playbackRate", {
        get: function () {
            return this.corePlayer.playbackRate;
        },
        set: function (val) {
            this.corePlayer.playbackRate = val;
        },
        enumerable: false,
        configurable: true
    });
    FlowPlayer.prototype.resizeVideoElements = function (value) {
        return this.corePlayer.resizeVideoElements(value);
    };
    FlowPlayer.prototype.resize = function (value) {
        return this.corePlayer.resize(value);
    };
    FlowPlayer.prototype.playNext = function (opts) {
        return this.corePlayer.playNext(opts);
    };
    FlowPlayer.prototype.captureVideo = function (dx, dy, dw, dh, extra) {
        return this.corePlayer.captureVideo(dx, dy, dw, dh, extra);
    };
    FlowPlayer.prototype.appendNext = function (value) {
        return this.corePlayer.appendNext(value);
    };
    FlowPlayer.prototype.preloadNext = function () {
        var _a;
        var configs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            configs[_i] = arguments[_i];
        }
        return (_a = this.corePlayer).preloadNext.apply(_a, configs);
    };
    FlowPlayer.prototype.clearAllPreload = function () {
        return this.corePlayer.clearAllPreload();
    };
    FlowPlayer.prototype.triggerAutoplay = function () {
        return this.corePlayer.triggerAutoplay();
    };
    return FlowPlayer;
}(PluginablePlayer));

var StatsCollector = /** @class */ (function () {
    function StatsCollector(player) {
        var _this = this;
        this.player = player;
        this.stats = {};
        this.handlerCollectEvt = function (e) {
            var evtName = e.type, dispatcher = e.target;
            var collectInfos = [];
            _this.collectors.forEach(function (collect) {
                var _a;
                (_a = collect.listeners) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) {
                    if (listener.event === evtName && listener.dispatcher === dispatcher) {
                        collectInfos.push(listener.cb(e));
                    }
                });
            });
            _this.updateInfos(collectInfos);
        };
        this.initCollects();
        this.setCollectEvts(true);
    }
    StatsCollector.prototype.destroy = function () {
        this.setCollectEvts(false);
        this.collectors.length = 0;
        this.stats = {};
    };
    StatsCollector.prototype.getStats = function () {
        this.updateInfos(this.collectors.map(function (collector) { var _a; return (_a = collector.updater) === null || _a === void 0 ? void 0 : _a.call(collector); }));
        return this.stats;
    };
    StatsCollector.prototype.initCollects = function () {
        var _a;
        var _this = this;
        var key2Creator = (_a = {},
            _a[STATS_NAME.VID] = this.createVidCollect,
            _a[STATS_NAME.FLOW_ID] = this.createFlowidCollect,
            _a[STATS_NAME.GUID] = this.createGuidCollect,
            _a[STATS_NAME.KERNEL_NAME] = this.createKernelNameCollect,
            _a[STATS_NAME.CDN_INFO] = this.createCdnCollect,
            _a[STATS_NAME.PLAYER_SIZE] = this.createResolutionCollect,
            _a[STATS_NAME.FRAME_RATE] = this.createFrameRateCollect,
            _a[STATS_NAME.BUFFER_HEALTH] = this.createBufferHealthCollect,
            _a[STATS_NAME.BUFFER_RANGE] = this.createBufferRangeCollect,
            _a[STATS_NAME.NET] = this.createNetCollect,
            _a[STATS_NAME.VIDEO_SIZE] = this.createVideoSizeCollect,
            _a[STATS_NAME.CODEC] = this.createCodecCollect,
            _a);
        this.collectors = Object.keys(key2Creator).map(function (key) { return key2Creator[key].apply(_this, [key]); });
    };
    StatsCollector.prototype.setCollectEvts = function (isBind) {
        var _this = this;
        // 先收集下有哪些事件需要监听，重复监听事件不重复监听，统一处理
        var playerEvtMap = {};
        var extEvtMap = {};
        this.collectors.forEach(function (collect) {
            var _a;
            (_a = collect.listeners) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) {
                // 分开监听，怕`H5_PLAY_EVENT`, `H5_EXT_EVENT`和`PLAY_EVENT`里面有重复的事件名
                if (listener.dispatcher === _this.player) {
                    playerEvtMap[listener.event] = listener.dispatcher;
                }
                else if (listener.dispatcher === _this.player.pluginMsg) {
                    extEvtMap[listener.event] = listener.dispatcher;
                }
            });
        });
        [playerEvtMap, extEvtMap].forEach(function (evtMap) {
            Object.keys(evtMap).forEach(function (evtName) {
                if (isBind) {
                    evtMap[evtName].on(evtName, _this.handlerCollectEvt);
                }
                else {
                    evtMap[evtName].off(evtName, _this.handlerCollectEvt);
                }
            });
        });
    };
    StatsCollector.prototype.updateInfos = function (collectInfos) {
        var _this = this;
        var infos = collectInfos.filter(function (info) { return info && _this.stats[info.key] !== info.value; });
        if (infos.length <= 0) {
            return;
        }
        infos.forEach(function (info) { return _this.stats[info.key] = info.value; });
        this.player.pluginMsg.emit(H5_EXT_EVENT.STATS_CHANGE, infos);
    };
    StatsCollector.prototype.getUpdateInfo = function (key, value) {
        return { key: key, value: value };
    };
    StatsCollector.prototype.createVidCollect = function (key) {
        var _this = this;
        var updater = function () {
            var player = _this.player;
            var datasetVid = player.getCommonKv(COMMON_DATA_KEY.vid);
            // 1. 如果没有 vid，则什么都不展示
            if (!datasetVid) {
                return _this.getUpdateInfo(key, '');
            }
            // 要展示的字符串，用于拼接，默认用 - 占位
            var playItemInfo = '-';
            // 2. 有 vid，把 VID 信息覆盖掉 - 占位
            if (datasetVid) {
                if (player.config.type === PLAY_MODE.LIVE) {
                    playItemInfo = "".concat(datasetVid, "-").concat(player.getCommonKv(COMMON_DATA_KEY.livepid) || 0) || '-';
                }
                else {
                    playItemInfo = datasetVid || '-';
                }
            }
            return _this.getUpdateInfo(key, playItemInfo);
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    dispatcher: this.player.pluginMsg,
                    event: H5_EXT_EVENT.DATASET_UPDATE,
                    cb: function (e) {
                        if (e.data.key === COMMON_DATA_KEY.vid) {
                            return updater();
                        }
                    },
                }],
        };
    };
    StatsCollector.prototype.createFlowidCollect = function (key) {
        var _this = this;
        var updater = function () {
            var suffixStrForSrvData = _this.player.getCommonKv(COMMON_DATA_KEY.isUseSrvData) ? ' (sd)' : '';
            return _this.getUpdateInfo(key, "".concat(_this.player.getCommonKv(COMMON_DATA_KEY.flowid)).concat(suffixStrForSrvData));
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    dispatcher: this.player.pluginMsg,
                    event: H5_EXT_EVENT.DATASET_UPDATE,
                    cb: function (e) {
                        if (e.data.key === COMMON_DATA_KEY.flowid || e.data.key === COMMON_DATA_KEY.isUseSrvData) {
                            return updater();
                        }
                    },
                }],
        };
    };
    StatsCollector.prototype.createGuidCollect = function (key) {
        var _this = this;
        return {
            key: key,
            updater: function () { return _this.getUpdateInfo(key, _this.player.getCommonKv(COMMON_DATA_KEY.guid)); },
        };
    };
    StatsCollector.prototype.createKernelNameCollect = function (key) {
        var _this = this;
        var updater = function () {
            var _a, _b, _c, _d, _e;
            var extName = (_c = urlTool.getFileExtension((_b = (_a = _this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) === null || _b === void 0 ? void 0 : _b.loadingUrl)) !== null && _c !== void 0 ? _c : '-';
            var kernelName = (_d = _this.player.getCommonKv(COMMON_DATA_KEY.curcore)) !== null && _d !== void 0 ? _d : '-';
            var kernelVersion = (_e = _this.player.getCommonKv(COMMON_DATA_KEY.curcorever)) !== null && _e !== void 0 ? _e : VERSION;
            var p2pVer = _this.player.getCommonKv(COMMON_DATA_KEY.p2pver);
            var p2pVerText = p2pVer ? "-p2p-".concat(p2pVer) : '';
            return _this.getUpdateInfo(key, "".concat(extName, "/").concat(kernelName, " (").concat(kernelVersion).concat(p2pVerText, ")"));
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    dispatcher: this.player.pluginMsg,
                    event: H5_EXT_EVENT.DATASET_UPDATE,
                    cb: function (e) {
                        var keys = [
                            COMMON_DATA_KEY.curcorever,
                            COMMON_DATA_KEY.curcore,
                            COMMON_DATA_KEY.p2pver,
                        ];
                        if (keys.indexOf(e.data.key) > -1) {
                            return updater();
                        }
                    },
                }],
        };
    };
    StatsCollector.prototype.createCdnCollect = function (key) {
        var _this = this;
        var updater = function () {
            var _a;
            if (!_this.player.getCommonKv(COMMON_DATA_KEY.vid)) {
                return _this.getUpdateInfo(key, '');
            }
            return _this.getUpdateInfo(key, urlTool.getDomainOfURL(((_a = _this.player.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.loadingUrl) || ''));
        };
        return {
            key: key,
            listeners: [
                {
                    event: H5_PLAY_EVENT.VIDEO_LOAD_START,
                    dispatcher: this.player,
                    cb: updater,
                },
                {
                    event: PLAY_EVENT.RETRY_BACKURL,
                    dispatcher: this.player,
                    cb: updater,
                },
                {
                    event: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                    dispatcher: this.player,
                    cb: updater,
                },
            ],
        };
    };
    StatsCollector.prototype.createResolutionCollect = function (key) {
        var _this = this;
        var updater = function () {
            var _a, _b;
            var _c = _this.player, container = _c.container, getCommonKv = _c.getCommonKv;
            var containerSize = "".concat(container.clientWidth, "*").concat(container.clientHeight);
            var screenSize = getCommonKv(COMMON_DATA_KEY.resolution);
            var isExtended = (_b = (_a = window.screen) === null || _a === void 0 ? void 0 : _a.isExtended) !== null && _b !== void 0 ? _b : false;
            return _this.getUpdateInfo(key, "".concat(containerSize, " / ").concat(screenSize, " (ext:").concat(isExtended, ")"));
        };
        return {
            key: key,
            updater: updater,
        };
    };
    StatsCollector.prototype.createFrameRateCollect = function (key) {
        var _this = this;
        var updater = function () {
            var _a, _b;
            var _c = ((_b = (_a = _this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) === null || _b === void 0 ? void 0 : _b.qualityInfo) || {}, _d = _c.totalVideoFrames, totalVideoFrames = _d === void 0 ? 0 : _d, _e = _c.droppedVideoFrames, droppedVideoFrames = _e === void 0 ? 0 : _e;
            var per = (droppedVideoFrames / totalVideoFrames) * 100;
            return _this.getUpdateInfo(key, "".concat(droppedVideoFrames, "/").concat(totalVideoFrames, "; ").concat(isNaN(per) ? 0 : per.toFixed(2), "%"));
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    event: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                    dispatcher: this.player,
                    cb: updater,
                }],
        };
    };
    StatsCollector.prototype.createBufferHealthCollect = function (key) {
        var _this = this;
        var updater = function () {
            var _a = _this.player, videoBuffered = _a.videoBuffered, playtime = _a.playtime;
            var bufferEnd = videoBuffered.find(function (range) { return range.start <= playtime && range.end >= playtime; });
            if (!bufferEnd) {
                return _this.getUpdateInfo(key, '');
            }
            var health = bufferEnd.end - playtime;
            return _this.getUpdateInfo(key, isNaN(health) ? '-' : "".concat(health.toFixed(2), "s"));
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    event: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                    dispatcher: this.player,
                    cb: updater,
                }, {
                    event: H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                    dispatcher: this.player,
                    cb: updater,
                },
            ],
        };
    };
    StatsCollector.prototype.createBufferRangeCollect = function (key) {
        var _this = this;
        var updater = function () {
            var bufferRange = _this.player.videoBuffered
                .map(function (range) { return "".concat(range.start.toFixed(3), "-").concat(range.end.toFixed(3)); })
                .join(',');
            return _this.getUpdateInfo(key, bufferRange);
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    event: H5_PLAY_EVENT.VIDEO_LOAD_PROGRESS,
                    dispatcher: this.player,
                    cb: updater,
                }],
        };
    };
    StatsCollector.prototype.createNetCollect = function (key) {
        var _this = this;
        var updater = function () {
            var currentVideoInfo = _this.player.currentVideoInfo;
            if (!(currentVideoInfo === null || currentVideoInfo === void 0 ? void 0 : currentVideoInfo.performance)) {
                return _this.getUpdateInfo(key, '');
            }
            var _a = currentVideoInfo.performance, _b = _a.speed, speed = _b === void 0 ? 0 : _b, _c = _a.p2pStats, p2pStats = _c === void 0 ? '' : _c;
            return _this.getUpdateInfo(key, "".concat(speed, " KB/s ").concat(p2pStats));
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    event: H5_PLAY_EVENT.VIDEO_TIMEUPDATE,
                    dispatcher: this.player,
                    cb: updater,
                }],
        };
    };
    StatsCollector.prototype.createVideoSizeCollect = function (key) {
        var _this = this;
        var updater = function () {
            var _a, _b;
            var _c = (_b = (_a = _this.player) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) !== null && _b !== void 0 ? _b : {}, _d = _c.videoHeight, videoHeight = _d === void 0 ? 0 : _d, _e = _c.videoWidth, videoWidth = _e === void 0 ? 0 : _e;
            return _this.getUpdateInfo(key, "".concat(videoWidth, "*").concat(videoHeight));
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    event: PLAY_EVENT.METADATA_CHANGE,
                    dispatcher: this.player,
                    cb: updater,
                }, {
                    event: H5_PLAY_EVENT.VIDEO_SETLEVEL_END,
                    dispatcher: this.player,
                    cb: updater,
                }],
        };
    };
    /**
     * 编码codecs字符串
     */
    StatsCollector.prototype.createCodecCollect = function (key) {
        var _this = this;
        var updater = function () {
            var currentVideoInfo = _this.player.currentVideoInfo;
            if (!currentVideoInfo) {
                return _this.getUpdateInfo(key, '');
            }
            var _a = currentVideoInfo.codecs, codecs = _a === void 0 ? { video: '', audio: '' } : _a;
            var videoCodec = codecs.video, audioCodec = codecs.audio;
            var codecString = (videoCodec && audioCodec) ? "".concat(videoCodec, " / ").concat(audioCodec) : '';
            var vinfoCodec = "(".concat(_this.player.getCommonKv(COMMON_DATA_KEY.codec) || '-', ")");
            return _this.getUpdateInfo(key, "".concat(codecString, " ").concat(vinfoCodec).trim());
        };
        return {
            key: key,
            updater: updater,
            listeners: [{
                    event: PLAY_EVENT.METADATA_CHANGE,
                    dispatcher: this.player,
                    cb: updater,
                }],
        };
    };
    return StatsCollector;
}());
var STATS_NAME;
(function (STATS_NAME) {
    STATS_NAME["VID"] = "vid";
    STATS_NAME["FLOW_ID"] = "flowid";
    STATS_NAME["GUID"] = "guid";
    STATS_NAME["KERNEL_NAME"] = "kernelName";
    STATS_NAME["CDN_INFO"] = "cdnInfo";
    STATS_NAME["PLAYER_SIZE"] = "playerSize";
    STATS_NAME["FRAME_RATE"] = "frameRate";
    STATS_NAME["BUFFER_HEALTH"] = "bufferHealth";
    STATS_NAME["BUFFER_RANGE"] = "bufferRange";
    STATS_NAME["NET"] = "net";
    STATS_NAME["VIDEO_SIZE"] = "videoSize";
    STATS_NAME["CODEC"] = "codec";
})(STATS_NAME || (STATS_NAME = {}));

var _a;
var logMethodCall = logMethodCallDecoratorCreator('H5Player');
var performanceCost = performanceCostDecoratorCreator('H5Player');
var rotateTransformValue = (_a = {},
    _a[PictureDirection.VERTICAL] = 'rotateX(180deg)',
    _a[PictureDirection.HORIZON] = 'rotateY(180deg)',
    _a[PictureDirection.NORMAL] = 'none',
    _a);
/**
  * H5player引用上报
  */
function collectUsage() {
    var channel = 'npm';
    try {
        // @ts-ignore
        channel = "npm";
    }
    catch (_a) {
    }
    // 采集引用上报信息，from定义1标识为H5player使用
    ReferenceReport.getReporter().collectUsage(1, channel);
}
var H5Player = /** @class */ (function (_super) {
    __extends(H5Player, _super);
    function H5Player(config) {
        var _this = this;
        var _a, _b, _c;
        if (!config.isPrivateDeployment) {
            // 采集引用上报信息, 私有部署时不进行上报
            collectUsage();
        }
        _this = _super.call(this, __assign(__assign(__assign({}, defaultH5PlayerConfig), config.coreConfig), config)) || this;
        /** 插件实例 */
        _this.plugins = {};
        /** 交互蒙层，点击后 toggle 播放 / 暂停状态 */
        _this.interactMod = null;
        _this.getCommonKv = function (key) { return _this.dataset.commonMap[key]; };
        _this.getStateKv = function (key) { return _this.dataset.stateMap[key]; };
        /** 静音前的音量 */
        _this.mutedVolume = 1;
        /**
         * 混入方法到player实例上
         * @param {Function |  Object} mix 要混入的方法，通过函数或对象传入
         */
        _this.mixin = function (mix) {
            var mixinObject = typeof mix === 'function' ? mix() : mix;
            Object.keys(mixinObject).forEach(function (method) {
                if (method in _this) {
                    throw new Error("cannot override existing player method: ".concat(method));
                }
                var func = mixinObject[method];
                // 限制只能混入方法，属性建议挂在数据中心
                if (typeof func !== 'function') {
                    console.error("mixin ".concat(func, " is not a function"));
                    return;
                }
                _this[method] = func;
            });
        };
        /**
         * 移动鼠标的回调函数
         * 这里必须 throttle 下，防止状态跳变，并节省性能开销
         */
        _this.mouseMoveHandler = lodash_throttle(function () {
            // 当鼠标移动时，立即清除掉鼠标的隐藏状态
            _this.setMouseState(false);
            // 延迟判断，设置鼠标隐藏状态
            clearTimeout(_this.mouseMoveTimer);
            _this.mouseMoveTimer = setTimeout(_this.setMouseState, AUTO_HIDE_MOUSE_DELAY);
        }, HIDE_MOUSE_THROTTLE);
        _this.setMouseState = function (isHide) {
            var mouseHideState = isHide !== null && isHide !== void 0 ? isHide : _this.shouldHideMouse();
            _this.container.style.cursor = mouseHideState ? 'none' : 'auto';
        };
        _this.log('new H5Player(), input config=', config);
        /** 记录播放器初始化时间 */
        var playerInitTime = Date.now();
        var plugins = config.plugins, mixins = config.mixins;
        _this.fullscreenLogics = new FullScreenLogics(_this, _this.config.fullscreenContainer);
        _this.statsCollector = new StatsCollector(_this);
        // 设置事件监听数量上限
        var maxListeners = 100;
        _this.setMaxListeners(maxListeners);
        _this.createClickMask();
        _this.createInnerPlugins();
        // 创建插件，挂载mixins
        if (plugins instanceof Array) {
            _this.createPlugins(plugins);
        }
        _this.initGetinfoModule(_this.config);
        if (mixins instanceof Array)
            mixins.forEach(_this.mixin);
        _this.autoplayLogics = new AutoPlayLogics(_this);
        _this.initPlayerResizeObserver();
        _this.initPluginApis();
        _this.forwardPluginEvents();
        _this.initContainerStyle();
        _this.setupEventFlagData();
        _this.setupLoopPlay();
        _this.setupMouseAutoHide();
        _this.applyStyleOnVideoNodeChange();
        // 统计播放器初始化耗时
        _this.setStateKv(DATA_STATE.INIT, {
            type: LOG_TYPE.CORE_EVENT,
            ftime: Date.now(),
            ext: { stime: playerInitTime },
        });
        // TEE workaround: 为TEE提供请求全屏前的屏幕信息
        _this.setCommonKv(COMMON_DATA_KEY.TEE_screen, {
            width: (_a = screen === null || screen === void 0 ? void 0 : screen.width) !== null && _a !== void 0 ? _a : -1,
            height: (_b = screen === null || screen === void 0 ? void 0 : screen.height) !== null && _b !== void 0 ? _b : -1,
            dpr: (_c = window.devicePixelRatio) !== null && _c !== void 0 ? _c : -1,
        });
        return _this;
    }
    /** 注册一个需要记录在localStorage中的common key，这个函数需要在初始化thumbplayer前调用 */
    H5Player.registerSavedCommonKey = function (key) {
        if (DataSet.SETTING_CONFIG[key]) {
            console.warn("key ".concat(key, " already registered"));
            return;
        }
        DataSet.SETTING_CONFIG.push({ dsKey: key, lsKey: "__thumbplayer_custom_".concat(key, "__") });
    };
    /** 加载，并缓存加载对象和加载参数 */
    H5Player.prototype.load = function (urlOrVid, param) {
        if (!urlOrVid)
            return _super.prototype.load.call(this);
        this.cacheLoadParam(urlOrVid, param);
        this.corePlayer.load();
        return _super.prototype.load.call(this, urlOrVid, this.getParamWithStartTime(urlOrVid, param));
    };
    /** 播放，并缓存播放对象和播放参数 */
    H5Player.prototype.play = function (urlOrVid, param) {
        if (!urlOrVid)
            return _super.prototype.play.call(this);
        this.cacheLoadParam(urlOrVid, param);
        // 清除video画面
        this.corePlayer.load();
        return _super.prototype.play.call(this, urlOrVid, this.getParamWithStartTime(urlOrVid, param));
    };
    /** 创建插件，并自动转发广告插件的事件 */
    H5Player.prototype.createPlugin = function (insName, option) {
        if (option === void 0) { option = {}; }
        this.timeStart("".concat(StepKey.CREATE_PLUGIN_PREFIX, "_").concat(insName));
        _super.prototype.createPlugin.call(this, insName, option);
        var _a = option.pluginName, pluginName = _a === void 0 ? insName : _a;
        if (pluginName === AdPluginName) {
            // 创建广告插件时，自动监听/代理广告事件
            proxyAdEvent(this);
        }
        this.timeEnd("".concat(StepKey.CREATE_PLUGIN_PREFIX, "_").concat(insName));
    };
    H5Player.prototype.replay = function () {
        var _a, _b, _c;
        var vid = this.vid;
        var url = this.playUrl;
        // 重播时不保留startTime
        (_b = (_a = this.loadParam) === null || _a === void 0 ? void 0 : _a.videoLoadParam) === null || _b === void 0 ? true : delete _b.startTime;
        (_c = this.loadParam) === null || _c === void 0 ? true : delete _c.srvData;
        // 先尝试用vid播放，然后再尝试用url播放
        if (vid)
            return this.play(vid, this.loadParam);
        if (url) {
            // 去除url中的hashtag部分，对应url中用#t=n指定startTime的情况
            var idxHash = url.lastIndexOf('#');
            if (idxHash > 0) {
                url = url.slice(0, idxHash);
            }
            return this.play({ url: url }, this.loadParam);
        }
        this.log('Current player has no available vid or url to replay');
    };
    H5Player.prototype.pause = function (pauseType) {
        return _super.prototype.pause.call(this, pauseType);
    };
    /**
     * @param time 单位：秒
     */
    H5Player.prototype.seek = function (time) {
        var _a = this.timeRange, startTime = _a.startTime, endTime = _a.endTime;
        var seekTime = Math.min(endTime, Math.max(startTime, time));
        return _super.prototype.seek.call(this, seekTime);
    };
    /** 设置视频画面镜像 */
    H5Player.prototype.setPictureImage = function (direction) {
        if (direction === void 0) { direction = PictureDirection.NORMAL; }
        this.pictureDirection = direction;
        if (this.isPlayingAd) {
            this.setAdVideoStyle({ transform: rotateTransformValue[direction] });
        }
        else {
            this.setVideoStyle({ transform: rotateTransformValue[direction] });
        }
        // 将旋转角度恢复为0
        if (direction === PictureDirection.NORMAL) {
            this.rotateDegree = 0;
        }
    };
    /** 设置视频旋转角度 */
    H5Player.prototype.setRotate = function (deg) {
        if (typeof deg !== 'number' || Number.isNaN(deg))
            return;
        this.rotateDegree = deg;
        if (this.isPlayingAd) {
            this.setAdVideoStyle({ transform: "rotate(".concat(deg, "deg)") });
        }
        else {
            this.setVideoStyle({ transform: "rotate(".concat(deg, "deg)") });
        }
    };
    /** 获取视频旋转角度 */
    H5Player.prototype.getRotate = function () {
        return this.rotateDegree;
    };
    /**
     * 进入 / 退出全屏状态
     * @param isEnter 是否进入全屏，true 进入全屏，false 退出全屏
     * @param mode 指定全屏模式，分为系统全屏和 CSS 全屏。默认情况下会自动判断
     */
    H5Player.prototype.requestFullScreen = function (isEnter, mode) {
        var _a, _b, _c;
        if (isEnter === void 0) { isEnter = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_d) {
                if (isEnter) {
                    // TEE workaround: 为TEE提供请求全屏前的屏幕信息
                    this.setCommonKv(COMMON_DATA_KEY.TEE_screen, {
                        width: (_a = screen === null || screen === void 0 ? void 0 : screen.width) !== null && _a !== void 0 ? _a : -1,
                        height: (_b = screen === null || screen === void 0 ? void 0 : screen.height) !== null && _b !== void 0 ? _b : -1,
                        dpr: (_c = window.devicePixelRatio) !== null && _c !== void 0 ? _c : -1,
                    });
                }
                return [2 /*return*/, this.fullscreenLogics.requestFullScreen(isEnter, mode)];
            });
        });
    };
    Object.defineProperty(H5Player.prototype, "fullscreenMode", {
        get: function () {
            return this.fullscreenLogics.fullscreenMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "volume", {
        get: function () {
            return this.corePlayer.volume;
        },
        set: function (val) {
            var _a;
            this.corePlayer.volume = val;
            try {
                (_a = getAdPlugin(this.config.instanceId)) === null || _a === void 0 ? void 0 : _a.setAdVolume(val);
            }
            catch (e) {
                this.logger.error('call adPlugin::setAdVolume', e);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "timeRange", {
        get: function () {
            return this.playtimeLimiter.range;
        },
        enumerable: false,
        configurable: true
    });
    H5Player.prototype.destroy = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        try {
            // try-catch避免重复destroy报错
            this.stop();
            this.pluginMsg.emit(H5_EXT_EVENT.DESTROY);
        }
        catch (err) {
            this.log(err);
        }
        if (this.plugins) {
            // 调用插件实例的销毁
            Object.keys(this.plugins).forEach(function (pluginKey) {
                var _a, _b;
                // 多实例时目前会销毁最后挂载的实例，所以要判断plugins[pluginKey]是否存在
                (_b = (_a = _this.plugins[pluginKey]) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
            delete this.plugins;
        }
        destroyGetinfoModule((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceId);
        // 判断 config 是否存在是为了兼容多次销毁
        setAdPlugin((_b = this.config) === null || _b === void 0 ? void 0 : _b.instanceId, null);
        (_c = this.containerResizeObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
        this.containerResizeObserver = null;
        this.autoplayLogics.destroy();
        this.fullscreenLogics.destroy();
        (_d = this.statsCollector) === null || _d === void 0 ? void 0 : _d.destroy();
        this.statsCollector = null;
        (_e = this.interactMod) === null || _e === void 0 ? void 0 : _e.remove();
        this.interactMod = null;
        this.setupMouseAutoHide(false);
        // 移除鼠标自动隐藏的定时器
        clearTimeout(this.mouseMoveTimer);
        if (this.container.style.cursor === 'none') {
            this.container.style.cursor = 'auto';
        }
        _super.prototype.destroy.call(this);
    };
    Object.defineProperty(H5Player.prototype, "offlineLogPlugin", {
        // 兼容旧版本的属性
        /** @deprecated 离线日志插件 */
        get: function () {
            return this.plugins[OfflineLogPlugin.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "pluginInstances", {
        /** @deprecated use plugins */
        get: function () {
            return this.plugins;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "player", {
        /** @deprecated use this */
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, PlaytimeLimiterPlugin.pluginName, {
        // 内置的插件
        /** 播放时长限制器插件 */
        get: function () {
            return this.plugins[PlaytimeLimiterPlugin.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, DataSet.pluginName, {
        /** 数据中心插件 */
        get: function () {
            return this.plugins[DataSet.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, OfflineLogPlugin.pluginName, {
        /** 离线日志插件 */
        get: function () {
            return this.plugins[OfflineLogPlugin.pluginName];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "vid", {
        // 播放相关属性
        /** 当前播放视频id */
        get: function () {
            return isVideoId(this.currentPlayItem) ? this.currentPlayItem : null;
        },
        enumerable: false,
        configurable: true
    });
    H5Player.prototype.canGetinfoRetry = function () {
        if (!this.player.vid) {
            // 只有播vid的时候有getinfo请求，需要getinfo级别重试
            return false;
        }
        return true;
    };
    Object.defineProperty(H5Player.prototype, "url", {
        /** 当前播放地址 */
        get: function () {
            var _a;
            return (_a = this.currentVideoInfo) === null || _a === void 0 ? void 0 : _a.loadingUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "paused", {
        /** 当前播放器是否为暂停状态 */
        get: function () {
            return this.state === VIDEO_STATE.PAUSE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(H5Player.prototype, "muted", {
        /** 静音 */
        get: function () {
            return this.volume === 0;
        },
        set: function (val) {
            if (this.muted && !val) {
                // case 1 当前为静音状态，操作解除
                this.volume = this.mutedVolume || 1; // 如果因为任何原因this.mutedVolume为0，设置音量为1
            }
            else if (!this.muted && val) {
                // case 2 当前不是静音状态，操作静音
                this.mutedVolume = this.volume;
                this.volume = 0;
            }
            // 除此之外的case都不做处理，避免连续调用的副作用
        },
        enumerable: false,
        configurable: true
    });
    /** 写入dataset的状态字段 */
    H5Player.prototype.setStateKv = function (key, value, freezeKey) {
        this.dataset.writeState(key, value, freezeKey);
    };
    H5Player.prototype.setCommonKv = function (arg1, arg2, arg3) {
        var _this = this;
        if (typeof arg1 === 'string') {
            this.dataset.writeCommon(arg1, arg2, arg3);
        }
        else {
            Object.keys(arg1).forEach(function (i) { return _this.dataset.writeCommon(i, arg1[i], arg2); });
        }
    };
    H5Player.prototype.getStats = function () {
        return this.statsCollector.getStats();
    };
    Object.defineProperty(H5Player.prototype, "videoReqParam", {
        get: function () {
            var _a;
            return (_a = this.loadParam) === null || _a === void 0 ? void 0 : _a.videoReqInfoParam;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 是否应该隐藏鼠标，默认条件如下：
     *
     * 不需要判断 this.config.autoHideMouse 这个条件
     * 如果 autoHideMouse = false，连监听器都不会添加
     */
    H5Player.prototype.shouldHideMouse = function () {
        return this.fullscreenMode !== null
            && this.state === VIDEO_STATE.PLAYING;
    };
    /**
     * 选择getinfo模块，例如点播和直播分别使用不同的模块
     */
    H5Player.prototype.selectGetinfoModule = function (config) {
        return config === null || config === void 0 ? void 0 : config.getinfoModule;
    };
    H5Player.prototype.getParamWithStartTime = function (urlOrVid, param) {
        var _a;
        if (param === void 0) { param = {}; }
        var playtimeLimiter = this.playtimeLimiter;
        if (!urlOrVid)
            return param;
        // 如果用户传入了 startTime，则直接使用 startTime，以兼容老的逻辑
        if ((_a = param.videoLoadParam) === null || _a === void 0 ? void 0 : _a.startTime)
            return param;
        if (typeof urlOrVid === 'string' || typeof urlOrVid === 'number') {
            playtimeLimiter.clearAllConfig(urlOrVid);
        }
        else if (Array.isArray(urlOrVid)) {
            // 不支持数组调用时设置
            return param;
        }
        else {
            playtimeLimiter.clearAllConfig(urlOrVid.url);
        }
        if (param.playTimeLimit) {
            playtimeLimiter.addLimitConfig(param.playTimeLimit);
        }
        return __assign(__assign({}, param), { videoLoadParam: __assign(__assign({}, param.videoLoadParam), { startTime: this.timeRange.startTime }) });
    };
    H5Player.prototype.createClickMask = function () {
        var _this = this;
        var _a = this.config, _b = _a.enableInteractMod, enableInteractMod = _b === void 0 ? true : _b, type = _a.type;
        // 如果用户关闭蒙层，或者在直播模式下，则什么也不做
        if (!enableInteractMod || type === PLAY_MODE.LIVE)
            return;
        var mod = document.createElement('div');
        mod.classList.add('thumbplayer-user-mod');
        domTool.css(mod, { width: '100%', height: '100%', position: 'absolute', 'z-index': 1 });
        domTool.append(this.container, mod);
        mod.addEventListener('click', function () {
            // 暂停 / 播放被阻止后点击播放，开始播放
            if ([VIDEO_STATE.PAUSE, VIDEO_STATE.CANPLAY].includes(_this.state)) {
                _this.play();
            }
            else if ([VIDEO_STATE.PLAYING, VIDEO_STATE.BUFFERING].includes(_this.state)) {
                _this.pause(H5_PAUSE_TYPE.USER_CLICK);
            }
        });
        this.interactMod = mod;
    };
    /** 给容器设置一些基础样式，方便UI插件挂载 */
    H5Player.prototype.initContainerStyle = function () {
        var container = this.container;
        container.style.outline = '0 none';
        container.style.overflow = 'hidden';
        container.style.backgroundColor = '#000';
        if (getComputedStyle(container).position === 'static') {
            container.style.position = 'relative';
        }
    };
    /** 从插件转发二级事件 */
    H5Player.prototype.forwardPluginEvents = function () {
        var _this = this;
        this[DataSet.pluginName].on(DATA_EVENTS.STATE_UPDATE, function (_a) {
            var data = _a.data;
            _this.pluginMsg.emit(H5_EXT_EVENT.DATASET_STATE_UPDATE, data);
        });
        this[DataSet.pluginName].on(DATA_EVENTS.UPDATE, function (_a) {
            var data = _a.data;
            _this.pluginMsg.emit(H5_EXT_EVENT.DATASET_UPDATE, data);
        });
        this.on(PLAY_EVENT.SET_LOADING, function (_a) {
            var data = _a.data;
            _this.pluginMsg.emit(H5_EXT_EVENT.SET_LOADING, { value: data.show });
        });
    };
    // 初始化默认插件
    H5Player.prototype.createInnerPlugins = function () {
        var _a;
        this.createPlugin(DataSet.pluginName);
        if (OfflineLogPlugin.isEnvSupport
            && !((_a = this.config.offlineConfig) === null || _a === void 0 ? void 0 : _a.disable)
            && !this.config.isPrivateDeployment) {
            this.createPlugin(OfflineLogPlugin.pluginName);
        }
        this.createPlugin(PlaytimeLimiterPlugin.pluginName);
        if (this.config.enableQAreporter
            && !this.config.isPrivateDeployment) {
            this.createPlugin(this.config.type === PLAY_MODE.LIVE
                ? LiveQaReporterPlugin.pluginName : VodQaReporterPlugin.pluginName);
        }
    };
    H5Player.prototype.cacheLoadParam = function (urlOrVid, param) {
        if (!urlOrVid)
            return;
        if (isVideoId(urlOrVid)) {
            this.pluginMsg.emit(H5_EXT_EVENT.VID_CHANGE, { oldVal: this.vid, newVal: urlOrVid });
        }
        this.currentPlayItem = urlOrVid;
        if (param && Object.keys(param).length)
            this.loadParam = param;
    };
    H5Player.prototype.setupEventFlagData = function () {
        var _this = this;
        this.on(H5_PLAY_EVENT.AD_PLAYING, function () { return _this.isPlayingAd = true; });
        this.on(H5_PLAY_EVENT.AD_END, function () { return _this.isPlayingAd = false; });
    };
    H5Player.prototype.setupLoopPlay = function () {
        var _this = this;
        this.on(H5_PLAY_EVENT.PLAY_SESSION_END, function (_a) {
            var _b;
            var data = _a.data;
            var loopMode = (_b = _this.config.loopMode) !== null && _b !== void 0 ? _b : VideoLoopMode.replay;
            var endState = data.endState;
            var canReplay = endState === END_STATE.NORMAL;
            // 循环模式下视频播放结束时调用replay启动下一个播放流程
            if (_this.config.loop
                && canReplay
                && loopMode === VideoLoopMode.replay) {
                _this.replay();
            }
        });
        // 起播后设置video.loop，在url模式播放mp4时设置true，其他设置false
        // loop之后不会触发ended事件，和上面session end是互斥的
        this.on(H5_PLAY_EVENT.VIDEO_PLAYING, function (_a) {
            var data = _a.data;
            if (!data.isFirst || !_this.config.loop)
                return;
            var currentVideoElement = _this.currentVideoElement;
            if (currentVideoElement instanceof HTMLVideoElement) {
                // 优先外部配置
                var loopMode = _this.config.loopMode;
                // 原有逻辑，默认情况下仅允许在原生内核url模式下开启native loop
                if (isUrlConfig(_this.currentPlayItem)
                    && _this.corePlayer.kernelName === KERNEL_NAME.ORIGIN) {
                    loopMode = VideoLoopMode.native;
                }
                currentVideoElement.loop = loopMode === VideoLoopMode.native;
            }
        });
    };
    Object.defineProperty(H5Player.prototype, "playUrl", {
        /** play时传入的地址 */
        get: function () {
            var currentPlayItem = this.currentPlayItem;
            if (isVideoId(currentPlayItem))
                return;
            if (Array.isArray(currentPlayItem))
                return;
            return currentPlayItem === null || currentPlayItem === void 0 ? void 0 : currentPlayItem.url;
        },
        enumerable: false,
        configurable: true
    });
    H5Player.prototype.setupMouseAutoHide = function (isBind) {
        if (isBind === void 0) { isBind = true; }
        // 默认开启自动隐藏鼠标功能
        var _a = (this.config || {}).autoHideMouse, autoHideMouse = _a === void 0 ? true : _a;
        if (!autoHideMouse)
            return;
        var binder = getEventTargetBinder(this.container, isBind);
        binder('mousemove', this.mouseMoveHandler);
    };
    H5Player.prototype.initPlayerResizeObserver = function () {
        var _this = this;
        this.containerResizeObserver = new ResizeObserver(function () {
            var _a = _this.container, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
            // 这里不在事件抛出时节流，而是由监听方自行实现回调节流
            _this.emit(PLAY_EVENT.CONTAINER_RESIZE, { width: clientWidth, height: clientHeight });
        });
        this.containerResizeObserver.observe(this.container);
    };
    H5Player.prototype.setVideoStyle = function (style) {
        domTool.css(this.corePlayer.currentVideoElement, style);
    };
    H5Player.prototype.setAdVideoStyle = function (style) {
        var _a, _b, _c;
        var adVideos = (_c = (_b = getAdPlugin((_a = this.config) === null || _a === void 0 ? void 0 : _a.instanceId)) === null || _b === void 0 ? void 0 : _b.videoAdPlayer) === null || _c === void 0 ? void 0 : _c.videoElements;
        if (adVideos) {
            adVideos.forEach(function (v) { return domTool.css(v, style); });
        }
    };
    H5Player.prototype.applyStyleOnVideoNodeChange = function () {
        var _this = this;
        var getRotateStyle = function () {
            if (_this.pictureDirection === undefined && _this.rotateDegree === undefined)
                return;
            return rotateTransformValue[_this.pictureDirection] || "rotate(".concat(_this.rotateDegree, "deg)");
        };
        this.corePlayer.on(PLAY_EVENT.VIDEONODE_CHANGE, function () {
            var rotateStyle = getRotateStyle();
            if (rotateStyle) {
                _this.setVideoStyle({ transform: rotateStyle });
            }
        });
        this.on(H5_PLAY_EVENT.AD_REQ_ASSETS_START, function (_a) {
            var data = _a.data;
            if (!isPreOrPostAd(data))
                return;
            var rotateStyle = getRotateStyle();
            if (rotateStyle) {
                _this.setAdVideoStyle({ transform: rotateStyle });
            }
        });
        // 前后贴广告结束后删除旋转样式，避免影响暂停广告
        this.on(H5_PLAY_EVENT.AD_END, function (_a) {
            var data = _a.data;
            if (!isPreOrPostAd(data))
                return;
            var rotateStyle = getRotateStyle();
            if (rotateStyle) {
                _this.setAdVideoStyle({ transform: 'none' });
            }
        });
    };
    /**
     * 初始化仅提供给插件使用的api方法（播放器层面这些api不对引用方公开）。
     */
    H5Player.prototype.initPluginApis = function () {
        var _this = this;
        this.playerApiProxy.replayInCurFlowNode = function (vid, param) {
            var _a;
            _this.log("replayInCurFlowNode(), vid=".concat(vid, ", param="), param);
            return (_a = _this.flowManager.currentFlowNode) === null || _a === void 0 ? void 0 : _a.replay(vid, param);
        };
    };
    /**
     * 创建getinfo模块
     * @param config 播放器配置信息
     */
    H5Player.prototype.initGetinfoModule = function (config) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var GetinfoModule = this.selectGetinfoModule(config);
        if (!GetinfoModule) {
            return null;
        }
        var getinfoModule = createGetinfoModule(GetinfoModule, config, {
            getCommonKv: this.getCommonKv.bind(this),
            pluginMsg: this.pluginMsg,
        });
        return getinfoModule;
    };
    /** 注册播放内核 */
    H5Player.registerKernel = KernelFactory.registerKernel;
    H5Player.KernelFactory = KernelFactory;
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], H5Player.prototype, "load", null);
    __decorate([
        logMethodCall,
        performanceCost,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], H5Player.prototype, "play", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], H5Player.prototype, "replay", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], H5Player.prototype, "pause", null);
    __decorate([
        logMethodCall,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], H5Player.prototype, "seek", null);
    __decorate([
        destroyProtectDecorator,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, String]),
        __metadata("design:returntype", void 0)
    ], H5Player.prototype, "setCommonKv", null);
    return H5Player;
}(FlowPlayer));
var AUTO_HIDE_MOUSE_DELAY = 5 * 1000;
var HIDE_MOUSE_THROTTLE = 3 * 100;
H5Player.registerPlugin(DataSet.pluginName, DataSet);
H5Player.registerPlugin(PlaytimeLimiterPlugin.pluginName, PlaytimeLimiterPlugin);
H5Player.registerPlugin(OfflineLogPlugin.pluginName, OfflineLogPlugin);
H5Player.registerPlugin(VodQaReporterPlugin.pluginName, VodQaReporterPlugin);
H5Player.registerPlugin(LiveQaReporterPlugin.pluginName, LiveQaReporterPlugin);

function createH5Player(config) {
    return new H5Player(config);
}
var envVals = getEnvVals();

var ThumbPlayerH5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createH5Player: createH5Player,
  H5Player: H5Player,
  envVals: envVals,
  BaseReporter: BaseReporter,
  kernelEvtBus: kernelEvtBus,
  preloadEvtBus: preloadEvtBus,
  EvtEmitter: EvtEmitter,
  PLAY_EVENT: PLAY_EVENT,
  VIDEO_STATE: VIDEO_STATE,
  KERNEL_NAME: KERNEL_NAME,
  PLAY_MODE: PLAY_MODE,
  END_STATE: END_STATE,
  PRELOAD_TYPE: PRELOAD_TYPE,
  VIDEO_CODEC: VIDEO_CODEC,
  CONTAINER_FORMAT: CONTAINER_FORMAT,
  AUDIO_CODEC: AUDIO_CODEC,
  i18nConfig: i18nConfig,
  t: t,
  get ErrorCode () { return ErrorCode; },
  get ErrorMsg () { return ErrorMsg; },
  get FullScreenMode () { return FullScreenMode; },
  get STATS_NAME () { return STATS_NAME; },
  get StepKey () { return StepKey; },
  getAdPlugin: getAdPlugin,
  getAdReqParams: getAdReqParams,
  adEvents: adEvents,
  BaseFlowNode: BaseFlowNode,
  get FLOW_NODE_EVENT () { return FLOW_NODE_EVENT; },
  offlineLogLazyLoadStrategy: offlineLogLazyLoadStrategy,
  offlineLogEagerLoadStrategy: offlineLogEagerLoadStrategy,
  BeaconRequest: BeaconRequest,
  ImageRequest: report,
  definePlugins: definePlugins,
  autobind: autobind,
  logApiInvoke: logApiInvoke,
  once: once,
  tryEmit: tryEmit,
  getEnvVals: getEnvVals,
  get H5_EXT_EVENT () { return H5_EXT_EVENT; },
  get H5_PLAY_EVENT () { return H5_PLAY_EVENT; },
  Plugin: Plugin,
  isFunctionPlugin: isFunctionPlugin,
  createPluginFactory: createPluginFactory,
  getHookMethodName: getHookMethodName,
  registerPlugin: registerPlugin,
  deregisterPlugin: deregisterPlugin,
  getPlugin: getPlugin,
  getPlugins: getPlugins,
  pluginExists: pluginExists,
  AdPluginName: AdPluginName,
  get AD_TYPE () { return AD_TYPE; },
  isPreOrPostAd: isPreOrPostAd,
  isVideoId: isVideoId,
  DRM_TYPE: DRM_TYPE,
  DRM_VALUE: DRM_VALUE,
  OFFICIAL_PLUGIN: OFFICIAL_PLUGIN,
  PLUGIN_MAP: PLUGIN_MAP,
  get H5_PAUSE_TYPE () { return H5_PAUSE_TYPE; },
  get AUTO_PLAY_POLICY () { return AUTO_PLAY_POLICY; },
  get PictureDirection () { return PictureDirection; },
  get VideoLoopMode () { return VideoLoopMode; },
  get DATA_EVENTS () { return DATA_EVENTS; },
  get DATA_STATE () { return DATA_STATE; },
  get LOG_TYPE () { return LOG_TYPE; },
  get BUFFER_REASON () { return BUFFER_REASON; },
  get LOCAL_KEY () { return LOCAL_KEY; },
  get PersistedUserSettings () { return PersistedUserSettings; },
  DEFAULT_KEY: DEFAULT_KEY,
  COMMON_DATA_KEY: COMMON_DATA_KEY,
  stepTimerFakeGlobalInstanceId: stepTimerFakeGlobalInstanceId,
  StepTimer: StepTimer
});

// *************************************************************************
// 因为superplayer的npm包锁版本原因，以下两个导出名是为了兼容superplayer的旧版本
// *************************************************************************
var VideoReqInfoPluginName = '__thumbplayer-video-request';
// 只在 npm 下挂 window，用于 npm 播放器加载 cdn 插件时，插件获取 H5 模块
{
    // 挂载播放器所需要的全局变量
    mountGlobal({
        globalName: 'ThumbPlayerH5',
        target: ThumbPlayerH5,
        onDuplicate: function () {
            console.warn('Possible duplicated ThumbPlayerH5 detected. Avoid to import this package multiple times.');
        },
    });
}

export { AD_TYPE, AUTO_PLAY_POLICY, AdPluginName, BUFFER_REASON, BaseCheck, BaseFlowNode, BaseReporter, BeaconRequest, COMMON_DATA_KEY, CheckNormalError, DATA_EVENTS, DATA_STATE, DEFAULT_KEY, DRM_TYPE, DRM_VALUE, ErrorCode, ErrorMsg, FLOW_NODE_EVENT, FullScreenMode, H5Player, H5_EXT_EVENT, H5_PAUSE_TYPE, H5_PLAY_EVENT, report as ImageRequest, LOCAL_KEY, LOG_TYPE, OFFICIAL_PLUGIN, PLUGIN_MAP, PersistedUserSettings, PictureDirection, Plugin, STATS_NAME, StepKey, StepTimer, VideoLoopMode, VideoReqInfoPluginName, adEvents, autobind, createGetinfoModule, createH5Player, createPluginFactory, ThumbPlayerH5 as default, definePlugins, deregisterPlugin, destroyGetinfoModule, doGetinfo, envVals, getAdPlugin, getAdReqParams, getEnvVals, getGetinfoModule, getHookMethodName, getPlugin, getPlugins, hasGetinfoModule, isFunctionPlugin, isPreOrPostAd, isVideoId, logApiInvoke, offlineLogEagerLoadStrategy, offlineLogLazyLoadStrategy, once, pluginExists, registerPlugin, stepTimerFakeGlobalInstanceId, tryEmit };
